webpackJsonp([3],Array(20).concat([
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* unused harmony export auth */
/* unused harmony export authWorkers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(50);





// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDuXbUlrIbKPVOgOYPzMLZ_ciVzVovk4DI",
//   authDomain: "greenhousecakes.firebaseapp.com",
//   projectId: "greenhousecakes",
//   storageBucket: "greenhousecakes.appspot.com",
//   messagingSenderId: "705670123148",
//   appId: "1:705670123148:web:cf8c2bcf27f40cccccb5a9",
//   measurementId: "G-YH3Z1X25KE"
// };
var firebaseConfig = {
  apiKey: "AIzaSyBx4fFaqt28W4jwSEP8xiGCadpEUORV6nU",
  authDomain: "ghc-crm.firebaseapp.com",
  projectId: "ghc-crm",
  storageBucket: "ghc-crm.appspot.com",
  messagingSenderId: "359440603882",
  appId: "1:359440603882:web:a6b831423b39f5f8ef9593",
  measurementId: "G-K091GW7E1Z"
};

// Initialize Firebase
__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].initializeApp(firebaseConfig);
var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore();
var storage = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].storage();
// Initialize Firebase Authentication and get a reference to the service
var auth = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth();
var authWorkers = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth();

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64035344_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64035344_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCard_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a8a2cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCard_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a8a2cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BottomNavbar_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topHeader_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_messaging__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_router__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UpdateModal_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AddChequeModal_vue__ = __webpack_require__(549);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__components_Navbar__["a" /* default */],
    topHeader: __WEBPACK_IMPORTED_MODULE_1__components_topHeader_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_modal__["a" /* default */],
    RouterLink: __WEBPACK_IMPORTED_MODULE_11_vue_router__["a" /* RouterLink */],
    UpdateModal: __WEBPACK_IMPORTED_MODULE_12__components_UpdateModal_vue__["a" /* default */],
    BottomNavbar: __WEBPACK_IMPORTED_MODULE_0__components_BottomNavbar_vue__["a" /* default */],
    AddChequeModal: __WEBPACK_IMPORTED_MODULE_13__components_AddChequeModal_vue__["a" /* default */]

  },
  data: function data() {
    return {
      siteLogo: 'Green House Cakes',
      dropOpen: false,
      addNew: false,
      modalToggle: false,
      newCategoryModal: false,
      secretModal: false,
      modalId: "",
      selectDealerName: "",
      type: '',
      Dealers: [],
      //   cheque:{
      //     dealerName:'',
      //     amount:null,
      //     formattedDate: "",
      //     createdDate: moment().format('LLLL'),
      //     checked: false,
      //   },
      cheque: {

        dealerName: '',
        amount: null,
        formattedDate: '',
        notes: '',
        createdDate: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('LLLL'),
        checked: false
      },
      secret: {
        name: '',
        note: '',
        createdDate: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('LLLL')
      },
      chequeModal: false,
      errorDealer: false,
      errorAddingDealer: "",
      isOpen: false,
      showUpdateModal: false,
      darkMode: false
    };
  },
  created: function created() {
    var vm = this;
    document.addEventListener('click', this.dropdown);
    document.addEventListener('click', this.addNewDropDown);
    vm.loadDealers();
    vm.setupVersionListener();

    var savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      this.darkMode = savedTheme === "dark";
      document.documentElement.setAttribute("data-theme", savedTheme);
    } else {
      // اعتمادًا على إعداد الجهاز
      var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.darkMode = prefersDark;
      document.documentElement.setAttribute("data-theme", prefersDark ? "dark" : "light");
    }
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.dropdown);
    document.removeEventListener('click', this.addNewDropDown);
  },

  methods: {
    showNavbar: function showNavbar() {

      return !['/login', '/register'].includes(this.$route.path);
    },
    askForNotificationPermission: function askForNotificationPermission() {
      if (!__WEBPACK_IMPORTED_MODULE_8_firebase_app__["a" /* default */].messaging.isSupported()) {
        alert("🚫 المتصفح لا يدعم الإشعارات");
        return;
      }

      var messaging = __WEBPACK_IMPORTED_MODULE_8_firebase_app__["a" /* default */].messaging();

      Notification.requestPermission().then(function (permission) {
        alert("📣 النتيجة: " + permission);

        if (permission === "granted") {
          return messaging.getToken({
            vapidKey: "🔑 vapidKey تاعك من Firebase"
          });
        } else {
          alert("🛑 تم رفض الإشعارات من قبل المتصفح");
        }
      }).then(function (token) {
        if (token) {
          alert("✅ تم الحصول على التوكن: " + token);
          var user = JSON.parse(localStorage.getItem("User"));
          __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection("deviceTokens").doc(token).set({
            createdAt: new Date(),
            userID: user && user.userID || null,
            platform: "iOS Safari"
          });
        }
      }).catch(function (err) {
        console.error("❌ Error:", err);
        alert("⚠️ خطأ أثناء الحصول على التوكن");
      });
    },
    setupVersionListener: function setupVersionListener() {
      var _this = this;

      // تأكد من استيراد firebase وتهيئته في مشروعك
      __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection("appUpdates").doc("version").onSnapshot(function (doc) {
        if (!doc.exists) return;
        var serverVersion = doc.data().version;
        var localVersion = localStorage.getItem("appVersion") || "1.0.0";

        if (serverVersion !== localVersion) {
          localStorage.setItem("appVersion", serverVersion);
          _this.showUpdateModal = true;
        }
      });
    },
    toCheques: function toCheques() {
      var vm = this;
      if (vm.$root.loggedUser.Type == 'Admin') {
        vm.$router.push("/Cheques");
      } else {
        // vm.$router.go(-0);
        alert("אין לך גישה לדף הזו");
      }
    },
    toCheckout: function toCheckout() {
      var vm = this;
      vm.$router.push("/newOrderBeta");
    },
    openMenu: function openMenu() {
      var vm = this;
      vm.isOpen = true;
    },
    closeMenu: function closeMenu() {
      var vm = this;
      vm.isOpen = false;
    },
    photoaid: function photoaid() {
      var vm = this;
      window.open("https://photoaid.com/en/tools/cropround?srsltid=AfmBOopOurCsBhhttlxL74t4uB71pQPWc7CqQRGhaEJU3co75mS-8jlI");
    },
    shutterstock: function shutterstock() {
      var vm = this;
      window.open("https://www.shutterstock.com/create/editor");
    },
    nayax: function nayax() {
      var vm = this;
      window.open("https://webui-srv.bnayax.com/");
    },
    leumi: function leumi() {
      var vm = this;
      window.open("https://www.leumi.co.il/he");
    },
    uploadImage: function uploadImage(e) {
      var _this2 = this;

      if (e.target.files[0]) {
        var file = e.target.files[0];
        var storageRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app__["a" /* default */].storage().ref('expenses/' + file.name);
        var uploadTask = storageRef.put(file);
        uploadTask.on('state_changed', function (snapshot) {}, function (error) {
          // Handle unsuccessful uploads
        }, function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            _this2.expense.image.push(downloadURL);
            // let media = { 
            //     date: new Date().toLocaleDateString(),
            //     image: '',
            //     fullname: this.fullname,
            //     orderNumber : this.counter.orderNumber
            // }
            // media.image = downloadURL;
            // console.log(media);
            // db.collection("Media").add(media);
            console.log('File available at', downloadURL);
          });
        });
      }
    },
    addDealer: function addDealer() {
      var vm = this;
      console.log("Add ( DealerResult ) ");
      if (vm.selectDealerName.length > 0) {
        var DealerMeheron = {
          selectDealerName: vm.selectDealerName,
          type: vm.type,
          createdDate: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('LLLL')
        };

        __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection("Dealers").add(DealerMeheron).then(function (DealerResult) {
          console.log("Add ( DealerResult ) Success");
          console.log(DealerResult);
          vm.selectDealerName = "";
        }).catch(function (error) {
          console.error('add( DealerResult ) Error !');
          console.error(error);
        });
      } else if (vm.selectDealerName.length <= 0) {
        vm.errorDealer = true;
        vm.errorAddingDealer = "נא למלא את השדה";
      }
    },
    loadDealers: function loadDealers() {
      var vm = this;
      vm.Dealers = [];
      __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection("Dealers").orderBy("createdDate", "desc").get().then(function (DealerMeheron) {
        for (var a = 0; a < DealerMeheron.size; a++) {
          var dealerId = DealerMeheron.docs[a].id;
          var dealer = DealerMeheron.docs[a].data();
          //   console.log(DealerMeheron.size);
          vm.Dealers.push({ ID: dealerId, Data: dealer });
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    addCheque: function addCheque(cheque) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection('cheques').add(cheque).then(function () {
        if (_this3.$root && typeof _this3.$root.loadChequesSum === 'function') {
          _this3.$root.loadChequesSum();
        }
        _this3.chequeModal = false;
      }).catch(function (error) {
        console.error('Error adding cheque:', error);
        alert('לא ניתן לשמור את השיק. נסה שוב.');
      });
    },
    addExpense: function addExpense() {
      var vm = this;
      console.log("Add ( addExpense ) ");
      if (vm.secret.name.length > 0) {
        var secret = {
          name: vm.secret.name,
          note: vm.secret.note,
          createdDate: __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('LLLL')
        };
        __WEBPACK_IMPORTED_MODULE_7__src_firebase__["a" /* db */].collection("Secrets").add(secret).then(function (secretResult) {
          console.log("Add ( secretResult ) Success");
          console.log(secretResult);
          vm.secret.name = "";
          vm.secret.note = "";
        }).catch(function (error) {
          console.error('add( secretResult ) Error !');
          console.error(error);
        });
        //   vm.$root.loadChequesSum();
      } else if (vm.secret.name.length <= 0) {
        vm.errorDealer = true;
        vm.errorAddingDealer = "נא למלא את השדה";
      }
    },
    toggleOpen: function toggleOpen() {
      if (!this.dropOpen) {
        this.dropOpen = true;
        this.addNew = false;
      } else {
        this.dropOpen = false;
      }
    },
    addNewOpen: function addNewOpen() {
      if (!this.addNew) {
        this.addNew = true;
        this.dropOpen = false;
      } else {
        this.addNew = false;
      }
    },
    dropdown: function dropdown(e) {
      var el = this.$refs.dropdown;
      if (!el) return; // ما في ref، ما تعمل اشي
      if (el !== e.target && !el.contains(e.target)) {
        this.dropOpen = false;
      }
    },
    addNewDropDown: function addNewDropDown(e) {
      var el = this.$refs.addNewDropDown;
      if (!el) return;
      if (el !== e.target && !el.contains(e.target)) {
        this.addNew = false;
      }
    },
    logout: function logout() {
      console.log("Logout Click From App.vue");
      var vm = this;
      vm.$root.loggedUser = null;
      localStorage.removeItem("User");
      document.removeEventListener('click', vm.dropdown);
      document.removeEventListener('click', vm.addNewDropDown);
      vm.dropOpen = false;
      vm.addNew = false;
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    openModal: function openModal() {
      var vm = this;
      if (!vm.modalToggle) {
        vm.modalToggle = true;
      } else {
        vm.modalToggle = false;
      }
    },
    openChequeModal: function openChequeModal() {

      this.chequeModal = true;
    },
    closeChequeModal: function closeChequeModal() {

      this.chequeModal = false;
    },
    closeModal: function closeModal() {
      this.modalToggle = false;
      this.errorDealer = false;
      this.errorAddingDealer = "";
      this.selectDealerName = "";
      this.type = "";
    },
    openExpenseModal: function openExpenseModal() {
      var vm = this;
      if (!vm.secretModal) {
        vm.secretModal = true;
      } else {
        vm.secretModal = false;
      }
    },
    closeExpenseModal: function closeExpenseModal() {
      var vm = this;
      if (vm.secretModal) {
        vm.secretModal = false;
      } else {
        vm.secretModal = true;
      }
    },
    toggleTheme: function toggleTheme() {
      this.darkMode = !this.darkMode;
      var theme = this.darkMode ? "dark" : "light";
      document.documentElement.setAttribute("data-theme", theme);
      localStorage.setItem("theme", theme);
    },
    handleOpenModal: function handleOpenModal(type) {
      // سكّر كل اشي قبل ما تفتح واحد
      this.modalToggle = false;
      this.secretModal = false;
      this.chequeModal = false;
      this.newCategoryModal = false;

      if (type === 'supplier') this.modalToggle = true;
      if (type === 'recipe') this.secretModal = true;
      if (type === 'cheque') this.chequeModal = true;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'BottomNavbar',

    methods: {
        goTo: function goTo(route) {

            if (this.$route.path !== route) {
                this.$router.push(route);
            }
        },
        isActive: function isActive(route) {
            return this.$route.path === route;
        }
    }

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: false,
      extActive: false,
      addNew: false,
      pageName: null,
      userMenuOpen: false,
      quickLinks: [],
      mobileMenuOpen: false

    };
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('click', this.onClickOutside);
    document.addEventListener("click", this.closeMenus);

    var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore();
    db.collection("AdminQuickLinks").doc("externalLinks").get().then(function (doc) {
      if (doc.exists) {
        _this.quickLinks = doc.data().buttons || [];
      }
    }).catch(function (err) {
      console.error("Error fetching quick links:", err);
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
    document.removeEventListener("click", this.closeMenus);
  },

  methods: {
    navigateAndClose: function navigateAndClose(route) {
      this.mobileMenuOpen = false;
      this.$router.push(route);
    },
    emitOpen: function emitOpen(type) {
      // ببعث للـApp
      this.$emit('open-modal', type);
      // (اختياري) سكّر الدروب داون بعد الضغط
      this.addNew = false;
    },
    onClickOutside: function onClickOutside(e) {
      // إذا الضغط مش داخل عنصر .admin-btn -> سكّر القائمة
      var btn = this.$el.querySelector('.admin-btn');
      if (btn && !btn.contains(e.target)) this.isActive = false;
    },
    toggle: function toggle() {

      if (!this.isActive) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    logout: function logout() {
      // console.log("Logout Click");
      var vm = this;
      localStorage.removeItem("User");
      vm.$root.loggedUser = null;
      vm.$router.replace("/");
    },
    goToSettings: function goToSettings() {
      this.userMenuOpen = false;
      this.$router.push('/settings');
    },
    addNewOpen: function addNewOpen() {
      if (!this.addNew) {
        this.addNew = true;
        this.dropOpen = false;
      } else {
        this.addNew = false;
      }
    },
    changeRoute: function changeRoute(pageName) {
      if (pageName != this.$route.path) {
        this.$router.push(pageName);
      }
      this.isActive = false;
    },
    closeMenus: function closeMenus(e) {
      // إغلاق القوائم إذا كبس براهم
      if (!this.$el.querySelector(".user-dropdown").contains(e.target)) {
        this.userMenuOpen = false;
      }
      if (!this.$el.querySelector(".addNewBtn").contains(e.target)) {
        this.addNew = false;
      }
    },
    handleQuickAction: function handleQuickAction(btn) {
      this.isActive = false;

      if (btn.action.startsWith("/")) {
        // رابط داخلي
        this.$router.push(btn.action);
      } else {
        // رابط خارجي
        var url = btn.action;
        if (!/^https?:\/\//i.test(url)) {
          url = "https://" + url;
        }
        window.open(url, "_blank");
      }
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(531);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  props: ["modalToggle"],
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      services: [{
        title: 'הגדרות החשבון',
        link: '#'

      }]
    };
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropdown',
  props: ['title', 'items'],
  data: function data() {
    return {
      isOpen: false
    };
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  data: function data() {
    return {
      modalToggle: false
    };
  },

  methods: {
    closeModal: function closeModal() {
      var vm = this;
      if (vm.modalToggle) {
        vm.modalToggle = false;
      } else {
        vm.modalToggle = true;
      }
    }
  }
});

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UpdateModal",
  props: {
    // إذا كنت تمرر visible كـ prop، يمكنك استخدامه هنا؛ 
    // لكن بما أنك تستخدم v-if من المكون الأب فلا تحتاج لخاصية visible داخل الـ modal.
    // إذا أردت استخدام prop، تأكد من تمريره من المكون الأب.
  },
  methods: {
    reloadNow: function reloadNow() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log("Modal mounted – it should be visible now.");
    setTimeout(function () {
      _this.reloadNow();
    }, 3000);
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_messaging__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    props: {

        chequeModal: {
            type: Boolean,
            default: false
        },

        Dealers: {
            type: Array,
            default: function _default() {
                return [];
            }
        }

    },

    data: function data() {

        return {

            errorDealer: false,

            errorAddingDealer: '',

            localCheque: {
                dealerName: '',
                amount: null,
                formattedDate: '',
                notes: '',
                bank: 'לאומי'
            }

        };
    },


    methods: {
        closeModal: function closeModal() {

            this.resetForm();

            this.$emit('close');
        },
        resetForm: function resetForm() {

            this.localCheque = {
                dealerName: '',
                amount: null,
                formattedDate: '',
                notes: '',
                bank: 'לאומי'
            };

            this.errorDealer = false;
            this.errorAddingDealer = '';
        },
        addCheque: function addCheque() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var vm, dateObject, timestamp, cheque;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = _this;


                                vm.errorDealer = false;
                                vm.errorAddingDealer = '';

                                if (!(vm.localCheque.dealerName.length <= 0 || !vm.localCheque.amount || vm.localCheque.formattedDate.length <= 0)) {
                                    _context.next = 7;
                                    break;
                                }

                                vm.errorDealer = true;

                                vm.errorAddingDealer = "נא למלא את כל השדות";

                                return _context.abrupt("return");

                            case 7:
                                dateObject = __WEBPACK_IMPORTED_MODULE_5_moment___default()(vm.localCheque.formattedDate, "YYYY-MM-DD", true);
                                timestamp = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(dateObject.toDate());
                                cheque = {

                                    dealerName: vm.localCheque.dealerName,

                                    bank: vm.localCheque.bank || '',
                                    amount: vm.localCheque.amount,

                                    date: timestamp,

                                    formattedDate: vm.localCheque.formattedDate,

                                    notes: vm.localCheque.notes || '',

                                    createdDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('LLLL'),

                                    checked: false

                                    // 🔥 ابعت البيانات للـ App.vue
                                };
                                _this.$emit('save', cheque);

                                _this.closeModal();

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }

});

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_orderCard_vue__ = __webpack_require__(88);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Orders',
  components: {
    order: __WEBPACK_IMPORTED_MODULE_9__components_Order_vue__["a" /* default */], orderCard: __WEBPACK_IMPORTED_MODULE_10__components_orderCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      orders: [],
      txtSearch: '',
      toDate: '',
      fromDate: '',
      totalOrders: 0,
      deletedOrders: 0,
      acceptedOrders: 0,
      fromToday: 0,
      yesterdayItemNav: false,
      todayItemNav: false,
      tommorowItemNav: false,
      isLoading: true,
      salesReport: {}, // تخزين إجمالي المنتجات المباعة هنا 
      showModal: false, // يتحكم في عرض المودال
      selectedDate: new Date().toISOString().split("T")[0] // افتراضيًا اليوم الحالي


    };
  },

  watch: {
    selectedDate: function selectedDate(newDate) {
      console.log("📅 تم تغيير التاريخ إلى:", newDate);
      this.fetchSalesReport();
    }
  },

  created: function created() {
    var m = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
    m.locale('he');
    console.log(m.format('LLLL'));
    var vm = this;
    vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format("YYYY-MM-DD");
    vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(10, 'days').format("YYYY-MM-DD");
    vm.todayItemNav = true;
    vm.loadOrdersRealTime();
    if (vm.totalOrders == 0) {
      vm.totalOrders = 0;
    }
  },

  computed: {
    filteredOrders: function filteredOrders() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var orders = [];
        for (var i = 0; i < vm.orders.length; i++) {
          var t = vm.orders[i];
          var found = false;
          if (t.Data.fullname.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            found = true;
          }
          if (t.Data.phoneNumber.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            found = true;
          }
          // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
          //   found = true;
          // }
          if (found) {
            orders.push(t);
          }
        }
        return orders;
      } else {
        return vm.orders;
      }
    }
  },
  mounted: function mounted() {
    this.fetchSalesReport(); // تحديث التقرير عند تحميل الصفحة بناءً على التاريخ الافتراضي
  },

  methods: {
    fetchSalesReport: function fetchSalesReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ordersRef, snapshot, salesData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("🚀 جلب البيانات لتاريخ:", _this.selectedDate);

                if (_this.selectedDate) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                ordersRef = __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore().collection("orders");
                _context.prev = 4;
                _context.next = 7;
                return ordersRef.where("dateOrder", "==", _this.selectedDate).get();

              case 7:
                snapshot = _context.sent;

                if (!snapshot.empty) {
                  _context.next = 12;
                  break;
                }

                console.warn("⚠️ لا توجد طلبات لهذا اليوم.");
                _this.salesReport = {};
                return _context.abrupt('return');

              case 12:
                salesData = {};


                snapshot.forEach(function (doc) {
                  var order = doc.data();
                  if (!order.cart || !Array.isArray(order.cart)) return;

                  order.cart.forEach(function (product) {
                    var productName = product.Data && product.Data.Name ? product.Data.Name : "منتج غير معروف";
                    var quantity = product.selectedCount ? Number(product.selectedCount) : 0;

                    if (!salesData[productName]) {
                      salesData[productName] = 0;
                    }
                    salesData[productName] += quantity;
                  });
                });

                _this.salesReport = salesData;
                console.log("✅ البيانات المحدثة:", _this.salesReport);

                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](4);

                console.error("❌ حدث خطأ أثناء جلب البيانات:", _context.t0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 18]]);
      }))();
    },
    todayOrders: function todayOrders() {
      var vm = this;
      vm.todayItemNav = true;
      vm.tommorowItemNav = false;
      vm.yesterdayItemNav = false;

      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    tommorowOrders: function tommorowOrders() {
      var vm = this;
      vm.tommorowItemNav = true;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(1, 'days').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(1, 'days').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    thisMonth: function thisMonth() {
      var vm = this;
      vm.tommorowItemNav = false;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf('month').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().endOf('month').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    lastMonth: function lastMonth() {
      var vm = this;
      vm.tommorowItemNav = false;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract("1", "months").startOf('month').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract("1", "months").endOf('month').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    yesterdayOrders: function yesterdayOrders() {
      var vm = this;
      vm.yesterdayItemNav = true;
      vm.todayItemNav = false;
      vm.tommorowItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    loadOrders: function loadOrders() {
      var vm = this;
      vm.orders = [];
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.deletedOrders = 0;
      //  .orderBy("orderNumber","desc")
      // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
      __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).orderBy("dateOrder", "asc").get().then(function (orderResult) {
        for (var a = 0; a < orderResult.size; a++) {
          var orderId = orderResult.docs[a].id;
          var _order = orderResult.docs[a].data();
          // console.log(orderResult.size);
          vm.orders.push({ ID: orderId, Data: _order });
          vm.totalOrders = orderResult.size;

          if (_order.status == 'נמחקה') {
            vm.deletedOrders++;
          }
        }

        if (vm.deletedOrders == 0) {
          vm.acceptedOrders = vm.totalOrders;
        }
        // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
        // .then(function(deletedResult){
        //   for(let a = 0; a < deletedResult.size; a++){
        //     // console.log(vm.deletedOrders);
        //     // console.log(deletedResult.docs[a].id);
        //     vm.deletedOrders = deletedResult.size;
        //   } 
        //   if(vm.totalOrders - vm.deletedOrders <= 0){
        //     vm.acceptedOrders = vm.totalOrders;
        //   }
        //   if( vm.deletedOrders == 0){
        //       // vm.deletedOrders = 0;
        //       vm.acceptedOrders = vm.totalOrders;

        //     }
        //     else {
        //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
        //     }
        // }).catch(function(error){
        //     console.error("Error getting document:", error);
        //     });
      }).catch(function (error) {
        console.error("Error getting document:", error);
      });
    },

    // loadOrdersRealTime(){
    //     let vm = this;
    //     vm.fromToday = 0;
    //     vm.totalOrders = 0 ;
    //     vm.deletedOrders = 0;
    //     vm.acceptedOrders = 0;

    //     //  .orderBy("orderNumber","desc")
    //     // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
    //     db.collection("orders").where('dateOrder', '>=', vm.fromDate)
    //     .where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").orderBy("timeOrder","asc").onSnapshot((orderResult) => {
    //       vm.isLoading = false;
    //       vm.orders = [];
    //       vm.totalOrders = orderResult.size;
    //         orderResult.forEach((doc) => {
    //                 let orderId = doc.id;
    //                 let order = doc.data();
    //                 // vm.totalOrders = doc.size;
    //                 vm.orders.push({ ID: orderId, Data: order });   
    //                 if(order.Date == order.dateOrder){
    //                 vm.fromToday++;
    //                 }
    //                 if(order.status == 'נמחקה'){
    //                   vm.deletedOrders++;
    //                 }
    //                 if( vm.deletedOrders == 0){
    //                   vm.acceptedOrders = vm.totalOrders;
    //                 }


    //               });

    //         // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
    //         // .then(function(deletedResult){
    //         //   for(let a = 0; a < deletedResult.size; a++){
    //         //     // console.log(vm.deletedOrders);
    //         //     // console.log(deletedResult.docs[a].id);
    //         //     vm.deletedOrders = deletedResult.size;
    //         // } 

    //         // if(vm.totalOrders - vm.deletedOrders <= 0){
    //         //   vm.acceptedOrders = vm.totalOrders;
    //         //     }
    //         //     if( vm.deletedOrders == 0){
    //         //       // vm.deletedOrders = 0;
    //         //       vm.acceptedOrders = vm.totalOrders;

    //         //     }
    //         //     else {
    //         //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
    //         //     }
    //         //     // console.log('deleted Orders :',vm.deletedOrders);
    //         //     // console.log('accepted Orders :',vm.acceptedOrders);

    //         //  })
    //         //  .catch(function(error){
    //         //     console.error("Error getting document:", error);
    //         //     });


    //           })
    //         },
    loadOrdersRealTime: function loadOrdersRealTime() {
      var vm = this;
      vm.fromToday = 0;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.orders = [];
      vm.isLoading = true;

      var ordersRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection("orders");

      // استعلام الطلبات حسب dateOrder
      var query1 = ordersRef.where("dateOrder", ">=", vm.fromDate).where("dateOrder", "<=", vm.toDate);

      // استعلام الطلبات حسب dayOrder
      var query2 = ordersRef.where("dayOrder", ">=", vm.fromDate).where("dayOrder", "<=", vm.toDate);

      // نفّذ الاستعلامين
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([query1.get(), query2.get()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            snapshot1 = _ref2[0],
            snapshot2 = _ref2[1];

        var allDocs = [];

        snapshot1.forEach(function (doc) {
          allDocs.push({ ID: doc.id, Data: doc.data() });
        });

        snapshot2.forEach(function (doc) {
          // تأكد ما تكرّر الطلب إذا موجود بالاستعلام الأول
          if (!allDocs.find(function (o) {
            return o.ID === doc.id;
          })) {
            allDocs.push({ ID: doc.id, Data: doc.data() });
          }
        });

        vm.totalOrders = allDocs.length;

        allDocs.sort(function (a, b) {
          var dateA = a.Data.selectedDateReadable || a.Data.dayOrder || a.Data.dateOrder || '';
          var dateB = b.Data.selectedDateReadable || b.Data.dayOrder || b.Data.dateOrder || '';

          var timeA = a.Data.timeOrder ? a.Data.timeOrder.padStart(5, '0') : '00:00';
          var timeB = b.Data.timeOrder ? b.Data.timeOrder.padStart(5, '0') : '00:00';

          var datetimeA = dateA + ' ' + timeA;
          var datetimeB = dateB + ' ' + timeB;

          return datetimeA.localeCompare(datetimeB);
        });

        vm.orders = allDocs;

        allDocs.forEach(function (order) {
          var orderDate = order.Data.selectedDateReadable || order.Data.dayOrder || order.Data.dateOrder;

          if (orderDate === vm.fromDate) vm.fromToday++;

          if (order.Data.status === "נמחקה") vm.deletedOrders++;
        });

        if (vm.deletedOrders === 0) {
          vm.acceptedOrders = vm.totalOrders;
        } else {
          vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
        }

        vm.isLoading = false;
      }).catch(function (error) {
        console.error("❌ خطأ في تحميل الطلبات:", error);
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Order',
  props: ['order', 'rowIndex'],
  data: function data() {
    return {};
  },


  methods: {
    openOrder: function openOrder() {
      var vm = this;
      console.log("openOrder(" + vm.order.Data.fullname + ")..");
      vm.$root.selectedOrderObj = vm.order;
      vm.$root.selectedOrderIndex = vm.rowIndex;
      vm.$router.push("/SelectedOrderBeta/");
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(58);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'orderCard',
    props: ['order', 'rowIndex', 'orders'],
    data: function data() {
        return {
            activeStatusDropdown: null
        };
    },
    created: function created() {
        //console.log(this.rowIndex);
        // console.log(this.order);

        // console.log('created() Total images: ' + this.order.Data.orderImg.length) ;
    },
    updated: function updated() {
        // console.log('updated() Total images: ' + this.order.Data.orderImg.length) ;
    },

    methods: {
        //     printImage(imageUrl) {
        //     if (!imageUrl) {
        //       alert("⚠️ لم يتم العثور على الصورة!");
        //       return;
        //     }

        //     const printWindow = window.open("", "_blank");
        //     printWindow.document.write(`
        //       <html>
        //         <head>
        //           <title>طباعة الصورة</title>
        //           <style>
        //             @media print {
        //               @page {
        //                 size: auto;
        //                 margin: 0;
        //               }
        //               body { text-align: center; margin: 0; padding: 20px; }
        //               img { max-width: 100%; height: auto; }
        //             }
        //           </style>
        //         </head>
        //         <body>
        //           <img src="${imageUrl}" onload="window.print();">
        //         </body>
        //       </html>
        //     `);
        //     printWindow.document.close();
        //   },
        toggleStatusDropdown: function toggleStatusDropdown(orderId) {
            this.activeStatusDropdown = this.activeStatusDropdown === orderId ? null : orderId;
        },
        updateOrderStatus: function updateOrderStatus(orderId, newStatus) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore().collection("orders").doc(orderId).update({
                                    status: newStatus
                                });

                            case 3:

                                _this.activeStatusDropdown = null;

                                _context.next = 10;
                                break;

                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context['catch'](0);

                                console.error("خطأ أثناء تحديث الحالة:", _context.t0);
                                alert("حدث خطأ أثناء تحديث الحالة.");

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 6]]);
            }))();
        },
        openOrder: function openOrder() {
            var vm = this;
            console.log("openOrder(" + vm.order.Data.fullname + ")..");
            vm.$root.selectedOrderObj = vm.order;
            vm.$root.selectedOrderObjID = vm.order.ID;
            vm.$root.selectedOrderIndex = vm.rowIndex;
            vm.$router.push("/SelectedOrderBeta/" + vm.order.ID);
        },
        updateStatus: function updateStatus() {
            var vm = this;
            var newStatus = vm.order.Data.status;
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").doc(vm.order.ID).get().then(function (order) {
                var orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").doc(vm.order.ID).update(orderData);
                console.log("New Status is :" + newStatus);
                alert("סטטוס ההזמנה עודכן בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        printElement: function printElement() {
            var element = this.$refs.myElement;
            var printWindow = window.open('', '', 'height=500, width=400');
            var styles = '\n            <style>\n                @media print {\n                @page{\n                    size: 80mm;\n                    margin:0;\n                }\n                    body,html {\n                        margin :0;\n                        padding: 0;\n                        font-size:13px;\n                        text-align : right;\n                    }\n                    .images{\n                        display: none;\n\n                    }\n                \n                }\n            </style>\n            ';
            // const styles = Array.from(document.styleSheets)
            // .map(styleSheet => {
            //     try{
            //         return Array.from(styleSheet.cssRules)
            //         .map(rule => rule.cssText)
            //         .join(' ');
            //     } catch(e) {
            //         return '';
            //     }
            // })
            // .join(' ');

            printWindow.document.write('<html><head><title>Order</title>');

            // printWindow.document.write(`<style>${styles} </style>`);
            printWindow.document.write(styles);
            printWindow.document.write('</head><body>');
            printWindow.document.write(element.outerHTML);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.onafterprint = function () {
                printWindow.close();
            };
            printWindow.onbeforeunload = function () {
                printWindow.close();
            };

            printWindow.print();

            // setTimeout(() =>{

            // })
        },
        printReceipt: function printReceipt() {
            var content = this.$refs.receiptContent.innerHTML; // استخدم innerText بدلًا من innerHTML للطباعة كنص خام

            // إنشاء نافذة جديدة للطباعة
            var printWindow = window.open('', '', 'height=800,width=400');
            // كتابة المحتوى باستخدام CSS لتحديد الاتجاه من اليمين إلى اليسار
            printWindow.document.write('\n                        <html><head><title>\u0637\u0628\u0627\u0639\u0629 \u0627\u0644\u0625\u064A\u0635\u0627\u0644</title>\n                        <style>\n                        @import url(\'https://fonts.googleapis.com/css2?family=Heebo:wght@100;300;400;500;600;700;800;900&display=swap\');\n                        @import url(\'https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap\');\n                        @import url(\'https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@300;400;500;600;700;800;900&display=swap\');\n\n                        body {\n                            direction: rtl;\n                            text-align: right;\n                            font-size: 15px;\n                            max-width: 80mm;\n                            padding:0.5rem;\n                            font-family: Heebo , Noto Sans Arabic;\n                        }\n                        .head .status{\n                            display:none;\n                            \n                        }\n                        .head .name ,.head .day ,.head .time ,.head .date,.item .itemName {\n                            font-size:17px;\n                             line-height: 2;\n                             font-weight: 400;\n                             padding: 5px ;\n                            \n                        }\n                             .head .name {\n                             margin: 0;\n                             padding:0;\n                                font-weight:700;\n                                display: block;\n                                text-align:center;\n                             }\n                          .item .subTotal,\n                        .images {\n                            display:none;\n                        }\n                            .col3 .totalAmount {\n                            font-size: 17px;\n                            text-align: center;\n                            border-bottom: 1px solid #e0e0e0;\n                            position: relative;\n                            padding:10px;\n\n                            }\n\n                        </style>\n                        </head><body><div>' + content + '</div></body></html>\n                    ');

            // كتابة المحتوى بدون HTML معقد
            printWindow.document.close();

            // طباعة المحتوى مباشرة
            printWindow.print();

            // إغلاق النافذة بعد الطباعة
            printWindow.onafterprint = function () {
                printWindow.close();
            };
            // ضبط مؤقت لإغلاق النافذة إذا لم يتم إغلاقها

            printWindow.onbeforeunload = function () {
                printWindow.close();
            };
        }

        // shareLink(){
        //     let vm = this;
        //     console.log("greenhousecakes.web.app/SelectedOrderBeta/"+ vm.order.ID);
        //     window.open("https://api.whatsapp.com/send?"+ '&text=https://greenhousecakes.web.app/SelectedOrderBeta/'+ vm.order.ID);
        // },


        // printDiv(divId) {
        //     var printContents = document.getElementById(divId).innerHTML;
        //     var win = window.open("","print page", "height=700,width=1000");
        //     win.document.write('<style> *{direction:rtl;margin: 0;padding: 0;box-sizing: border-box;font-family:Noto Sans Hebrew , Noto sans Arabic;} .card{ width:100%; min-height: 420px; border: 2px solid #e0e0e0; padding: 1rem; border-radius: 2px; float: right; margin: 5px 0; /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */ position: relative; } .card:hover{ transform: translatey(-5px); } .card .head{ width: 100%; display: flex; align-items: center; padding-bottom: 0.7rem; border-bottom: 1px solid #e0e0e0; } .head span{ width: calc(100% / 3 ); font-size: 15px; margin: 0 5px; font-family: Noto Sans Hebrew, Noto Sans Arabic; font-weight: 600; text-align: center; overflow: hidden; } .head .name{ text-align: right; } .head .status{ text-align: center; padding: 3px 0px; border-radius: 5px; display:none;} .head .status .select{ width: 100%; padding: 8px; border: 0; font-size: 14px; display:none;} .head .date input{ border: 0; -webkit-appearance:none; } .head .orderNumber{ background-color: #e0e0e0; color: #000; text-align: center; /* padding: 3px 10px; */ border-radius: 5px; } .head .day{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .head .date{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .head .time{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .orderCart{ min-height: 100px; /* margin-bottom: 60px; */ } .orderCart .title{ font-size: 13px; color: #666; font-weight: 500; letter-spacing: 1px; padding: 0.2rem 0px; display: block; } .item{ width: 100%; padding: 0.5rem 0; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; position: relative; } .item span{ margin: 0 5px; font-weight: 500; font-family: Noto Sans Hebrew; } .item .selectedquantity{ color: #666; font-size: 14px; text-align: right; } .item .itemName{ } .item .subTotal{ position: absolute; left: 0; } .acceptBadge{ background-color: #666; color: #fff; text-align: center; border-radius: 5px; width: 100%; padding: 3px; border: 0; font-size: 14px; } .readyBadge{ background-color: #007a4d; color: #fff; text-align: center; border-radius: 5px; width: 100%; padding: 3px; border: 0; font-size: 14px; } .shippedBadge{ background-color: #0265dc; color: #fff; text-align: center; border-radius: 5px; } .canceledBadge{ background-color: #d31510; color: #fff; text-align: center; border-radius: 5px; } .inprogressBadge{ background-color: #666; color: #fff; text-align: center; border-radius: 5px; } .canceledOrder{ background-color: #fdebea; border: 2px solid #ff7770; } .orderReady{ background-color: #f1fef5; border: 2px solid #22a13c; } .confirmed{ background-color: #ebf7ff; border: 2px solid #44b7f0; } .images{ display: flex; align-items: top; justify-content: space-between; flex-wrap: wrap; } .images > div > img{ width: 100px; height: 100px; object-fit: fill; } .note{ margin: 5px 0; padding: 0; } .note span{ background-color:#ffe082 ; padding: 5px 10px; color: #000; display: block; font-family: Noto Sans Hebrew, Noto Sans Arabic; font-size: 14px; } .footerCard{ width: 100%; padding: 0.5rem 0rem; min-height: 40px; background-color: transparent; display: flex; align-items: center; border-top: 2px solid #e0e0e0; justify-content: center; } .footerCard .col3{ width: calc(100% / 2 ); text-align: center; } .footerCard .col3 .totalTitle{ font-size: 13px; font-weight: 500; color: #666; display: block; } .footerCard .col3 .totalAmount{ font-size: 14px; font-weight: 500; color: #000; display: block; display: block; } .footerCard .col3 .paid{ background-color: #dbeada; color: #298f33; padding: 5px 10px; border-radius: 8px; display: inline-block; font-family: Noto Sans Hebrew, Noto Sans Arabic; } .footerCard .col3 .unPaid{ background-color: #fbe7e2; color: #dc1213; padding: 5px 10px; border-radius: 8px; display: inline-block; font-family: Noto Sans Hebrew, Noto Sans Arabic; } </style>')
        //     win.document.write(printContents);
        //     win.print();
        //     win.close();

        // }


    }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_orderCard_vue__ = __webpack_require__(88);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrdersBeta',
  components: {
    order: __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__["a" /* default */], orderCard: __WEBPACK_IMPORTED_MODULE_8__components_orderCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      orders: [],
      txtSearch: '',
      toDate: '',
      fromDate: '',
      totalOrders: 0,
      deletedOrders: 0,
      acceptedOrders: 0,
      fromToday: 0,
      yesterdayItemNav: false,
      todayItemNav: false,
      tommorowItemNav: false,
      isLoading: true,
      salesReport: {}, // تخزين إجمالي المنتجات المباعة هنا 
      showModal: false, // يتحكم في عرض المودال
      selectedDate: new Date().toISOString().split("T")[0], // افتراضيًا اليوم الحالي\]
      unsubscribeOrders: null

    };
  },

  watch: {
    selectedDate: function selectedDate(newDate) {
      console.log("📅 تم تغيير التاريخ إلى:", newDate);
      this.fetchSalesReport();
    }
  },

  created: function created() {
    var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
    m.locale('he');
    console.log(m.format('LLLL'));
    var vm = this;
    var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD");
    vm.fromDate = today;
    vm.toDate = today;
    vm.todayItemNav = true;
    vm.loadOrdersRealTime();
    if (vm.totalOrders == 0) {
      vm.totalOrders = 0;
    }
  },

  computed: {
    filteredOrders: function filteredOrders() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var orders = [];
        for (var i = 0; i < vm.orders.length; i++) {
          var t = vm.orders[i];
          var found = false;

          if ((t.Data.fullname || '').toUpperCase().includes(vm.txtSearch.toUpperCase())) found = true;
          if ((t.Data.phoneNumber || '').toUpperCase().includes(vm.txtSearch.toUpperCase())) found = true;
          if ((t.Data.orderNumber || '').toString().includes(vm.txtSearch)) found = true;

          if (found) {
            orders.push(t);
          }
        }
        return orders;
      } else {
        return vm.orders;
      }
    },
    filteredOrdersCount: function filteredOrdersCount() {
      return this.filteredOrders.filter(function (o) {
        return o.Data.status !== 'נמחקה';
      }).length;
    }
  },
  mounted: function mounted() {
    this.fetchSalesReport(); // تحديث التقرير عند تحميل الصفحة بناءً على التاريخ الافتراضي
  },

  methods: {
    fetchSalesReport: function fetchSalesReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ordersRef, snapshot, salesData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("🚀 جلب البيانات لتاريخ:", _this.selectedDate);

                if (_this.selectedDate) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                ordersRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore().collection("orders");
                _context.prev = 4;
                _context.next = 7;
                return ordersRef.where("dateOrder", "==", _this.selectedDate).get();

              case 7:
                snapshot = _context.sent;

                if (!snapshot.empty) {
                  _context.next = 12;
                  break;
                }

                console.warn("⚠️ لا توجد طلبات لهذا اليوم.");
                _this.salesReport = {};
                return _context.abrupt('return');

              case 12:
                salesData = {};


                snapshot.forEach(function (doc) {
                  var order = doc.data();
                  if (!order.cart || !Array.isArray(order.cart)) return;

                  order.cart.forEach(function (product) {
                    var productName = product.Data && product.Data.Name ? product.Data.Name : "منتج غير معروف";
                    var quantity = product.selectedCount ? Number(product.selectedCount) : 0;

                    if (!salesData[productName]) {
                      salesData[productName] = 0;
                    }
                    salesData[productName] += quantity;
                  });
                });

                _this.salesReport = salesData;
                console.log("✅ البيانات المحدثة:", _this.salesReport);

                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](4);

                console.error("❌ حدث خطأ أثناء جلب البيانات:", _context.t0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 18]]);
      }))();
    },
    todayOrders: function todayOrders() {
      var vm = this;
      vm.todayItemNav = true;
      vm.tommorowItemNav = false;
      vm.yesterdayItemNav = false;

      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    tommorowOrders: function tommorowOrders() {
      var vm = this;
      vm.tommorowItemNav = true;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'days').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'days').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    thisMonth: function thisMonth() {
      var vm = this;
      vm.tommorowItemNav = false;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    lastMonth: function lastMonth() {
      var vm = this;
      vm.tommorowItemNav = false;
      vm.todayItemNav = false;
      vm.yesterdayItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract("1", "months").startOf('month').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract("1", "months").endOf('month').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    yesterdayOrders: function yesterdayOrders() {
      var vm = this;
      vm.yesterdayItemNav = true;
      vm.todayItemNav = false;
      vm.tommorowItemNav = false;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");

      vm.loadOrdersRealTime();
    },
    loadOrders: function loadOrders() {
      var vm = this;
      vm.orders = [];
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.deletedOrders = 0;
      //  .orderBy("orderNumber","desc")
      // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
      __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).orderBy("dateOrder", "asc").get().then(function (orderResult) {
        for (var a = 0; a < orderResult.size; a++) {
          var orderId = orderResult.docs[a].id;
          var _order = orderResult.docs[a].data();
          // console.log(orderResult.size);
          vm.orders.push({ ID: orderId, Data: _order });
          vm.totalOrders = orderResult.size;

          if (_order.status == 'נמחקה') {
            vm.deletedOrders++;
          }
        }

        if (vm.deletedOrders == 0) {
          vm.acceptedOrders = vm.totalOrders;
        }
        // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
        // .then(function(deletedResult){
        //   for(let a = 0; a < deletedResult.size; a++){
        //     // console.log(vm.deletedOrders);
        //     // console.log(deletedResult.docs[a].id);
        //     vm.deletedOrders = deletedResult.size;
        //   } 
        //   if(vm.totalOrders - vm.deletedOrders <= 0){
        //     vm.acceptedOrders = vm.totalOrders;
        //   }
        //   if( vm.deletedOrders == 0){
        //       // vm.deletedOrders = 0;
        //       vm.acceptedOrders = vm.totalOrders;

        //     }
        //     else {
        //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
        //     }
        // }).catch(function(error){
        //     console.error("Error getting document:", error);
        //     });
      }).catch(function (error) {
        console.error("Error getting document:", error);
      });
    },

    // loadOrdersRealTime(){
    //     let vm = this;
    //     vm.fromToday = 0;
    //     vm.totalOrders = 0 ;
    //     vm.deletedOrders = 0;
    //     vm.acceptedOrders = 0;

    //     //  .orderBy("orderNumber","desc")
    //     // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
    //     db.collection("orders").where('dateOrder', '>=', vm.fromDate)
    //     .where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").orderBy("timeOrder","asc").onSnapshot((orderResult) => {
    //       vm.isLoading = false;
    //       vm.orders = [];
    //       vm.totalOrders = orderResult.size;
    //         orderResult.forEach((doc) => {
    //                 let orderId = doc.id;
    //                 let order = doc.data();
    //                 // vm.totalOrders = doc.size;
    //                 vm.orders.push({ ID: orderId, Data: order });   
    //                 if(order.Date == order.dateOrder){
    //                 vm.fromToday++;
    //                 }
    //                 if(order.status == 'נמחקה'){
    //                   vm.deletedOrders++;
    //                 }
    //                 if( vm.deletedOrders == 0){
    //                   vm.acceptedOrders = vm.totalOrders;
    //                 }


    //               });

    //         // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
    //         // .then(function(deletedResult){
    //         //   for(let a = 0; a < deletedResult.size; a++){
    //         //     // console.log(vm.deletedOrders);
    //         //     // console.log(deletedResult.docs[a].id);
    //         //     vm.deletedOrders = deletedResult.size;
    //         // } 

    //         // if(vm.totalOrders - vm.deletedOrders <= 0){
    //         //   vm.acceptedOrders = vm.totalOrders;
    //         //     }
    //         //     if( vm.deletedOrders == 0){
    //         //       // vm.deletedOrders = 0;
    //         //       vm.acceptedOrders = vm.totalOrders;

    //         //     }
    //         //     else {
    //         //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
    //         //     }
    //         //     // console.log('deleted Orders :',vm.deletedOrders);
    //         //     // console.log('accepted Orders :',vm.acceptedOrders);

    //         //  })
    //         //  .catch(function(error){
    //         //     console.error("Error getting document:", error);
    //         //     });


    //           })
    //         },
    loadOrdersRealTime: function loadOrdersRealTime() {
      var vm = this;
      vm.fromToday = 0;
      vm.totalOrders = 0;
      vm.deletedOrders = 0;
      vm.acceptedOrders = 0;
      vm.orders = [];
      vm.isLoading = true;

      // إلغاء أي listener سابق إذا موجود
      if (vm.unsubscribeOrders) {
        vm.unsubscribeOrders();
      }

      var ordersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders");

      var query1 = ordersRef.where("dateOrder", ">=", vm.fromDate).where("dateOrder", "<=", vm.toDate);

      var query2 = ordersRef.where("dayOrder", ">=", vm.fromDate).where("dayOrder", "<=", vm.toDate);

      // شغّل المستمعين الفوريين
      var snapshotHandler = function snapshotHandler(snapshot1, snapshot2) {
        var allDocs = [];

        snapshot1.forEach(function (doc) {
          allDocs.push({ ID: doc.id, Data: doc.data() });
        });

        snapshot2.forEach(function (doc) {
          if (!allDocs.find(function (o) {
            return o.ID === doc.id;
          })) {
            allDocs.push({ ID: doc.id, Data: doc.data() });
          }
        });

        vm.totalOrders = allDocs.length;

        allDocs.sort(function (a, b) {
          var dateA = a.Data.selectedDateReadable || a.Data.dayOrder || a.Data.dateOrder || '';
          var dateB = b.Data.selectedDateReadable || b.Data.dayOrder || b.Data.dateOrder || '';

          var timeA = a.Data.timeOrder ? a.Data.timeOrder.padStart(5, '0') : '00:00';
          var timeB = b.Data.timeOrder ? b.Data.timeOrder.padStart(5, '0') : '00:00';

          var datetimeA = dateA + ' ' + timeA;
          var datetimeB = dateB + ' ' + timeB;

          return datetimeA.localeCompare(datetimeB);
        });

        vm.orders = allDocs;

        vm.fromToday = 0;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;

        allDocs.forEach(function (order) {
          var orderDate = order.Data.selectedDateReadable || order.Data.dayOrder || order.Data.dateOrder;
          if (orderDate === vm.fromDate) vm.fromToday++;

          if (order.Data.status === "נמחקה") vm.deletedOrders++;
        });

        vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
        vm.isLoading = false;
      };

      // اسمع للتحديثات من الاستعلامين
      var unsub1 = query1.onSnapshot(function (snapshot1) {
        query2.onSnapshot(function (snapshot2) {
          snapshotHandler(snapshot1, snapshot2);
        });
      });

      // خزّن unsubscribe عشان تستخدمه لما تتغير الفلاتر
      vm.unsubscribeOrders = function () {
        return unsub1();
      };
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    // props :['order', 'rowIndex'],
    components: {
        order: __WEBPACK_IMPORTED_MODULE_2__components_Order_vue__["a" /* default */]

    },
    data: function data() {
        return {
            orders: [],
            Dealers: [],
            // order: {
            //     fullname: '',
            //     phoneNumber: '',
            //     cakeTaste: '',
            //     cakeSize: '',
            //     dateOrder: '',
            //     timeOrder: '',
            //     dayOrder: '',
            //     priceOrder: '',
            //     createdDate: '',
            // },
            modalShow: false,
            activeOrder: null,
            today: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD"),
            orderCounterID: {
                counterID: null,
                orderCreatedDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL')
            },
            totalOrdersForToday: 0,
            subTotalForToday: 0,
            dealersCount: 0,
            lowStock: 0,
            totalExpenses: 0,
            expenses: [],
            deletedOrdersCounter: 0

        };
    },
    created: function created() {
        var vm = this;
        vm.today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD");
        vm.loadOrders();
        vm.loadTotalCounterOrders();
        vm.loadDealers();
        vm.loadLowStock();
        vm.loadTotalExpenses();
        vm.loadExpenses();
        console.log(__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LTS'));
    },

    methods: {
        goToRoute: function goToRoute(route) {
            this.$router.push(route);
        },
        loadDealers: function loadDealers() {
            var vm = this;
            vm.Dealers = [];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Dealers").where("type", "==", "ספק").onSnapshot(function (DealerMeheron) {
                for (var a = 0; a < DealerMeheron.size; a++) {
                    var dealerId = DealerMeheron.docs[a].id;
                    var dealer = DealerMeheron.docs[a].data();
                    //   console.log(DealerMeheron.size);
                    vm.dealersCount = DealerMeheron.size;

                    vm.Dealers.push({ ID: dealerId, Data: dealer });
                }
                //   })
                //   .catch(function(error){
                //       console.log("Error getting document:", error);
            });
        },
        loadOrders: function loadOrders() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").orderBy("orderNumber", "desc").limit("10").get().then(function (orderResult) {
                for (var a = 0; a < orderResult.size; a++) {
                    var orderId = orderResult.docs[a].id;
                    var _order = orderResult.docs[a].data();
                    vm.orders.push({ ID: orderId, Data: _order });
                }
            }).catch(function (error) {
                console.error("Error getting document:", error);
            });
        },
        loadTotalCounterOrders: function loadTotalCounterOrders() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").where("dateOrder", ">=", vm.today).where("dateOrder", "<=", vm.today).get().then(function (orderResult) {
                for (var a = 0; a < orderResult.size; a++) {
                    var orderId = orderResult.docs[a].id;
                    var _order2 = orderResult.docs[a].data();
                    vm.totalOrdersForToday = orderResult.size;
                    if (_order2.status == 'נמחקה') {
                        vm.deletedOrdersCounter++;
                    }

                    vm.totalOrdersForToday = vm.totalOrdersForToday - vm.deletedOrdersCounter;

                    vm.subTotalForToday = vm.subTotalForToday += _order2.totalOrderPrice;
                }
            }).catch(function (error) {
                console.error("Error getting document:", error);
            });
        },
        loadTotalExpenses: function loadTotalExpenses() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("cheques").get().then(function (expenseResult) {
                for (var a = 0; a < expenseResult.size; a++) {
                    var expenseId = expenseResult.docs[a].id;
                    var expense = expenseResult.docs[a].data();
                    vm.totalExpenses = vm.totalExpenses += expense.amount;
                }
            }).catch(function (error) {
                console.error("Error getting document:", error);
            });
        },
        loadExpenses: function loadExpenses() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Expenses").limit("5").orderBy("createdDate", "desc").get().then(function (expenseResult) {
                for (var a = 0; a < expenseResult.size; a++) {
                    var expenseId = expenseResult.docs[a].id;
                    var expense = expenseResult.docs[a].data();
                    //   vm.totalExpenses = expenseResult.size;
                    vm.expenses.push({ ID: expenseId, Data: expense });
                }
            }).catch(function (error) {
                console.error("Error getting document:", error);
            });
        },
        loadLowStock: function loadLowStock() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Products").where('Quantity', '<=', 3).get().then(function (ProductResult) {
                for (var a = 0; a < ProductResult.size; a++) {
                    var orderId = ProductResult.docs[a].id;
                    var _order3 = ProductResult.docs[a].data();
                    // console.log(orderResult.size);
                    vm.lowStock = ProductResult.size;
                    //   console.log("Orders Count Is : " + orderResultcount);
                    //   vm.orders.push({ ID: orderId, Data: order });
                    //   vm.subTotalForToday = vm.subTotalForToday += order.totalOrderPrice;
                    //   console.log(vm.subTotalForToday , "Total")

                }
            }).catch(function (error) {
                console.error("Error getting document:", error);
            });
        },
        pushOrderID: function pushOrderID() {
            var vm = this;

            vm.orderCounterID = {
                counterID: vm.counterID += 1,
                orderCreatedDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL')
            };
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("CounterID").set(vm.orderCounterID).then(function (orderResultID) {
                vm.orderCounterID = {
                    counterID: counterID += 1,
                    orderCreatedDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL')
                    //  console.log(orderResultID);

                    // console.log("Success")
                };
            }).catch(function () {
                console.log(error, "Error Adding Counter to Firebase");
            });
        },
        loadOrderID: function loadOrderID() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("CounterID").get().then(function (orderResultID) {
                for (var a = 0; a < orderResultID.size; a++) {
                    var orderId = orderResultID.docs[a].id;
                    var _order4 = orderResultID.docs[a].data();
                    //   console.log(orderResultID.size);
                    vm.orders.push({
                        ID: orderId, Data: _order4
                    });
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        }
    }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Secret',
  data: function data() {
    return {
      secrets: []
    };
  },
  created: function created() {
    var vm = this;
    vm.loadSecrets();
  },

  methods: {
    loadSecrets: function loadSecrets() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Secrets").get().then(function (secretsResult) {
        for (var a = 0; a < secretsResult.size; a++) {
          var secretId = secretsResult.docs[a].id;
          var secret = secretsResult.docs[a].data();
          // console.log(orderResult.size);
          vm.secrets.push({ ID: secretId, Data: secret });
          vm.totalsecrets = secretsResult.size;
        }
      });
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SelectedOrder',
    orders: [],

    data: function data() {
        return {
            editOrder: true
        };
    },
    created: function created() {
        var vm = this;
        console.log("Order Object is : ", vm.$root.selectedOrderObj);
        console.log("Order Id is : ", vm.$root.selectedOrderObj.ID);
    },

    methods: {
        deleteOrder: function deleteOrder() {
            var vm = this;
            console.log("Order Id is : ", vm.$root.selectedOrderObj.ID);
            var answer = confirm("האם אתה בטוח למחוק ההזמנה?");

            if (answer) {
                __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.$root.selectedOrderObj.ID).delete().then(function () {
                    console.log("Document successfully deleted!");
                    vm.$router.push("/Home");
                }).catch(function (error) {
                    console.error("Error removing document: ", error);
                });
            }
        },
        updateOrder: function updateOrder() {
            var vm = this;
            var newStatus = vm.$root.selectedOrderObj.Data.status;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.$root.selectedOrderObj.ID).get().then(function (order) {
                var orderData = order.data();
                var i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.$root.selectedOrderObj.ID).update(orderData);
                console.log("New Status is :" + newStatus);
                alert("סטטוס ההזמנה עודכן בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        updateOrderData: function updateOrderData() {
            var vm = this;
            var newName = vm.$root.selectedOrderObj.Data.fullname;
            var newPhone = vm.$root.selectedOrderObj.Data.phoneNumber;
            var newdateOrder = vm.$root.selectedOrderObj.Data.dateOrder;
            var newdayOrder = vm.$root.selectedOrderObj.Data.dayOrder;
            var newtimeOrder = vm.$root.selectedOrderObj.Data.timeOrder;
            var newcakeTaste = vm.$root.selectedOrderObj.Data.cakeTaste;
            var newcakeSize = vm.$root.selectedOrderObj.Data.cakeSize;
            var newpriceOrder = vm.$root.selectedOrderObj.Data.priceOrder;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.$root.selectedOrderObj.ID).get().then(function (order) {
                var orderData = order.data();
                var i = vm.$root.selectedOrderIndex;
                orderData.fullname = newName;
                orderData.phoneNumber = newPhone;
                orderData.dateOrder = newdateOrder;
                orderData.dayOrder = newdayOrder;
                orderData.timeOrder = newtimeOrder;
                orderData.cakeTaste = newcakeTaste;
                orderData.cakeSize = newcakeSize;
                orderData.priceOrder = newpriceOrder;
                __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.$root.selectedOrderObj.ID).update(orderData);
                console.log("Order Successhully Updated!");
                // editOrder = !editOrder
            }).catch(function (error) {
                console.log("Error :", error);
            });
        }
    }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignIn',
  props: ['item', 'rowIndex'],
  data: function data() {
    return {
      // workerName :'',
      LoginUser: {
        username: '',
        password: ""
      },
      wrongPassword: "",
      name: ""

    };
  },
  created: function created() {
    var vm = this;
    if (vm.$root.loggedUser != null) {

      vm.$router.push("/Home");
    } else {
      vm.$router.push("/");
    }
  },

  watch: {
    name: function name(val) {
      this.name = val.replace(/\W/g, "");
    }
  },
  methods: {
    nameKeydown: function nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    signIn: function signIn() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].collection("Users").where("username", "==", vm.LoginUser.username).limit(1).get().then(function (result) {
        if (result.size > 0) {
          result.forEach(function (doc) {
            var user = doc.data();
            if (user.password == vm.LoginUser.password) {
              vm.$root.loggedUser = doc.data();
              vm.$root.loggedUser.password = '*********';
              // if(!user.active){
              //   user.active = true;
              //   vm.$root.isAuth = user.active
              // }
              // vm.$root.getUserData();
              console.log("$root : ", vm.$root.isAuth);
              console.log("is the user active? ", user.active);
              localStorage.setItem("User", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vm.$root.loggedUser));
              // localStorage.setItem("UserID", JSON.stringify(vm.$root.loggedUser.userID ));
              if (vm.$root.loggedUser.Type === "Admin") {
                vm.$router.push("/Home");
              }
              if (vm.$root.loggedUser.Type === "Manager") {
                vm.$router.push("/Orders");
              }
              if (vm.$root.loggedUser.Type === "Worker") {
                vm.$router.push("/Orders");
              }
            } else {
              // alert("סיסמה שגויה");
              vm.wrongPassword = "שם משתמש או סיסמה שגויים!";
            }
          });
        } else {
          alert("משתמש אינו קיים");
        }
      }).catch(function (err) {
        console.log("Error : ");
      });
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'addWorkers',
    data: function data() {
        return {
            Users: [],
            User: {
                fullName: '',
                username: '',
                password: '',
                Type: '',
                profileImg: '',
                active: false
            }

        };
    },
    created: function created() {
        var vm = this;
        if (vm.$root.loggedUser.Type == 'Worker') {
            vm.$router.push("/Home");
        }
        vm.loadWorkers();
    },

    methods: {
        addData: function addData() {
            var vm = this;
            if (vm.User.fullName.length > 0) {

                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Users").add(vm.User).then(function (WorkersResult) {
                    alert("משתמש חדש נוסף בהצלחה");
                    vm.User.fullName = "";
                    vm.User.username = "";
                    vm.User.password = "";
                    vm.User.Type = "";
                    console.log("Add ( WorkersResult ) Success");
                    console.log(WorkersResult);
                }).catch(function (error) {
                    alert("שגיאה");
                    console.error('add( WorkersResult ) Error !');
                    console.error(error);
                });
            }
        },
        loadWorkers: function loadWorkers() {
            var vm = this;
            vm.Users = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Users").get().then(function (result) {
                console.log("Load Workers has been statred!");
                for (var a = 0; a < result.size; a++) {
                    var workerId = result.docs[a].id;
                    var User = result.docs[a].data();
                    // console.log(orderResult.size);
                    var resultcount = result.size;
                    console.log("Orders Count Is : " + result);
                    vm.Users.push({
                        ID: workerId,
                        firstName: User.firstName,
                        lastName: User.lastName,
                        username: User.username,
                        password: User.password,
                        Type: User.Type,
                        profileImg: User.profileImg
                    });
                }
            }).catch(function (error) {
                console.log("Error", error);
            });
        },
        logoutUser: function logoutUser(User) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Users").doc(User.ID).get().then(function (user) {
                var userData = user.data();
                userData.active = false;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Users").doc(User.ID).update(userData);
                console.log("New User Status is :" + userData.active);
                // alert("הכמות במלאי עודכנה בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        }
    }

});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_he__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Meheron',

  data: function data() {
    return {
      productName: "",
      productPrice: "",
      dealerName: "",
      quantity: 0,
      productImg: "",
      Meheronem: [],
      Dealers: [],
      selectDealerName: "",
      EditProduct: true

    };
  },
  created: function created() {
    var vm = this;
    vm.loadProducts();
    vm.loadDealers();
    if (vm.$root.loggedUser.Type !== 'Admin') {
      alert("אין לך גישה לדף הזה");
      vm.$router.go(-1);
    }
  },

  methods: {
    addProductMeheron: function addProductMeheron() {
      var vm = this;
      if (vm.productName.length > 0 && vm.productPrice.length > 0 && vm.dealerName.length > 0) {
        var ProductMeheron = {
          productName: vm.productName,
          productPrice: vm.productPrice,
          dealerName: vm.dealerName,
          productImg: vm.productImg,
          quantity: vm.quantity,
          createdDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LLLL')
        };

        __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Meheron").add(ProductMeheron).then(function (MeheronResult) {
          vm.productName = "";
          vm.productPrice = "";
          vm.dealerName = "";
          vm.quantity = "";
          vm.productImg = "";
          console.log("Add ( Product Meheron ) Success");
          console.log(MeheronResult);
          location.reload();
        }).catch(function (error) {
          console.error('add( Product Meheron ) Error !');
          console.error(error);
        });
      }
    },
    addDealer: function addDealer() {
      var vm = this;
      if (vm.selectDealerName.length > 0) {
        var DealerMeheron = {
          selectDealerName: vm.selectDealerName,
          createdDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LLLL')
        };

        __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Dealers").add(DealerMeheron).then(function (DealerResult) {
          vm.selectDealerName = "";
          console.log("Add ( DealerResult ) Success");
          console.log(DealerResult);
          location.reload();
        }).catch(function (error) {
          console.error('add( DealerResult ) Error !');
          console.error(error);
        });
      }
    },
    uploadImage: function uploadImage(e) {
      var _this = this;

      var file = e.target.files[0];
      var storageRef = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].storage().ref('ProductsMeheronem/' + file.name);

      var uploadTask = storageRef.put(file);

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on('state_changed', function (snapshot) {}, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          _this.productImg = downloadURL;
          console.log('File available at', downloadURL);
        });
      });
    },
    loadProducts: function loadProducts() {
      var vm = this;
      vm.Meheronem = [];
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Meheron").orderBy("createdDate", "desc").get().then(function (MeheronResult) {
        for (var a = 0; a < MeheronResult.size; a++) {
          var productId = MeheronResult.docs[a].id;
          var product = MeheronResult.docs[a].data();
          console.log(MeheronResult.size);
          vm.Meheronem.push({ ID: productId, Data: product });
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    loadDealers: function loadDealers() {
      var vm = this;
      vm.Meheronem = [];
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Dealers").orderBy("createdDate", "desc").get().then(function (DealerMeheron) {
        for (var a = 0; a < DealerMeheron.size; a++) {
          var dealerId = DealerMeheron.docs[a].id;
          var dealer = DealerMeheron.docs[a].data();
          console.log(DealerMeheron.size);
          vm.Dealers.push({ ID: dealerId, Data: dealer });
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    }
  }

});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Order_vue__ = __webpack_require__(52);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateOrderBeta',
    components: {
        order: __WEBPACK_IMPORTED_MODULE_6__components_Order_vue__["a" /* default */]
    },
    data: function data() {
        return {
            orders: [],
            cart: [],
            Products: [],
            fullname: "",
            phoneNumber: "",
            timeOrder: "16:00",
            dateOrder: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD"),
            dayOrder: "",
            priceOrder: "",
            cakeTaste: "",
            cakeSize: "",
            workerName: "",
            counter: {
                orderNumber: 0
            },
            orderImg: [],
            status: "התקבלה",
            min: 1000,
            activeItemBar: 1,
            activeProductsBar: 0,
            totalOrderPrice: 0,
            selectedQuantity: 1,
            productObj: "",
            note: "",
            paidStatus: "",
            discount: 0,
            txtSearch: '',
            isLoading: false
        };
    },
    created: function created() {
        var m = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
        m.locale('he');
        console.log(m.format('LLLL'));
        var vm = this;
        vm.loadOrders();
        vm.loadCounter();
        // vm.loadProductsToOrder();
    },

    computed: {
        filteredProducts: function filteredProducts() {
            var vm = this;
            if (vm.txtSearch.length > 0) {
                var Products = [];
                for (var i = 0; i < vm.Products.length; i++) {
                    var t = vm.Products[i];
                    var found = false;
                    if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
                        found = true;
                    }
                    if (found) {
                        Products.push(t);
                    }
                }
                return Products;
            } else {
                return vm.Products;
            }
        }
    },
    methods: {
        sendOrder: function sendOrder() {
            var vm = this;
            vm.isLoading = true;
            if (vm.fullname.length > 0 && vm.dayOrder.length > 0 && vm.timeOrder.length > 0 && vm.dateOrder.length > 0 && vm.paidStatus.length > 0) {
                var _order = {
                    fullname: vm.fullname,
                    phoneNumber: vm.phoneNumber,
                    orderImg: vm.orderImg,
                    dayOrder: vm.dayOrder,
                    timeOrder: vm.timeOrder,
                    dateOrder: vm.dateOrder,
                    totalOrderPrice: vm.totalOrderPrice,
                    // cakeTaste: vm.cakeTaste,
                    // cakeSize: vm.cakeSize,
                    // workerName: vm.$root.loggeduser.fullName,
                    status: vm.status,
                    createdDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL'),
                    orderNumber: vm.counter.orderNumber,
                    cart: vm.cart,
                    note: vm.note,
                    paidStatus: vm.paidStatus,
                    discount: vm.discount
                };
                if (vm.phoneNumber.length == 10) {
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").set(vm.counter).then(function (result) {
                        vm.loadCounter();
                        console.log("Counter Updated");
                    }).catch(function (error) {
                        console.log("Error");
                    });
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("orders").add(_order).then(function (orderResult) {
                        vm.fullname = "";
                        vm.phoneNumber = "";
                        vm.timeOrder = "";
                        vm.dateOrder = "";
                        vm.dayOrder = "";
                        vm.priceOrder = "";
                        vm.orderImg = [];
                        vm.cart = [];
                        vm.status = "התקבלה", vm.orderNumber = "", vm.paidStatus = "", vm.note = "", vm.discount = 0, vm.totalOrderPrice = 0;
                        console.log("Add Order Success");
                        console.log(orderResult);
                    }).catch(function (error) {
                        console.error('add(order) Error !');
                        console.error(error);
                    });
                    vm.isLoading = false;;
                } else {
                    alert("מספר הטלפון חייב להכיל 10 ספרות בלבד");
                }
            } else if (vm.fullname.length <= 0 || vm.dayOrder.length <= 0 || vm.timeOrder.length <= 0 || vm.dateOrder.length <= 0 || vm.paidStatus.length <= 0) {
                alert("חובה למלא את כל השדות!");
            }
        },
        uploadImage: function uploadImage(e) {
            var _this = this;

            if (e.target.files[0]) {
                var _file = e.target.files[0];
                var storageRef = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].storage().ref('orders/' + _file.name);
                var uploadTask = storageRef.put(_file);
                uploadTask.on('state_changed', function (snapshot) {}, function (error) {
                    // Handle unsuccessful uploads
                }, function () {
                    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        _this.orderImg.push(downloadURL);
                        var media = {
                            date: new Date().toLocaleDateString(),
                            image: "",
                            fullname: _this.fullname,
                            orderNumber: _this.counter.orderNumber
                        };
                        media.image = downloadURL;
                        console.log(media);
                        __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Media").add(media);
                        console.log('File available at', downloadURL);
                    });
                });
            }
        },
        downloadFullExample: function downloadFullExample() {
            var storageRef = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].storage().ref();

            // [START storage_download_full_example]
            // Create a reference to the file we want to download
            var starsRef = storageRef.child('orders/' + file.name);

            // Get the download URL
            starsRef.getDownloadURL().then(function (url) {
                // Insert url into an <img> tag to "download"
            }).catch(function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/object-not-found':
                        // File doesn't exist
                        break;
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    // ...

                    case 'storage/unknown':
                        // Unknown error occurred, inspect the server response
                        break;
                }
            });
            // [END storage_download_full_example]
        },
        loadOrders: function loadOrders() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("orders").orderBy("createdDate", "desc").get().then(function (orderResult) {
                for (var a = 0; a < orderResult.size; a++) {
                    var orderId = orderResult.docs[a].id;
                    var _order2 = orderResult.docs[a].data();
                    vm.orders.push({ ID: orderId, Data: _order2 });
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        loadCounter: function loadCounter() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").get().then(function (doc) {
                if (doc.exists) {
                    vm.counter = doc.data();
                    if (vm.counter.orderNumber < vm.min) {
                        vm.counter.orderNumber = vm.min;
                    } else {
                        vm.counter.orderNumber++;
                    }
                }
            }).catch(function (error) {
                console.error("❌ خطأ في تحميل العداد:", error);
            });
        },
        loadProductsToOrder: function loadProductsToOrder() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגות מרובעות').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadCircleCakes: function loadCircleCakes() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגות עגולות').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadBiscuit: function loadBiscuit() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגיות').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadPasim: function loadPasim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'פסים').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadCoufsaot: function loadCoufsaot() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'קופסאות').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadMghashim: function loadMghashim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'מגשים').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadOneUse: function loadOneUse() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'חד פעמי').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadDrinks: function loadDrinks() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'שתיה').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadHataifim: function loadHataifim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'חטיפים').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadBakingCakes: function loadBakingCakes() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").where('category', '==', 'שמרים').get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        addToArray: function addToArray(item) {
            var vm = this;
            var existingItem = vm.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            if (existingItem) {
                vm.selectedQuantity++;
            } else {
                vm.cart.push(item);
            }
            // vm.cart.push(item);

            console.log(vm.cart);
            vm.totalOrderPrice += item.Data.Price;

            // vm.cart.forEach(product => {
            // vm.totalOrderPrice += product.Data.Price;
            // })
        },
        addToCart: function addToCart(item) {
            var selectedCount = 1;
            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            this.productObj = item;
            console.log(this.productObj);
            if (existingItem) {
                existingItem.selectedCount++;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            } else {
                this.cart.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { selectedCount: 1 }));
                var _newQuantity = item.Data.Quantity - 1;
                __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            this.totalOrderPrice += item.Data.Price;
            console.log(this.cart);
        },
        reduceItem: function reduceItem(item, index) {
            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            var selectedCount = 1;
            if (existingItem) {
                existingItem.selectedCount--;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
                if (existingItem.selectedCount == 0) {

                    var _newQuantity2 = item.Data.Quantity;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                        var orderData = order.data();
                        orderData.Quantity = _newQuantity2;
                        __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                        console.log("New Amoumt is :" + _newQuantity2);
                    }).catch(function (error) {
                        console.log("Error :", error);
                    });
                    this.cart.splice(index, 1);
                }
                this.totalOrderPrice -= item.Data.Price;
                console.log(this.cart);
            } else {
                var _newQuantity3 = item.Data.Quantity - existingItem.selectedCount + 1;
                __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity3;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity3);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
        },
        removeItem: function removeItem(product, index) {
            var selectedCount = 1;
            if (product.selectedCount >= 1) {
                var newQuantity = this.productObj.Data.Quantity;
                console.log("Product Quantity :", product.Data.Quantity);
                console.log("Product Selected Quantity :", product.selectedCount);
                __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(product.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].collection("Products").doc(product.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            // else if(product.selectedCount < 1){
            //     let newQuantity = product.Data.Quantity + product.selectedCount;
            //     db.collection("Products").doc(product.ID).get()
            // .then((order) =>{
            //     let orderData = order.data();
            //     orderData.Quantity = newQuantity;
            //     db.collection("Products").doc(product.ID).update(orderData);
            //     console.log("New Amoumt is :" + newQuantity) ;

            // })
            // .catch((error) =>{
            //     console.log("Error :" , error);
            // })
            // }
            // Remove the item at the specified index from the array.
            this.cart.splice(index, 1);
            this.totalOrderPrice -= product.Data.Price * product.selectedCount;
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Calendar_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CalendarTime_vue__ = __webpack_require__(631);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'newOrderbeta',
    components: {
        order: __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__["a" /* default */], Calendar: __WEBPACK_IMPORTED_MODULE_8__components_Calendar_vue__["a" /* default */], CalendarTime: __WEBPACK_IMPORTED_MODULE_9__components_CalendarTime_vue__["a" /* default */]
    },
    data: function data() {
        return {
            orders: [],
            cart: [],
            Products: [],
            fullname: "",
            phoneNumber: "",
            timeOrder: "",
            dateOrder: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD"),
            dayOrder: "",
            priceOrder: "",
            cakeTaste: "",
            cakeSize: "",
            workerName: "",
            counter: {
                orderNumber: 0
            },
            orderImg: [],
            status: "התקבלה",
            min: 1000,
            activeProductsBar: 0,
            totalOrderPrice: 0,
            selectedQuantity: 1,
            productObj: "",
            note: "",
            paidStatus: "",
            discount: 0,
            txtSearch: '',
            isLoading: false,
            firstStep: true,
            secStep: false,
            thirdStep: false,
            forthStep: false,
            selectedDateReadable: "",
            successAdded: false,
            activeItemBar: 1,
            loadingCounter: false,
            steps: [1, 2, 3, 4],
            openCart: false,
            showPreview: false
        };
    },
    created: function created() {
        var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
        m.locale('he');
        var vm = this;
        vm.loadOrders();
        vm.loadCounter();
        // vm.loadProductsToOrder();
    },

    computed: {
        filteredProducts: function filteredProducts() {
            var vm = this;
            if (vm.txtSearch.length > 0) {
                var Products = [];
                for (var i = 0; i < vm.Products.length; i++) {
                    var t = vm.Products[i];
                    var found = false;
                    if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
                        found = true;
                    }
                    if (found) {
                        Products.push(t);
                    }
                }
                return Products;
            } else {
                return vm.Products;
            }
        },
        isFirstStep: function isFirstStep() {
            return this.activeItemBar === this.steps[0];
        },
        isLastStep: function isLastStep() {
            return this.activeItemBar === this.steps[this.steps.length - 1];
        },
        stepTitle: function stepTitle() {
            switch (this.activeItemBar) {
                case 1:
                    return "פרטי לקוח";
                case 2:
                    return "פרטי הזמנה";
                case 3:
                    return "פרטי הזמנה";
                case 4:
                    return "אישור";
                default:
                    return "";
            }
        },
        cartItemCount: function cartItemCount() {
            return this.cart.reduce(function (total, item) {
                return total + (item.selectedCount || 1); // إذا ما في selectedCount اعتبره 1
            }, 0);
        }
    },

    methods: {
        handleDateSelected: function handleDateSelected(dateInfo) {
            this.dayOrder = dateInfo.key;
            this.selectedDateReadable = dateInfo.readable;
        },
        handleTimeSelect: function handleTimeSelect(time) {
            this.timeOrder = time;
            console.log("الوقت المختار:", time);
        },
        handleResize: function handleResize() {
            var heightDiff = this.originalHeight - window.innerHeight;
            this.isKeyboardOpen = heightDiff > 150;
        },
        handleFocus: function handleFocus() {
            this.handleResize(); // فحص أولي
        },
        handleBlur: function handleBlur() {
            this.isKeyboardOpen = false;
        },
        goNext: function goNext() {
            alert("تم الانتقال ✅");
        },
        loadProducts: function loadProducts(collectionName) {

            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', collectionName).orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        extractISODate: function extractISODate(str) {
            try {
                if (!str.includes('-')) return null;
                var parts = str.split('-');
                var rawDate = parts[1].trim(); // "2 ביולי 2025"
                var momentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(rawDate, 'D [ב]MMMM YYYY', 'he'); // لاحظ [ב] بدل ב لحرف ثابت
                return momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : null;
            } catch (e) {
                console.error("❌ extractISODate error:", e);
                return null;
            }
        },
        sendOrder: function sendOrder() {
            var vm = this;
            vm.isLoading = true;

            if (vm.fullname.length > 0 && vm.selectedDateReadable.length > 0 && vm.timeOrder.length > 0 && vm.paidStatus.length > 0) {

                var extractedDate = this.extractISODate(vm.selectedDateReadable);
                console.log("📆 extracted:", extractedDate);

                var _order = {
                    fullname: vm.fullname,
                    phoneNumber: vm.phoneNumber,
                    orderImg: vm.orderImg,
                    selectedDateReadable: vm.selectedDateReadable,
                    timeOrder: vm.timeOrder,
                    dayOrder: vm.extractISODate(vm.selectedDateReadable), // ✅ التاريخ بصيغة ISO
                    totalOrderPrice: vm.totalOrderPrice,
                    status: vm.status,
                    createdDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('LLLL'),
                    orderNumber: vm.counter.orderNumber,
                    cart: vm.cart,
                    note: vm.note,
                    paidStatus: vm.paidStatus,
                    discount: vm.discount
                };

                if (vm.phoneNumber.length == 10) {
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").set(vm.counter).then(function (result) {
                        vm.loadCounter();
                        console.log("Counter Updated");
                    }).catch(function (error) {
                        console.log("Error");
                    });
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").add(_order).then(function (orderResult) {
                        vm.fullname = "";
                        vm.phoneNumber = "";
                        vm.timeOrder = "";
                        vm.dateOrder = "";
                        vm.dayOrder = "";
                        vm.priceOrder = "";
                        vm.orderImg = [];
                        vm.cart = [];
                        vm.status = "התקבלה", vm.orderNumber = "", vm.paidStatus = "", vm.note = "", vm.discount = 0, vm.totalOrderPrice = 0;
                        console.log(orderResult);
                    }).catch(function (error) {
                        console.error('add(order) Error !');
                        console.error(error);
                    });
                    vm.isLoading = false;
                    vm.activeItemBar = 1;
                    vm.showPreview = false;
                } else {
                    alert("מספר הטלפון חייב להכיל 10 ספרות בלבד");
                }
            } else if (vm.fullname.length <= 0 || vm.dayOrder.length <= 0 || vm.timeOrder.length <= 0 || vm.dateOrder.length <= 0 || vm.paidStatus.length <= 0) {
                alert("חובה למלא את כל השדות!");
            }
        },
        uploadImage: function uploadImage(e) {
            var _this = this;

            if (e.target.files[0]) {
                var _file = e.target.files[0];
                var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].storage().ref('orders/' + _file.name);
                var uploadTask = storageRef.put(_file);
                uploadTask.on('state_changed', function (snapshot) {}, function (error) {
                    // Handle unsuccessful uploads
                }, function () {
                    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        _this.orderImg.push(downloadURL);
                        var media = {
                            date: new Date().toLocaleDateString(),
                            image: "",
                            fullname: _this.fullname,
                            orderNumber: _this.counter.orderNumber
                        };
                        media.image = downloadURL;
                        __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Media").add(media);
                        console.log('File available at', downloadURL);
                    });
                });
            }
        },
        downloadFullExample: function downloadFullExample() {
            var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].storage().ref();

            // [START storage_download_full_example]
            // Create a reference to the file we want to download
            var starsRef = storageRef.child('orders/' + file.name);

            // Get the download URL
            starsRef.getDownloadURL().then(function (url) {
                // Insert url into an <img> tag to "download"
            }).catch(function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/object-not-found':
                        // File doesn't exist
                        break;
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    // ...

                    case 'storage/unknown':
                        // Unknown error occurred, inspect the server response
                        break;
                }
            });
            // [END storage_download_full_example]
        },
        loadOrders: function loadOrders() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").orderBy("createdDate", "desc").get().then(function (orderResult) {
                for (var a = 0; a < orderResult.size; a++) {
                    var orderId = orderResult.docs[a].id;
                    var _order2 = orderResult.docs[a].data();
                    vm.orders.push({ ID: orderId, Data: _order2 });
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },

        // loadCounter() {
        //   let vm = this;
        //   vm.loadingCounter = true ;
        //   db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").get()
        //     .then((doc) => {
        //       if (doc.exists) {
        //         vm.counter = doc.data();
        //         if (vm.counter.orderNumber < vm.min) {
        //           vm.counter.orderNumber = vm.min;
        //         } else {
        //           vm.counter.orderNumber++;
        //         }
        //         vm.loadingCounter = false ;
        //       }
        //     })
        //     .catch((error) => {
        //       console.error("❌ خطأ في تحميل العداد:", error);
        //     });
        // },
        loadCounter: function loadCounter() {
            var vm = this;
            vm.loadingCounter = true;
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").onSnapshot(function (doc) {
                if (doc.exists) {
                    vm.counter = doc.data();
                    vm.loadingCounter = false;
                    console.log("vm.orderNumber =" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.counter));
                    if (vm.counter.orderNumber < vm.min) {
                        vm.counter.orderNumber = vm.min;
                    } else {
                        vm.counter.orderNumber++;
                    }
                }
            });
        },
        addToCart: function addToCart(item) {
            var _this2 = this;

            this.txtSearch = '';
            var selectedCount = 1;
            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            this.productObj = item;
            console.log(this.productObj);
            if (existingItem) {
                existingItem.selectedCount++;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            } else {
                this.cart.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { selectedCount: 1 }));
                var _newQuantity = item.Data.Quantity - 1;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            this.totalOrderPrice += item.Data.Price;
            console.log(this.cart);
            this.successAdded = true;
            setTimeout(function () {
                _this2.successAdded = false;
            }, 3000); // 3000 milliseconds = 3 seconds
        },
        reduceItem: function reduceItem(item, index) {
            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            var selectedCount = 1;
            if (existingItem) {
                existingItem.selectedCount--;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
                if (existingItem.selectedCount == 0) {

                    var _newQuantity2 = item.Data.Quantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                        var orderData = order.data();
                        orderData.Quantity = _newQuantity2;
                        __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                        console.log("New Amoumt is :" + _newQuantity2);
                    }).catch(function (error) {
                        console.log("Error :", error);
                    });
                    this.cart.splice(index, 1);
                }
                this.totalOrderPrice -= item.Data.Price;
                console.log(this.cart);
            } else {
                var _newQuantity3 = item.Data.Quantity - existingItem.selectedCount + 1;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity3;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity3);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
        },
        removeItem: function removeItem(product, index) {
            var selectedCount = 1;
            if (product.selectedCount >= 1) {
                var newQuantity = this.productObj.Data.Quantity;
                console.log("Product Quantity :", product.Data.Quantity);
                console.log("Product Selected Quantity :", product.selectedCount);
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(product.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(product.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            // Remove the item at the specified index from the array.
            this.cart.splice(index, 1);
            this.totalOrderPrice -= product.Data.Price * product.selectedCount;
        },
        openCartModal: function openCartModal() {
            var vm = this;
            vm.openCart = !vm.openCart;
        },
        goToNext: function goToNext() {
            if (!this.isLastStep) {
                this.activeItemBar++;
            }
        },
        goToPrevious: function goToPrevious() {
            if (!this.isFirstStep) {
                this.activeItemBar--;
            }
        }
    }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130b54f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-130b54f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130b54f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Calendar",
  data: function data() {
    return {
      days: [],
      selectedDate: null
    };
  },
  created: function created() {
    this.generateDays();
  },

  methods: {
    generateDays: function generateDays() {
      var today = new Date();
      for (var i = 0; i < 30; i++) {
        var date = new Date();
        date.setDate(today.getDate() + i);

        var dayName = date.toLocaleDateString("he-IL", { weekday: "long" });
        var day = date.toLocaleDateString("he-IL", {
          day: "numeric",
          month: "long",
          year: "numeric"
        });

        var dateKey = date.toISOString().split("T")[0]; // ✅ هذا السطر مهم

        this.days.push({
          dateObject: date,
          dayName: dayName,
          dateString: day,
          dateKey: dateKey // ✅ لا تنسى تضيفه هنا
        });
      }
    },
    selectDate: function selectDate(day) {
      this.selectedDate = day.dateKey; // نحدد التاريخ المختار
      var dateKey = day.dateKey;
      var readable = day.dayName + " - " + day.dateString;
      this.$emit("date-selected", {
        key: dateKey,
        readable: readable
      });
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CalendarTime",
  data: function data() {
    return {
      timeSlots: [],
      selectedTime: null
    };
  },
  created: function created() {
    this.generateTimeSlots();
  },

  methods: {
    generateTimeSlots: function generateTimeSlots() {
      var startHour = 9;
      var endHour = 20;
      var interval = 30; // دقائق

      var slots = [];

      var pad = function pad(num) {
        return String(num).padStart(2, '0');
      };

      for (var h = startHour; h <= endHour; h++) {
        for (var m = 0; m < 60; m += interval) {
          var hour = pad(h);
          var minute = pad(m);
          var value = hour + ":" + minute;

          // نتأكد ما نضيف 22:00
          if (h === endHour && m > 30) break;

          slots.push({
            value: value,
            label: "" + value // فيك تضيف AM/PM أو صيغة عربية
          });
        }
      }

      this.timeSlots = slots;
    },
    selectTime: function selectTime(slot) {
      this.selectedTime = slot.value;
      this.$emit("time-selected", slot.value);
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Calendar_vue__ = __webpack_require__(354);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





 // عدّل المسار حسب مكان الملف

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SelectedOrderBeta',
    components: {
        Calendar: __WEBPACK_IMPORTED_MODULE_9__components_Calendar_vue__["a" /* default */]
    },
    data: function data() {
        return {
            editOrder: true,
            id: this.$route.params.id,
            selectedorderID: this.$route.params.id,
            orderOBJ: '',
            newImage: '',
            deleted: true,
            editInfo: false,
            editDates: false,
            editCartItems: false,
            isLoading: true,
            ProductsModal: false,
            Products: [],
            selectedCategory: '',
            txtSearch: '',
            productObj: "",
            progress: '',
            files: [], // لتخزين الملفات المختارة
            uploadedImages: [], // لتخزين روابط الصور بعد رفعها
            hours: []

        };
    },
    created: function created() {
        var vm = this;
        console.log(vm.selectedorderID);
        vm.loadSingleOrder();
        this.generateHours();
        console.log("URL :", window.location.href);
    },

    computed: {
        filteredProducts: function filteredProducts() {
            var vm = this;
            if (vm.txtSearch.length > 0) {
                var Products = [];
                for (var i = 0; i < vm.Products.length; i++) {
                    var t = vm.Products[i];
                    var found = false;
                    if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
                        found = true;
                    }
                    if (found) {
                        Products.push(t);
                    }
                }
                return Products;
            } else {
                return vm.Products;
            }
        }
    },
    methods: {
        updateDate: function updateDate(newDate) {
            this.orderOBJ.selectedDateReadable = newDate.readable;
            // optional: this.orderOBJ.dateOrder = this.extractISODate(newDate.readable);
        },
        generateHours: function generateHours() {
            var startHour = 9.5; // 9:30
            var endHour = 21.5;
            var result = [];

            for (var h = startHour; h <= endHour; h += 0.5) {
                var hour = Math.floor(h);
                var minutes = h % 1 === 0 ? "00" : "30";
                result.push(hour.toString().padStart(2, '0') + ':' + minutes);
            }

            this.hours = result;
        },
        saveOrderUpdates: function saveOrderUpdates() {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(this.selectedorderID).update({
                selectedDateReadable: this.orderOBJ.selectedDateReadable,
                timeOrder: this.orderOBJ.timeOrder
            }).then(function () {
                alert("העדכון בוצע בהצלחה");
            }).catch(function (err) {
                console.error("❌ Error updating order:", err);
            });
        },
        handleFiles: function handleFiles(event) {
            // تحويل الملفات المختارة إلى مصفوفة
            this.files = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(event.target.files);

            // رفع الملفات إلى Firebase
            this.uploadFiles();
        },
        uploadFiles: function uploadFiles() {
            var _this = this;

            var storageRef = __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].storage().ref(); // مرجع Firebase Storage

            this.files.forEach(function (file) {
                // توليد اسم فريد للملف لتجنب التكرار عند رفع صور من الهاتف
                var uniqueFileName = _this.selectedorderID + '_' + Date.now() + '_' + file.name;
                var fileRef = storageRef.child('orders/' + uniqueFileName); // تحديد مسار التخزين باستخدام الاسم الفريد
                var uploadTask = fileRef.put(file); // إنشاء مهمة الرفع

                // مراقبة تقدم عملية الرفع
                uploadTask.on("state_changed", function (snapshot) {
                    // حساب نسبة التقدم للملف الحالي
                    var progressForFile = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                    console.log('Progress for ' + uniqueFileName + ': ' + progressForFile + '%');
                    // يمكنك هنا استخدام متغير منفصل لكل ملف أو تجميع النسب حسب الحاجة
                    _this.progress = progressForFile; // أو تحديث واجهة المستخدم بالطريقة المناسبة
                }, function (error) {
                    // معالجة الأخطاء
                    console.error("خطأ أثناء رفع الملف:", error);
                }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var downloadURL;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return uploadTask.snapshot.ref.getDownloadURL();

                                case 3:
                                    downloadURL = _context.sent;
                                    _context.next = 6;
                                    return __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(_this.selectedorderID).update({
                                        orderImg: __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].firestore.FieldValue.arrayUnion(downloadURL)
                                    });

                                case 6:

                                    console.log("تم تحديث الوثيقة وإضافة الرابط بنجاح");
                                    _this.uploadedImages.push(downloadURL); // حفظ الرابط محليًا
                                    _this.loadSingleOrder();
                                    _context.next = 14;
                                    break;

                                case 11:
                                    _context.prev = 11;
                                    _context.t0 = _context['catch'](0);

                                    console.error("خطأ أثناء تحديث الوثيقة:", _context.t0);

                                case 14:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this, [[0, 11]]);
                })));
            });
        },
        uploadImage: function uploadImage(file) {
            // Create the file metadata
            var vm = this;
            var e = file.target.files[0];

            var storageRef = __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].storage().ref();

            // Upload file and metadata to the object 'images/mountains.jpg'
            var uploadTask = storageRef.child('orders/' + e.name).put(e);

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(__WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                vm.progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                console.log('Upload is ' + vm.progress + '% done');
                switch (snapshot.state) {
                    case __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].storage.TaskState.PAUSED:
                        // or 'paused'
                        console.log('Upload is paused');
                        break;
                    case __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].storage.TaskState.RUNNING:
                        // or 'running'
                        console.log('Upload is running');
                        break;
                }
            }, function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    // ...

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                }
            }, function () {

                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    vm.orderOBJ.orderImg.push(downloadURL);
                    __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({ orderImg: vm.orderOBJ.orderImg });
                    console.log('File available at', downloadURL);
                });
            });
        },
        backToOrders: function backToOrders() {
            var vm = this;
            console.log("backToOrders()");
            vm.$router.push("/ordersBeta");
        },
        deleteOrder: function deleteOrder() {
            var vm = this;
            console.log("Order Id is : ", vm.selectedorderID);
            var answer = confirm("האם אתה בטוח למחוק ההזמנה?");

            if (answer) {
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).delete().then(function () {
                    console.log("Document successfully deleted!");
                    vm.$router.push("/Home");
                }).catch(function (error) {
                    console.error("Error removing document: ", error);
                });
            }
        },
        deleteImage: function deleteImage(img, index) {
            var vm = this;
            console.log("Order Id is : ", vm.selectedorderID);
            var answer = confirm("האם אתה בטוח למחוק התמונה?");

            if (answer) {
                vm.orderOBJ.orderImg.splice(index, 1);
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({ orderImg: vm.orderOBJ.orderImg });
            }
        },
        updateStatus: function updateStatus() {
            var vm = this;
            var newStatus = vm.orderOBJ.status;
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).get().then(function (order) {
                var orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({ status: vm.orderOBJ.status });
                console.log("New Status is :" + newStatus);
                alert("סטטוס ההזמנה עודכן בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        saveNote: function saveNote() {
            var vm = this;
            var newNote = vm.orderOBJ.note;
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).get().then(function (order) {
                var orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.note = newNote;
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({ note: vm.orderOBJ.note });
                console.log("New Status is :" + newNote);
                alert("הערת ההזמנה עודכן בהצלחה");
                vm.editCartItems = false;
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        whatsappMessage: function whatsappMessage() {
            var vm = this;
            // window.open("https://wa.me/85261234567" );
            window.open("https://api.whatsapp.com/send?phone=972" + vm.orderOBJ.phoneNumber);
        },
        updatePayment: function updatePayment() {
            var vm = this;
            var newPayment = vm.orderOBJ.paidStatus;
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).get().then(function (order) {
                var orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.paidStatus = newPayment;
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({ paidStatus: vm.orderOBJ.paidStatus });
                console.log("New Status is :" + newPayment);
                alert("סטטוס הגבייה עודכן בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        updateOrderData: function updateOrderData() {
            var vm = this;

            // استخرج البيانات المطلوبة
            var updatedData = {
                fullname: vm.orderOBJ.fullname,
                phoneNumber: vm.orderOBJ.phoneNumber,
                timeOrder: vm.orderOBJ.timeOrder,
                selectedDateReadable: vm.orderOBJ.selectedDateReadable
            };

            // إزالة أي قيم undefined (لو ناقص إشي)
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(updatedData).forEach(function (key) {
                if (updatedData[key] === undefined) {
                    delete updatedData[key];
                }
            });

            // تحديث الطلب
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update(updatedData).then(function () {
                console.log("Order Successfully Updated!");
                vm.editInfo = false;
                vm.editDates = false;
            }).catch(function (error) {
                console.error("Error:", error);
            });
        },
        loadSingleOrder: function loadSingleOrder() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).get().then(function (order) {
                vm.isLoading = false;
                var orderData = order.data();
                var fullname = orderData.fullname;
                var orderNumber = orderData.orderNumber;
                var dayOrder = orderData.dayOrder;
                var dateOrder = orderData.dateOrder;
                var createdDate = orderData.createdDate;
                var phoneNumber = orderData.phoneNumber;
                var status = orderData.status;
                var timeOrder = orderData.timeOrder;
                var totalOrderPrice = orderData.totalOrderPrice;
                var orderImg = orderData.orderImg;
                var cart = orderData.Cart;
                var paidStatus = orderData.paidStatus;
                var discount = orderData.discount;
                var note = orderData.note;
                var selectedDateReadable = orderData.selectedDateReadable;

                // console.log(fullname);
                console.log(orderData);
                vm.orderOBJ = {
                    fullname: orderData.fullname,
                    orderNumber: orderData.orderNumber,
                    dayOrder: orderData.dayOrder,
                    dateOrder: orderData.dateOrder,
                    createdDate: orderData.createdDate,
                    phoneNumber: orderData.phoneNumber,
                    status: orderData.status,
                    timeOrder: orderData.timeOrder,
                    totalOrderPrice: orderData.totalOrderPrice,
                    orderImg: orderData.orderImg,
                    cart: orderData.cart,
                    paidStatus: orderData.paidStatus,
                    discount: orderData.discount,
                    selectedDateReadable: orderData.selectedDateReadable,
                    note: orderData.note
                };
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        pushOrderToTrash: function pushOrderToTrash() {
            var vm = this;
            var answer = confirm("האם אתה בטוח להעביר את ההזמנה לפח?");
            if (answer) {
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({
                    status: "נמחקה"
                });
                alert("ההמזנה הועברה לאשפה!");
            }
        },
        editInfoFun: function editInfoFun() {
            var vm = this;
            // vm.editInfo = true;
            if (vm.editInfo) {
                vm.editInfo = false;
            } else {
                vm.editInfo = true;
            }
        },
        editDatesFun: function editDatesFun() {
            var vm = this;
            if (vm.editDates) {
                vm.editDates = false;
            } else {
                vm.editDates = true;
            }
        },
        editCart: function editCart() {
            var vm = this;
            if (vm.editCartItems) {
                vm.editCartItems = false;
            } else {
                vm.editCartItems = true;
            }
        },
        addToCart: function addToCart() {
            var vm = this;
            if (vm.ProductsModal) {
                vm.ProductsModal = false;
            } else {
                vm.ProductsModal = true;
            }
        },
        closeModal: function closeModal() {
            var vm = this;
            if (vm.ProductsModal) {
                vm.ProductsModal = false;
            }
        },
        pushToCart: function pushToCart(item) {
            var vm = this;
            var selectedCount = 1;
            var existingItem = vm.orderOBJ.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            vm.productObj = item;
            console.log(vm.productObj);
            if (existingItem) {
                existingItem.selectedCount++;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            } else {
                vm.orderOBJ.cart.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { selectedCount: 1 }));
                var _newQuantity = item.Data.Quantity - 1;
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity;
                    __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            vm.orderOBJ.totalOrderPrice += item.Data.Price;
            console.log(vm.orderOBJ.cart);
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({
                cart: vm.orderOBJ.cart,
                totalOrderPrice: vm.orderOBJ.totalOrderPrice

            });
        },
        deleteItemFromCart: function deleteItemFromCart(item, index) {
            var vm = this;
            var answer = confirm("האם אתה בטוח למחוק את המוצר הזו?");
            console.log("Delete Started!");
            console.log("Item : ", item);
            if (answer) {
                vm.orderOBJ.totalOrderPrice = vm.orderOBJ.totalOrderPrice - item.Data.Price * item.selectedCount;
                vm.orderOBJ.cart.splice(index, 1);
                __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).update({
                    cart: vm.orderOBJ.cart,
                    totalOrderPrice: vm.orderOBJ.totalOrderPrice
                });
            }
        },
        loadProducts: function loadProducts() {
            var vm = this;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* db */].collection("Products").where("category", "==", vm.selectedCategory).get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadBigCakes: function loadBigCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות מרובעות';
            vm.loadProducts();
        },
        loadCircleCakes: function loadCircleCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות עגולות';
            vm.loadProducts();
        },
        loadPasim: function loadPasim() {
            var vm = this;
            vm.selectedCategory = 'פסים ושמרים';
            vm.loadProducts();
        },
        loadHatifim: function loadHatifim() {
            var vm = this;
            vm.selectedCategory = 'חטיפים';
            vm.loadProducts();
        },
        loadshtea: function loadshtea() {
            var vm = this;
            vm.selectedCategory = 'שתיה';
            vm.loadProducts();
        },
        loadSpecialCakes: function loadSpecialCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות להזנמות';
            vm.loadProducts();
        },
        loadShmareem: function loadShmareem() {
            var vm = this;
            vm.selectedCategory = 'שמרים';
            vm.loadProducts();
        },
        loadMagashim: function loadMagashim() {
            var vm = this;
            vm.selectedCategory = 'מגשים';
            vm.loadProducts();
        },
        loadOneUse: function loadOneUse() {
            var vm = this;
            vm.selectedCategory = 'חד פעמי';
            vm.loadProducts();
        },
        loadKofsaot: function loadKofsaot() {
            var vm = this;
            vm.selectedCategory = 'קופסאות';
            vm.loadProducts();
        }
    }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Inventory',
    data: function data() {
        return {
            Products: [],
            item: {
                Name: '',
                Quantity: 0,
                Price: '',
                category: ''
            },
            totalProducts: '',
            editEnabled: false,
            EditItem: null,
            selectedCategory: null,
            succsessMsg: '',
            txtSearch: '',
            showIndex: null,
            isBackfilling: false,
            backfillReport: "",
            isFixing: false

        };
    },
    created: function created() {
        var vm = this;
        vm.loadProducts();
    },

    computed: {
        filteredProducts: function filteredProducts() {
            var vm = this;
            if (vm.txtSearch.length > 0) {
                var Products = [];
                for (var i = 0; i < vm.Products.length; i++) {
                    var t = vm.Products[i];
                    var found = false;
                    if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
                        found = true;
                    }
                    if (found) {
                        Products.push(t);
                    }
                }
                return Products;
            } else {
                return vm.Products;
            }
        }
    },

    methods: {
        fixOrderedTimesForAllProducts: function fixOrderedTimesForAllProducts() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var db, snapshot, batch, operations, totalUpdated, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, data;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                db = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore();

                                _this.isFixing = true;

                                _context.prev = 2;
                                _context.next = 5;
                                return db.collection("Products").get();

                            case 5:
                                snapshot = _context.sent;
                                batch = db.batch();
                                operations = 0;
                                totalUpdated = 0;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 12;
                                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(snapshot.docs);

                            case 14:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 26;
                                    break;
                                }

                                doc = _step.value;
                                data = doc.data(); // 🔥 هذا السطر كان ناقص

                                if (data.orderedTimes === undefined) {
                                    batch.update(doc.ref, {
                                        orderedTimes: 0
                                    });

                                    operations++;
                                    totalUpdated++;
                                }

                                if (!(operations === 400)) {
                                    _context.next = 23;
                                    break;
                                }

                                _context.next = 21;
                                return batch.commit();

                            case 21:
                                batch = db.batch();
                                operations = 0;

                            case 23:
                                _iteratorNormalCompletion = true;
                                _context.next = 14;
                                break;

                            case 26:
                                _context.next = 32;
                                break;

                            case 28:
                                _context.prev = 28;
                                _context.t0 = _context["catch"](12);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 32:
                                _context.prev = 32;
                                _context.prev = 33;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 35:
                                _context.prev = 35;

                                if (!_didIteratorError) {
                                    _context.next = 38;
                                    break;
                                }

                                throw _iteratorError;

                            case 38:
                                return _context.finish(35);

                            case 39:
                                return _context.finish(32);

                            case 40:
                                if (!(operations > 0)) {
                                    _context.next = 43;
                                    break;
                                }

                                _context.next = 43;
                                return batch.commit();

                            case 43:

                                alert("\u2705 \u062A\u0645 \u062A\u062D\u062F\u064A\u062B " + totalUpdated + " \u0645\u0646\u062A\u062C");
                                _context.next = 50;
                                break;

                            case 46:
                                _context.prev = 46;
                                _context.t1 = _context["catch"](2);

                                console.error(_context.t1);
                                alert("❌ صار خطأ");

                            case 50:
                                _context.prev = 50;

                                _this.isFixing = false;
                                return _context.finish(50);

                            case 53:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 46, 50, 53], [12, 28, 32, 40], [33,, 35, 39]]);
            }))();
        },
        backfillImageFieldForAllProducts: function backfillImageFieldForAllProducts() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var vm, answer, COLLECTION, FIELD_NAME, DEFAULT_VALUE, PAGE_SIZE;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                vm = _this2;
                                answer = confirm("سيتم إضافة שדה imageUrl לכל المنتجات اللي ناقصها. متأكد؟");

                                if (answer) {
                                    _context4.next = 4;
                                    break;
                                }

                                return _context4.abrupt("return");

                            case 4:

                                vm.isBackfilling = true;
                                vm.backfillReport = "";

                                COLLECTION = "Products";
                                FIELD_NAME = "imageUrl";
                                DEFAULT_VALUE = "https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-no-image-available-icon-flatvector-illustration-pic-design-profile-vector-png-image_40966566.jpg"; // حط رابط placeholder إذا بدك

                                PAGE_SIZE = 450; // أقل من 500 للراحة

                                _context4.prev = 10;
                                return _context4.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                                    var lastDoc, totalUpdated, totalSkipped, totalScanned, _loop, _ret2;

                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    lastDoc = null;
                                                    totalUpdated = 0;
                                                    totalSkipped = 0;
                                                    totalScanned = 0;
                                                    _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop() {
                                                        var query, snap, batch, ops;
                                                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                                                            while (1) {
                                                                switch (_context2.prev = _context2.next) {
                                                                    case 0:
                                                                        query = __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection(COLLECTION).orderBy(__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore.FieldPath.documentId()).limit(PAGE_SIZE);


                                                                        if (lastDoc) query = query.startAfter(lastDoc);

                                                                        _context2.next = 4;
                                                                        return query.get();

                                                                    case 4:
                                                                        snap = _context2.sent;

                                                                        if (!snap.empty) {
                                                                            _context2.next = 7;
                                                                            break;
                                                                        }

                                                                        return _context2.abrupt("return", "break");

                                                                    case 7:
                                                                        batch = __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].batch();
                                                                        ops = 0;


                                                                        snap.docs.forEach(function (doc) {
                                                                            var _batch$update;

                                                                            totalScanned++;
                                                                            var data = doc.data() || {};
                                                                            var hasField = Object.prototype.hasOwnProperty.call(data, FIELD_NAME);

                                                                            if (hasField) {
                                                                                totalSkipped++;
                                                                                return;
                                                                            }

                                                                            batch.update(doc.ref, (_batch$update = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_batch$update, FIELD_NAME, DEFAULT_VALUE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_batch$update, "updatedAt", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore.FieldValue.serverTimestamp()), _batch$update));

                                                                            totalUpdated++;
                                                                            ops++;
                                                                        });

                                                                        if (!(ops > 0)) {
                                                                            _context2.next = 13;
                                                                            break;
                                                                        }

                                                                        _context2.next = 13;
                                                                        return batch.commit();

                                                                    case 13:

                                                                        lastDoc = snap.docs[snap.docs.length - 1];

                                                                        // تحديث report للمستخدم
                                                                        vm.backfillReport = "Checked: " + totalScanned + " | Updated: " + totalUpdated + " | Skipped: " + totalSkipped;

                                                                        if (!(snap.size < PAGE_SIZE)) {
                                                                            _context2.next = 17;
                                                                            break;
                                                                        }

                                                                        return _context2.abrupt("return", "break");

                                                                    case 17:
                                                                    case "end":
                                                                        return _context2.stop();
                                                                }
                                                            }
                                                        }, _loop, _this2);
                                                    });

                                                case 5:
                                                    if (false) {
                                                        _context3.next = 12;
                                                        break;
                                                    }

                                                    return _context3.delegateYield(_loop(), "t0", 7);

                                                case 7:
                                                    _ret2 = _context3.t0;

                                                    if (!(_ret2 === "break")) {
                                                        _context3.next = 10;
                                                        break;
                                                    }

                                                    return _context3.abrupt("break", 12);

                                                case 10:
                                                    _context3.next = 5;
                                                    break;

                                                case 12:

                                                    alert("\u2705 \u062A\u0645!\n\u062A\u0645 \u0641\u062D\u0635: " + totalScanned + "\n\u062A\u0645 \u062A\u062D\u062F\u064A\u062B: " + totalUpdated + "\n\u062A\u0645 \u062A\u062E\u0637\u064A: " + totalSkipped);

                                                    // إذا بدك تعيد تحميل المنتجات بعد التحديث:
                                                    vm.loadProducts();

                                                case 14:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee2, _this2);
                                })(), "t0", 12);

                            case 12:
                                _context4.next = 18;
                                break;

                            case 14:
                                _context4.prev = 14;
                                _context4.t1 = _context4["catch"](10);

                                console.error(_context4.t1);
                                alert("❌ خطأ: " + (_context4.t1.message || _context4.t1));

                            case 18:
                                _context4.prev = 18;

                                vm.isBackfilling = false;
                                return _context4.finish(18);

                            case 21:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee3, _this2, [[10, 14, 18, 21]]);
            }))();
        },
        deleteItem: function deleteItem(item) {
            var vm = this;
            console.log("Product Id is : ", item.ID);
            var answer = confirm("האם אתה בטוח למחוק המוצר?");

            if (answer) {
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).delete().then(function () {
                    console.log("Document successfully deleted!");
                    vm.loadProducts();
                }).catch(function (error) {
                    console.error("Error removing document: ", error);
                });
            }
        },

        // addToArray(){
        //     this.testsArray.push(this.test);
        //     console.log(this.testsArray);
        // },
        // addfield(){
        //     let vm = this;

        //     db.collection("Products").get().then((querySnapshot) => {
        //     querySnapshot.forEach((doc) => {
        //         doc.ref.update({orderedTimes: 0})
        //     })
        //     console.log("Success")
        //     })
        // },
        loadProducts: function loadProducts() {
            var vm = this;
            vm.Products = [];
            if (vm.selectedCategory == null) {
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").get().then(function (result) {
                    for (var a = 0; a < result.size; a++) {
                        var itemId = result.docs[a].id;
                        var item = result.docs[a].data();
                        // console.log(orderResult.size);
                        vm.Products.push({
                            ID: itemId,
                            Data: item

                        });
                    }
                    vm.totalProducts = result.size;
                }).catch(function (error) {
                    console.log("Error Loading Products", error);
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").where("category", "==", vm.selectedCategory).get().then(function (result) {
                    for (var a = 0; a < result.size; a++) {
                        var itemId = result.docs[a].id;
                        var item = result.docs[a].data();
                        // console.log(orderResult.size);
                        vm.Products.push({
                            ID: itemId,
                            Data: item

                        });
                    }
                    vm.totalProducts = result.size;
                }).catch(function (error) {
                    console.log("Error Loading Products", error);
                });
            }
        },
        loadBigCakes: function loadBigCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות מרובעות';
            vm.loadProducts();
        },
        loadCircleCakes: function loadCircleCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות עגולות';
            vm.loadProducts();
        },
        loadPasim: function loadPasim() {
            var vm = this;
            vm.selectedCategory = 'פסים ושמרים';
            vm.loadProducts();
        },
        loadHatifim: function loadHatifim() {
            var vm = this;
            vm.selectedCategory = 'חטיפים';
            vm.loadProducts();
        },
        loadshtea: function loadshtea() {
            var vm = this;
            vm.selectedCategory = 'שתיה';
            vm.loadProducts();
        },
        loadSpecialCakes: function loadSpecialCakes() {
            var vm = this;
            vm.selectedCategory = 'עוגות להזנמות';
            vm.loadProducts();
        },
        loadShmareem: function loadShmareem() {
            var vm = this;
            vm.selectedCategory = 'שמרים';
            vm.loadProducts();
        },
        loadMagashim: function loadMagashim() {
            var vm = this;
            vm.selectedCategory = 'מגשים';
            vm.loadProducts();
        },
        loadOneUse: function loadOneUse() {
            var vm = this;
            vm.selectedCategory = 'חד פעמי';
            vm.loadProducts();
        },
        loadKofsaot: function loadKofsaot() {
            var vm = this;
            vm.selectedCategory = 'קופסאות';
            vm.loadProducts();
        },
        sendProduct: function sendProduct() {
            var vm = this;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").add(vm.item).then(function (result) {
                console.log("Product has been added", result);
                vm.item = {
                    Name: '',
                    Quantity: 0,
                    Price: '',
                    category: '',
                    imageUrl: ''

                };
                vm.loadProducts();
                vm.succsessMsg = "המוצר נוסף בהצלחה";
            }).catch(function (error) {
                console.log("Error adding Products", error);
            });
        },
        updateProduct: function updateProduct(item) {
            var vm = this;
            var newQuantity = item.Data.Quantity;
            __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                var orderData = order.data();
                orderData.Quantity = newQuantity;
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity);
                // alert("הכמות במלאי עודכנה בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        editProductData: function editProductData(index) {
            var vm = this;
            vm.showIndex = index;
            console.log("Edit Enabled");

            if (!vm.editEnabled) {
                vm.editEnabled = true;
                vm.showIndex = index;
            } else {
                vm.editEnabled = false;
                vm.showIndex = null;
            }
        },
        editProduct: function editProduct(item) {
            var vm = this;
            var newProductName = item.Data.Name;
            var newProductPrice = item.Data.Price;
            __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                var orderData = order.data();
                orderData.Name = newProductName;
                orderData.Price = newProductPrice;
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                console.log("Data successfully updated ");
                vm.editEnabled = false;
                vm.showIndex = null;
                // alert("הכמות במלאי עודכנה בהצלחה");
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        reduceProduct: function reduceProduct(item) {
            item.Data.Quantity--;
            var vm = this;
            var newQuantity = item.Data.Quantity;
            __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                var orderData = order.data();
                orderData.Quantity = newQuantity;
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity);
            }).catch(function (error) {
                console.log("Error :", error);
            });
        },
        increaseProduct: function increaseProduct(item) {
            item.Data.Quantity++;
            var vm = this;
            var newQuantity = item.Data.Quantity;
            __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                var orderData = order.data();
                orderData.Quantity = newQuantity;
                __WEBPACK_IMPORTED_MODULE_6__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity);
            }).catch(function (error) {
                console.log("Error :", error);
            });
        }
    }

});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_he__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Suppliers',
    data: function data() {
        return {
            Dealers: []

        };
    },
    created: function created() {
        var vm = this;
        if (vm.$root.loggedUser.Type !== 'Admin') {
            alert("אין לך גישה לדף הזה");
            vm.$router.go(-1);
            // vm.$router.back();
        }
        vm.loadDealers();
    },

    methods: {
        loadDealers: function loadDealers() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].collection("Dealers").where("type", "!=", "עובד").onSnapshot(function (querySnapshot) {
                vm.Dealers = [];
                querySnapshot.forEach(function (doc) {
                    var dealerId = doc.id;
                    var dealer = doc.data();
                    vm.dealersCount = doc.size;
                    vm.Dealers.push({ ID: dealerId, Data: dealer });
                });
            });
        },
        deleteDealer: function deleteDealer(dealer) {
            var vm = this;

            var answer = confirm("האם אתה בטוח למחוק הספק?");

            if (answer) {
                __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].collection("Dealers").doc(dealer.ID).delete().then(function () {
                    console.log("Document successfully deleted!");
                    vm.loadDealers();
                }).catch(function (error) {
                    console.error("Error removing document: ", error);
                });
            }
        },
        updateAllSuppliers: function updateAllSuppliers() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var snapshot, batch;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].collection('Dealers').get();

                            case 2:
                                snapshot = _context.sent;
                                batch = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].batch();


                                snapshot.forEach(function (doc) {
                                    var ref = doc.ref;
                                    batch.update(ref, {
                                        notes: '',
                                        totalPurchases: 0,
                                        totalPayments: 0,
                                        balance: 0,
                                        lastActivity: null
                                    });
                                });

                                _context.next = 7;
                                return batch.commit();

                            case 7:
                                console.log("تم تحديث كل الموردين بنجاح");

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        addTransactionToSupplier: function addTransactionToSupplier(supplierId, transactionData) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _transactionData;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _transactionData = {
                                    type: '', // أو 'payment'
                                    description: '',
                                    quantity: 0,
                                    unitPrice: 0,
                                    totalAmount: 0,
                                    paymentMethod: '',
                                    transactionRef: '',
                                    attachmentURL: '', // رابط صورة لو موجود
                                    date: new Date()
                                };
                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* db */].collection('Dealers').doc(supplierId).collection('transactions').add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _transactionData, {
                                    createdAt: __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore.FieldValue.serverTimestamp()
                                }));

                            case 4:

                                console.log("تمت إضافة العملية للمورد بنجاح");
                                _context2.next = 10;
                                break;

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](0);

                                console.error("خطأ أثناء الإضافة:", _context2.t0);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[0, 7]]);
            }))();
        },
        goToLedger: function goToLedger(id) {
            console.log(id);
            this.$router.push({ name: 'SupplierLedger', params: { id: id } });
        },
        addTestTransaction: function addTestTransaction() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var supplierId, db;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                supplierId = '65r08EY2Tj7BZTyWQiDj';
                                db = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore();
                                _context3.next = 4;
                                return db.collection('Dealers').doc(supplierId).collection('transactions').add({
                                    type: 'purchase',
                                    description: 'شراء تجريبي - سكر وطحين',
                                    quantity: 5,
                                    unitPrice: 20,
                                    totalAmount: 100,
                                    paymentMethod: 'كاش',
                                    transactionRef: 'TEST123',
                                    attachmentURL: '',
                                    date: new Date(),
                                    createdAt: __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].firestore.FieldValue.serverTimestamp()
                                });

                            case 4:

                                console.log("✅ تم إضافة المعاملة التجريبية");

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',
  data: function data() {
    return {};
  },


  methods: {}
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Media',
    data: function data() {
        return {
            txtSearch: '',
            images: []
        };
    },
    created: function created() {
        var vm = this;
        vm.loadImages();
    },

    methods: {
        loadImages: function loadImages() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Media").orderBy('date', 'asc').get().then(function (result) {
                for (var i = 0; i < result.size; i++) {
                    var image = result.docs[i].data();
                    var imageId = result.docs[i].id;
                    vm.images.push({ ID: imageId, Data: image });
                }
            }).catch(function (error) {
                console.log("Error loading Images >>>", error);
            });
        },
        printDiv: function printDiv(divId) {
            var printContents = document.getElementById(divId).innerHTML;
            var originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;

            window.print();

            document.body.innerHTML = originalContents;
        }
    }

});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_orderCard_vue__ = __webpack_require__(88);
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Trash',
    components: {
        orderCard: __WEBPACK_IMPORTED_MODULE_4__components_orderCard_vue__["a" /* default */]
    },
    data: function data() {
        return {
            txtSearch: '',
            orders: []

        };
    },
    created: function created() {
        var vm = this;
        vm.loadOrdersFromTrash();
    },

    methods: {
        loadOrdersFromTrash: function loadOrdersFromTrash() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").where("status", "==", "נמחקה").get().then(function (result) {
                for (var i = 0; i < result.size; i++) {
                    var _order = result.docs[i].data();
                    var orderId = result.docs[i].id;
                    vm.orders.push({ ID: orderId, Data: _order });
                }
                console.log("Success");
            }).catch(function (error) {
                console.log("Error loading Orders >>>", error);
            });
        }
    }

});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_firestore__ = __webpack_require__(74);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cheques',

  data: function data() {
    return {
      checks: [],
      selectedMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 1),

      searchQuery: '',
      bankFilter: '',
      statusFilter: '',

      showAddForm: false,
      saving: false,
      loading: false,
      formError: '',
      pageError: '',

      updatingIds: [],
      deletingIds: [],

      newCheque: {
        dealerName: '',
        amount: '',
        date: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),
        bank: '',
        notes: ''
      }
    };
  },


  computed: {
    selectedMonthLabel: function selectedMonthLabel() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedMonth).locale('he').format('MMMM YYYY');
    },
    filteredChecks: function filteredChecks() {
      var _this = this;

      var query = String(this.searchQuery || '').toLowerCase();

      return this.checks.filter(function (cheque) {
        var name = String(cheque.dealerName || '').toLowerCase();
        var amount = String(cheque.amount == null ? '' : cheque.amount);
        var bank = _this.normalizeBank(cheque.bank);

        var matchesSearch = !query || name.includes(query) || amount.includes(query);

        var matchesBank = !_this.bankFilter || (_this.bankFilter === 'unknown' ? !bank : bank === _this.bankFilter);

        var matchesStatus = !_this.statusFilter || (_this.statusFilter === 'checked' ? !!cheque.checked : !cheque.checked);

        return matchesSearch && matchesBank && matchesStatus;
      });
    },
    stats: function stats() {
      var _this2 = this;

      var checks = Array.isArray(this.checks) ? this.checks : [];

      var totalAmount = checks.reduce(function (sum, cheque) {
        return sum + (Number(cheque.amount) || 0);
      }, 0);

      var checkedChecks = checks.filter(function (cheque) {
        return !!cheque.checked;
      });
      var pendingChecks = checks.filter(function (cheque) {
        return !cheque.checked;
      });

      var checkedAmount = checkedChecks.reduce(function (sum, cheque) {
        return sum + (Number(cheque.amount) || 0);
      }, 0);

      var pendingAmount = pendingChecks.reduce(function (sum, cheque) {
        return sum + (Number(cheque.amount) || 0);
      }, 0);

      var leumiChecks = checks.filter(function (cheque) {
        return _this2.normalizeBank(cheque.bank) === 'leumi';
      });

      var discountChecks = checks.filter(function (cheque) {
        return _this2.normalizeBank(cheque.bank) === 'discount';
      });

      var leumiAmount = leumiChecks.reduce(function (sum, cheque) {
        return sum + (Number(cheque.amount) || 0);
      }, 0);

      var discountAmount = discountChecks.reduce(function (sum, cheque) {
        return sum + (Number(cheque.amount) || 0);
      }, 0);

      return {
        totalAmount: totalAmount,
        totalCount: checks.length,
        checkedAmount: checkedAmount,
        checkedCount: checkedChecks.length,
        pendingAmount: pendingAmount,
        pendingCount: pendingChecks.length,
        averageAmount: checks.length ? totalAmount / checks.length : 0,
        leumiAmount: leumiAmount,
        leumiCount: leumiChecks.length,
        discountAmount: discountAmount,
        discountCount: discountChecks.length
      };
    }
  },

  mounted: function mounted() {
    this.fetchChecksForMonth();
  },


  methods: {
    normalizeBank: function normalizeBank(bank) {
      var value = String(bank || '').trim().toLowerCase();

      if (!value) return '';

      if (value === 'leumi' || value.includes('לאומי')) return 'leumi';
      if (value === 'discount' || value.includes('דיסקונט')) return 'discount';

      return value;
    },
    bankLabel: function bankLabel(bank) {
      var normalized = this.normalizeBank(bank);

      if (normalized === 'leumi') return 'בנק לאומי';
      if (normalized === 'discount') return 'בנק דיסקונט';

      return 'בנק לא צוין';
    },
    bankClass: function bankClass(bank) {
      var normalized = this.normalizeBank(bank);

      if (normalized === 'leumi') return 'bank-leumi';
      if (normalized === 'discount') return 'bank-discount';

      return 'bank-unknown';
    },
    formatAmount: function formatAmount(value) {
      return (Number(value) || 0).toLocaleString('he-IL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    changeMonth: function changeMonth(offset) {
      this.selectedMonth = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + offset, 1);

      this.fetchChecksForMonth();
    },
    goToCurrentMonth: function goToCurrentMonth() {
      var today = new Date();
      this.selectedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.fetchChecksForMonth();
    },
    fetchChecksForMonth: function fetchChecksForMonth() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var year, month, startDate, endDate, snapshot, loadedChecks;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.loading = true;
                _this3.pageError = '';

                year = _this3.selectedMonth.getFullYear();
                month = _this3.selectedMonth.getMonth();
                startDate = new Date(year, month, 1);
                endDate = new Date(year, month + 1, 1);
                _context.prev = 6;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection('cheques').where('date', '>=', __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(startDate)).where('date', '<', __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(endDate)).get();

              case 9:
                snapshot = _context.sent;
                loadedChecks = [];


                snapshot.forEach(function (doc) {
                  var data = doc.data() || {};
                  var rawDate = data.date;

                  var formattedDate = '';

                  if (rawDate && typeof rawDate.toDate === 'function') {
                    formattedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(rawDate.toDate()).format('YYYY-MM-DD');
                  } else if (rawDate instanceof Date) {
                    formattedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(rawDate).format('YYYY-MM-DD');
                  } else if (rawDate) {
                    formattedDate = String(rawDate);
                  }

                  loadedChecks.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data, {
                    id: doc.id,
                    date: formattedDate,
                    amount: Number(data.amount) || 0,
                    checked: !!data.checked
                  }));
                });

                loadedChecks.sort(function (a, b) {
                  return String(a.date).localeCompare(String(b.date));
                });
                _this3.checks = loadedChecks;
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](6);

                console.error('Error loading cheques:', _context.t0);
                _this3.pageError = 'טעינת השיקים נכשלה. בדוק את החיבור והרשאות Firebase.';

              case 20:
                _context.prev = 20;

                _this3.loading = false;
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[6, 16, 20, 23]]);
      }))();
    },
    addCheque: function addCheque() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dealerName, amount, dateString, dateObject, cheque;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.formError = '';

                dealerName = String(_this4.newCheque.dealerName || '').trim();
                amount = Number(_this4.newCheque.amount);
                dateString = _this4.newCheque.date;

                if (!(!dealerName || !dateString || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(amount) || amount <= 0)) {
                  _context2.next = 7;
                  break;
                }

                _this4.formError = 'נא למלא שם ספק, סכום ותאריך תקינים.';
                return _context2.abrupt('return');

              case 7:
                dateObject = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateString, 'YYYY-MM-DD', true);

                if (dateObject.isValid()) {
                  _context2.next = 11;
                  break;
                }

                _this4.formError = 'תאריך השיק אינו תקין.';
                return _context2.abrupt('return');

              case 11:

                _this4.saving = true;

                _context2.prev = 12;
                cheque = {
                  dealerName: dealerName,
                  amount: amount,
                  date: __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(dateObject.toDate()),
                  formattedDate: dateString,
                  createdDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()().locale('he').format('L'),
                  checked: false,
                  notes: String(_this4.newCheque.notes || '').trim()
                };


                if (_this4.newCheque.bank) {
                  cheque.bank = _this4.newCheque.bank;
                }

                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection('cheques').add(cheque);

              case 17:

                _this4.newCheque = {
                  dealerName: '',
                  amount: '',
                  date: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),
                  bank: '',
                  notes: ''
                };

                _this4.showAddForm = false;

                // אם השיק أضيف لشهر آخر، انتقل إلى شهره حتى يظهر مباشرة.
                _this4.selectedMonth = new Date(dateObject.year(), dateObject.month(), 1);

                _context2.next = 22;
                return _this4.fetchChecksForMonth();

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](12);

                console.error('Error adding cheque:', _context2.t0);
                _this4.formError = 'שמירת השיק נכשלה. נסה שוב.';

              case 28:
                _context2.prev = 28;

                _this4.saving = false;
                return _context2.finish(28);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[12, 24, 28, 31]]);
      }))();
    },
    toggleCheque: function toggleCheque(cheque) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var previousValue, nextValue;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!cheque || !cheque.id)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                previousValue = !!cheque.checked;
                nextValue = !previousValue;


                _this5.updatingIds.push(cheque.id);
                _this5.pageError = '';

                // עדכון מיידי בממשק, עם שחזור במקרה של כישלון.
                _this5.$set(cheque, 'checked', nextValue);

                _context3.prev = 7;
                _context3.next = 10;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection('cheques').doc(cheque.id).update({
                  checked: nextValue
                });

              case 10:

                if (_this5.$root && typeof _this5.$root.loadChequesSum === 'function') {
                  _this5.$root.loadChequesSum();
                }
                _context3.next = 18;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](7);

                console.error('Error updating cheque:', _context3.t0);
                _this5.$set(cheque, 'checked', previousValue);
                _this5.pageError = 'עדכון מצב השיק נכשל. השינוי בוטל.';

              case 18:
                _context3.prev = 18;

                _this5.updatingIds = _this5.updatingIds.filter(function (id) {
                  return id !== cheque.id;
                });
                return _context3.finish(18);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[7, 13, 18, 21]]);
      }))();
    },
    deleteDealer: function deleteDealer(cheque) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!cheque || !cheque.id)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                answer = confirm('האם אתה בטוח שברצונך למחוק את השיק?');

                if (answer) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:

                _this6.deletingIds.push(cheque.id);
                _this6.pageError = '';

                _context4.prev = 7;
                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* db */].collection('cheques').doc(cheque.id).delete();

              case 10:

                _this6.checks = _this6.checks.filter(function (item) {
                  return item.id !== cheque.id;
                });

                if (_this6.$root && typeof _this6.$root.loadChequesSum === 'function') {
                  _this6.$root.loadChequesSum();
                }
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](7);

                console.error('Error deleting cheque:', _context4.t0);
                _this6.pageError = 'מחיקת השיק נכשלה.';

              case 18:
                _context4.prev = 18;

                _this6.deletingIds = _this6.deletingIds.filter(function (id) {
                  return id !== cheque.id;
                });
                return _context4.finish(18);

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[7, 14, 18, 21]]);
      }))();
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CheckList_vue__ = __webpack_require__(672);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chequesBeta',
  components: {
    CheckList: __WEBPACK_IMPORTED_MODULE_0__components_CheckList_vue__["a" /* default */]
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(74);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedMonth: null,
      monthsList: [],
      checks: [amount = 10, date = '02-02-2025']

    };
  },
  mounted: function mounted() {
    this.generateMonths();
  },

  methods: {
    generateMonths: function generateMonths() {
      var today = new Date();
      var currentYear = today.getFullYear();
      for (var yearOffset = -1; yearOffset <= 1; yearOffset++) {
        var year = currentYear + yearOffset;
        for (var i = 0; i < 12; i++) {
          this.monthsList.push(new Date(year, i, 1));
        }
      }
    },
    fetchChecksForMonth: function fetchChecksForMonth(month) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var year, monthNumber;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.selectedMonth = month;
                year = month.getFullYear();
                monthNumber = month.getMonth() + 1;
                _context.next = 5;
                return _this.getChecksForMonth(year, monthNumber);

              case 5:
                _this.checks = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getChecksForMonth: function getChecksForMonth(year, month) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var db, startDate, endDate, checksRef, querySnapshot, checks;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                db = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore();
                startDate = new Date(year, month - 1, 1);
                endDate = new Date(year, month, 0, 23, 59, 59);
                _context2.prev = 3;
                checksRef = db.collection("cheques");
                _context2.next = 7;
                return checksRef.where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(startDate)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(endDate)).get();

              case 7:
                querySnapshot = _context2.sent;
                checks = [];

                querySnapshot.forEach(function (doc) {
                  checks.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: doc.id }, doc.data()));
                });

                return _context2.abrupt("return", checks);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                console.error("خطأ في جلب الشيكات:", _context2.t0);
                return _context2.abrupt("return", []);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 13]]);
      }))();
    },
    nextSlide: function nextSlide() {
      this.$refs.slider.scrollBy({ left: 150, behavior: 'smooth' });
    },
    prevSlide: function prevSlide() {
      this.$refs.slider.scrollBy({ left: -150, behavior: 'smooth' });
    },
    formatISODateWithMonth: function formatISODateWithMonth(date) {
      var months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
      var monthName = months[date.getMonth()];
      return monthName + " - " + date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, '0');
    },
    formatDate: function formatDate(timestamp) {
      if (!timestamp) return "تاريخ غير متوفر";
      var date = timestamp.toDate();
      return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0');
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports',
  data: function data() {
    return {};
  },
  created: function created() {},
  updated: function updated() {},

  methods: {}
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_he__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'expenses',
    data: function data() {
        return {
            Cheques: [],
            totalAmount: 0,
            cheque: {
                dealerName: '',
                amount: 0,
                date: '',
                createdDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LLLL'),
                checked: false
            },
            chequeModal: false,
            errorDealer: null,
            todayItemNav: '',
            tommorowItemNav: '',
            yesterdayItemNav: ''

        };
    },
    created: function created() {
        var vm = this;
        if (vm.$root.loggedUser.Type !== 'Admin') {
            alert("אין לך גישה לדף הזה");
            vm.$router.go(-1);
        }
        vm.$root.loadExpenses();
    },


    methods: {
        addCheque: function addCheque() {
            var vm = this;
            console.log("Add ( chequeResult ) ");
            if (vm.cheque.dealerName.length > 0 && vm.cheque.date.length > 0) {
                var cheque = {
                    dealerName: vm.cheque.dealerName,
                    amount: vm.cheque.amount,
                    date: vm.cheque.date,
                    createdDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LLLL'),
                    checked: false
                };
                __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("cheques").add(cheque).then(function (chequeResult) {
                    console.log("Add ( chequeResult ) Success");
                    console.log(chequeResult);
                    vm.cheque.dealerName = "";
                    vm.cheque.amount = null;
                    vm.cheque.date = "";
                }).catch(function (error) {
                    console.error('add( chequeResult ) Error !');
                    console.error(error);
                });
            } else if (vm.cheque.dealerName.length <= 0 && vm.cheque.date.length <= 0) {
                vm.errorDealer = true;
                vm.errorAddingDealer = "נא למלא את השדה";
            }
        },
        deleteDealer: function deleteDealer(cheque) {
            var vm = this;

            var answer = confirm("האם אתה בטוח למחוק הספק?");

            if (answer) {
                __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("cheques").doc(cheque.ID).delete().then(function () {
                    vm.$root.loadChequesSum();
                    console.log("Document successfully deleted!");
                }).catch(function (error) {
                    console.error("Error removing document: ", error);
                });
            }
        },
        checkLine: function checkLine(expenseId) {
            console.log('checkLine(' + expenseId + ')');
            var vm = this;
            var isDone = true;
            for (var i = 0; i < vm.$root.Expenses.length; i++) {
                if (vm.$root.Expenses[i].ID === expenseId) {
                    if (vm.$root.Expenses[i].checked && vm.$root.Expenses[i].checked === true) {
                        isDone = false;
                    }
                    break;
                }
            }
            __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("Expenses").doc(expenseId).update({ checked: isDone }).then(function () {
                console.log("Document successfully updated!");
            }).catch(function (error) {
                console.error("Error updating document: ", error);
            });
        },
        openChequeModal: function openChequeModal() {
            var vm = this;
            if (!vm.chequeModal) {
                vm.chequeModal = true;
            } else {
                vm.chequeModal = false;
            }
        },
        closeChequeModal: function closeChequeModal() {
            var vm = this;
            if (vm.chequeModal) {
                vm.chequeModal = false;
            } else {
                vm.chequeModal = true;
            }
        },
        todayOrders: function todayOrders() {
            var vm = this;
            vm.todayItemNav = true;
            vm.tommorowItemNav = false;
            vm.yesterdayItemNav = false;
            vm.fromDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY-MM-DD");
            vm.toDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY-MM-DD");

            vm.loadCheques();
        },
        tommorowOrders: function tommorowOrders() {
            var vm = this;
            vm.tommorowItemNav = true;
            vm.todayItemNav = false;
            vm.yesterdayItemNav = false;
            vm.fromDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format("YYYY-MM-DD");
            vm.toDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format("YYYY-MM-DD");

            vm.loadCheques();
        },
        thisMonth: function thisMonth() {
            var vm = this;
            vm.tommorowItemNav = false;
            vm.todayItemNav = false;
            vm.yesterdayItemNav = false;
            vm.fromDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format("YYYY-MM-DD");
            vm.toDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format("YYYY-MM-DD");

            vm.loadCheques();
        },
        lastMonth: function lastMonth() {
            var vm = this;
            vm.tommorowItemNav = false;
            vm.todayItemNav = false;
            vm.yesterdayItemNav = false;
            vm.fromDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract("1", "months").startOf('month').format("YYYY-MM-DD");
            vm.toDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract("1", "months").endOf('month').format("YYYY-MM-DD");

            vm.loadCheques();
        },
        yesterdayOrders: function yesterdayOrders() {
            var vm = this;
            vm.yesterdayItemNav = true;
            vm.todayItemNav = false;
            vm.tommorowItemNav = false;
            vm.fromDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");
            vm.toDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'days').format("YYYY-MM-DD");

            vm.loadCheques();
        }
    }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'checkout',
    components: {
        order: __WEBPACK_IMPORTED_MODULE_7__components_Order_vue__["a" /* default */]
    },
    data: function data() {
        return {
            orders: [],
            cart: [],
            Products: [],
            fullname: "",
            phoneNumber: "",
            timeOrder: "16:00",
            dateOrder: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD"),
            dayOrder: "",
            priceOrder: "",
            cakeTaste: "",
            cakeSize: "",
            workerName: "",
            counter: {
                orderNumber: 0
            },
            orderImg: [],
            status: "התקבלה",
            min: 1000,
            activeItemBar: 1,
            activeProductsBar: 0,
            totalOrderPrice: 0,
            selectedQuantity: 1,
            productObj: "",
            note: "",
            paidStatus: "",
            discount: 0,
            orderedTimes: '',
            txtSearch: '',
            selectedCategory: ''
        };
    },
    created: function created() {
        var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
        m.locale('he');
        console.log(m.format('LLLL'));
        var vm = this;
        vm.loadOrders();
        vm.loadCounter();
        // vm.loadProductsToOrder();
    },

    computed: {
        filteredProducts: function filteredProducts() {
            var vm = this;
            if (vm.txtSearch.length > 0) {
                var Products = [];
                for (var i = 0; i < vm.Products.length; i++) {
                    var t = vm.Products[i];
                    var found = false;
                    if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
                        found = true;
                    }
                    if (found) {
                        Products.push(t);
                    }
                }
                return Products;
            } else {
                return vm.Products;
            }
        }
    },

    methods: {
        sendOrder: function sendOrder() {
            var vm = this;
            if (vm.fullname.length > 0 && vm.dayOrder.length > 0 && vm.timeOrder.length > 0 && vm.dateOrder.length > 0 && vm.paidStatus.length > 0) {
                var _order = {
                    fullname: vm.fullname,
                    phoneNumber: vm.phoneNumber,
                    orderImg: vm.orderImg,
                    dayOrder: vm.dayOrder,
                    timeOrder: vm.timeOrder,
                    dateOrder: vm.dateOrder,
                    totalOrderPrice: vm.totalOrderPrice,
                    status: vm.status,
                    createdDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('LLLL'),
                    orderNumber: vm.counter.orderNumber,
                    cart: vm.cart,
                    note: vm.note,
                    paidStatus: vm.paidStatus,
                    discount: vm.discount
                };
                if (vm.phoneNumber.length == 10) {
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").set(vm.counter).then(function (result) {
                        vm.loadCounter();
                        console.log("Counter Updated");
                    }).catch(function (error) {
                        console.log("Error");
                    });

                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").add(_order).then(function (orderResult) {
                        vm.fullname = "";
                        vm.phoneNumber = "";
                        vm.timeOrder = "";
                        vm.dateOrder = "";
                        vm.dayOrder = "";
                        vm.priceOrder = "";
                        vm.orderImg = [];
                        vm.cart = [];
                        vm.status = "התקבלה", vm.orderNumber = "", vm.paidStatus = "", vm.note = "", vm.discount = 0, vm.totalOrderPrice = 0;
                        console.log("Add Order Success");
                        console.log(orderResult);
                    }).catch(function (error) {
                        console.error('add(order) Error !');
                        console.error(error);
                    });
                } else {
                    alert("מספר הטלפון חייב להכיל 10 ספרות בלבד");
                }
            } else if (vm.fullname.length <= 0 || vm.dayOrder.length <= 0 || vm.timeOrder.length <= 0 || vm.dateOrder.length <= 0 || vm.paidStatus.length <= 0) {
                alert("חובה למלא את כל השדות!");
            }
        },
        uploadImage: function uploadImage(e) {
            var _this = this;

            if (e.target.files[0]) {
                var _file = e.target.files[0];
                var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].storage().ref('orders/' + _file.name);
                var uploadTask = storageRef.put(_file);
                uploadTask.on('state_changed', function (snapshot) {}, function (error) {
                    // Handle unsuccessful uploads
                }, function () {
                    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        _this.orderImg.push(downloadURL);
                        var media = {
                            date: new Date().toLocaleDateString(),
                            image: "",
                            fullname: _this.fullname,
                            orderNumber: _this.counter.orderNumber
                        };
                        media.image = downloadURL;
                        console.log(media);
                        __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Media").add(media);
                        console.log('File available at', downloadURL);
                    });
                });
            }
        },
        downloadFullExample: function downloadFullExample() {
            var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].storage().ref();

            // [START storage_download_full_example]
            // Create a reference to the file we want to download
            var starsRef = storageRef.child('orders/' + file.name);

            // Get the download URL
            starsRef.getDownloadURL().then(function (url) {
                // Insert url into an <img> tag to "download"
            }).catch(function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/object-not-found':
                        // File doesn't exist
                        break;
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    // ...

                    case 'storage/unknown':
                        // Unknown error occurred, inspect the server response
                        break;
                }
            });
            // [END storage_download_full_example]
        },
        loadOrders: function loadOrders() {
            var vm = this;
            vm.orders = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("orders").orderBy("createdDate", "desc").get().then(function (orderResult) {
                for (var a = 0; a < orderResult.size; a++) {
                    var orderId = orderResult.docs[a].id;
                    var _order2 = orderResult.docs[a].data();
                    console.log(orderResult.size);
                    vm.orders.push({ ID: orderId, Data: _order2 });
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        loadCounter: function loadCounter() {
            var vm = this;
            console.log("loadCounter()");
            // db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").get().then((doc) =>{
            //     // console.log("doc.exist =" + doc.exists);
            //     if (doc.exists){
            //         vm.counter = doc.data();
            //         console.log("vm.orderNumber =" + JSON.stringify(vm.counter));
            //         if(vm.counter.orderNumber < vm.min){
            //             vm.counter.orderNumber = vm.min;
            //         }
            //         else{
            //             vm.counter.orderNumber++;
            //         }
            //     }
            // }).catch((err) => {
            //     console.log("Error", err);
            // })

            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").onSnapshot(function (doc) {
                if (doc.exists) {
                    vm.counter = doc.data();
                    console.log("vm.orderNumber =" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.counter));
                    if (vm.counter.orderNumber < vm.min) {
                        vm.counter.orderNumber = vm.min;
                    } else {
                        vm.counter.orderNumber++;
                    }
                }
            });
        },
        loadProductsToOrder: function loadProductsToOrder() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגות מרובעות').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadCircleCakes: function loadCircleCakes() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגות עגולות').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadBiscuit: function loadBiscuit() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'עוגיות').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadPasim: function loadPasim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'פסים').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadCoufsaot: function loadCoufsaot() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'קופסאות').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadMghashim: function loadMghashim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'מגשים').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadOneUse: function loadOneUse() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'חד פעמי').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadDrinks: function loadDrinks() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'שתיה').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadHataifim: function loadHataifim() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'חטיפים').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        loadBakingCakes: function loadBakingCakes() {
            var vm = this;
            vm.activeProductsBar = 1;
            vm.Products = [];
            __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").where('category', '==', 'שמרים').orderBy("orderedTimes", "desc").get().then(function (result) {
                for (var a = 0; a < result.size; a++) {
                    var itemId = result.docs[a].id;
                    var item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                        ID: itemId,
                        Data: item

                    });
                }
                vm.totalProducts = result.size;
            }).catch(function (error) {
                console.log("Error Loading Products", error);
            });
        },
        addToArray: function addToArray(item) {
            var vm = this;
            var existingItem = vm.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            if (existingItem) {
                vm.selectedQuantity++;
            } else {
                vm.cart.push(item);
            }
            // vm.cart.push(item);

            console.log(vm.cart);
            vm.totalOrderPrice += item.Data.Price;

            // vm.cart.forEach(product => {
            // vm.totalOrderPrice += product.Data.Price;
            // })
        },
        addToCart: function addToCart(item) {
            var selectedCount = 1;

            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            this.productObj = item;
            console.log(this.productObj);
            if (existingItem) {
                existingItem.selectedCount++;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                var newOrderedTimes = item.Data.orderedTimes + existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    orderData.orderedTimes = newOrderedTimes;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                    console.log("New ordered time is :" + orderData.orderedTimes);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            } else {
                this.cart.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { selectedCount: 1 }));
                var _newQuantity = item.Data.Quantity - 1;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            this.totalOrderPrice += item.Data.Price;
            console.log(this.cart);
        },
        reduceItem: function reduceItem(item, index) {
            var existingItem = this.cart.find(function (cartItem) {
                return cartItem.ID === item.ID;
            });
            var selectedCount = 1;
            if (existingItem) {
                existingItem.selectedCount--;
                var newQuantity = item.Data.Quantity - existingItem.selectedCount;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
                if (existingItem.selectedCount == 0) {

                    var _newQuantity2 = item.Data.Quantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                        var orderData = order.data();
                        orderData.Quantity = _newQuantity2;
                        __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                        console.log("New Amoumt is :" + _newQuantity2);
                    }).catch(function (error) {
                        console.log("Error :", error);
                    });
                    this.cart.splice(index, 1);
                }
                this.totalOrderPrice -= item.Data.Price;
                console.log(this.cart);
            } else {
                var _newQuantity3 = item.Data.Quantity - existingItem.selectedCount + 1;
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = _newQuantity3;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(item.ID).update(orderData);
                    console.log("New Amoumt is :" + _newQuantity3);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
        },
        removeItem: function removeItem(product, index) {
            var selectedCount = 1;
            if (product.selectedCount >= 1) {
                var newQuantity = this.productObj.Data.Quantity;
                console.log("Product Quantity :", product.Data.Quantity);
                console.log("Product Selected Quantity :", product.selectedCount);
                __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(product.ID).get().then(function (order) {
                    var orderData = order.data();
                    orderData.Quantity = newQuantity;
                    __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */].collection("Products").doc(product.ID).update(orderData);
                    console.log("New Amoumt is :" + newQuantity);
                }).catch(function (error) {
                    console.log("Error :", error);
                });
            }
            // else if(product.selectedCount < 1){
            //     let newQuantity = product.Data.Quantity + product.selectedCount;
            //     db.collection("Products").doc(product.ID).get()
            // .then((order) =>{
            //     let orderData = order.data();
            //     orderData.Quantity = newQuantity;
            //     db.collection("Products").doc(product.ID).update(orderData);
            //     console.log("New Amoumt is :" + newQuantity) ;

            // })
            // .catch((error) =>{
            //     console.log("Error :" , error);
            // })
            // }
            // Remove the item at the specified index from the array.
            this.cart.splice(index, 1);
            this.totalOrderPrice -= product.Data.Price * product.selectedCount;
        }
    }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Order_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_orderCard_vue__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'printOrder',
  components: {
    order: __WEBPACK_IMPORTED_MODULE_5__components_Order_vue__["a" /* default */], orderCard: __WEBPACK_IMPORTED_MODULE_6__components_orderCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedorderID: this.$route.params.id,
      txtSearch: ''
    };
  },
  created: function created() {
    var vm = this;
    console.log(this.$route.params.id);
    vm.loadSingleOrder();
  },

  computed: {
    filteredOrders: function filteredOrders() {
      var vm = this;
      if (vm.txtSearch.length > 0) {
        var orders = [];
        for (var i = 0; i < vm.orders.length; i++) {
          var t = vm.orders[i];
          var found = false;
          if (t.Data.fullname.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            found = true;
          }
          if (t.Data.phoneNumber.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            found = true;
          }
          // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
          //   found = true;
          // }
          if (found) {
            orders.push(t);
          }
        }
        return orders;
      } else {
        return vm.orders;
      }
    }
  },
  methods: {
    loadSingleOrder: function loadSingleOrder() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].collection("orders").doc(vm.selectedorderID).get().then(function (order) {
        vm.isLoading = false;
        var orderData = order.data();
        var fullname = orderData.fullname;
        var orderNumber = orderData.orderNumber;
        var dayOrder = orderData.dayOrder;
        var dateOrder = orderData.dateOrder;
        var createdDate = orderData.createdDate;
        var phoneNumber = orderData.phoneNumber;
        var status = orderData.status;
        var timeOrder = orderData.timeOrder;
        var totalOrderPrice = orderData.totalOrderPrice;
        var orderImg = orderData.orderImg;
        var cart = orderData.Cart;
        var paidStatus = orderData.paidStatus;
        var discount = orderData.discount;
        // console.log(fullname);
        console.log(orderData);
        vm.orderOBJ = {
          fullname: orderData.fullname,
          orderNumber: orderData.orderNumber,
          dayOrder: orderData.dayOrder,
          dateOrder: orderData.dateOrder,
          createdDate: orderData.createdDate,
          phoneNumber: orderData.phoneNumber,
          status: orderData.status,
          timeOrder: orderData.timeOrder,
          totalOrderPrice: orderData.totalOrderPrice,
          orderImg: orderData.orderImg,
          cart: orderData.cart,
          paidStatus: orderData.paidStatus,
          discount: orderData.discount
        };
      }).catch(function (error) {
        console.log("Error :", error);
      });
    }
  }
});

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkForUpdates__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_messaging__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flaticon_flaticon_uicons_css_all_all_css__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flaticon_flaticon_uicons_css_all_all_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__flaticon_flaticon_uicons_css_all_all_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_firebase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// Import Bootstrap an BootstrapVue CSS files (order is important)


// Make BootstrapVue available throughout your project





// استدعاء مراقب التحديثات قبل إنشاء التطبيق
// setupVersionListener();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
// Make BootstrapVue available throughout your project
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["a" /* BootstrapVue */]);
// Optionally install the BootstrapVue icon components plugin
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["b" /* IconsPlugin */]);
function getPlatformInfo() {
  var ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS/.test(ua)) {
    return "iOS Safari";
  }
  if (/Android/.test(ua)) {
    return "Android";
  }
  return "Web";
};
if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].messaging.isSupported()) {
  var messaging = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].messaging();

  Notification.requestPermission().then(function (permission) {
    if (permission === 'granted') {
      return messaging.getToken({
        vapidKey: "BBpB8VEQrmGfwrz6hd3NmxVT4tdp8XY_izsV49cHeq0z4F_FSLhrlJEaKgv7SU3APGboU2dTnAx1IiHmpG3m8tM"
      });
    } else {
      console.warn("🚫 تم رفض صلاحية الإشعارات");
    }
  }).then(function (token) {
    if (token) {
      var user = JSON.parse(localStorage.getItem("User"));

      console.log("✅ Token:", token);
      alert(token);
      // احفظ الـ token في Firestore تحت collection "deviceTokens"
      __WEBPACK_IMPORTED_MODULE_12__src_firebase__["a" /* db */].collection("deviceTokens").doc(token).set({
        createdAt: new Date(),
        userID: user.userID || null,
        username: user.username || null,
        role: user.role || 'user',
        platform: getPlatformInfo()
      });
    }
  }).catch(function (err) {
    console.error("❌ فشل في جلب Token", err);
  });

  // استقبال الإشعارات داخل التطبيق
  messaging.onMessage(function (payload) {
    console.log("📬 رسالة واردة أثناء الاستخدام:", payload);

    var _payload$notification = payload.notification,
        title = _payload$notification.title,
        body = _payload$notification.body,
        image = _payload$notification.image;


    var options = {
      body: body,
      icon: '/icons/icon-192x192.png',
      image: image || undefined
    };

    // عرض الإشعار يدويًا
    if (Notification.permission === "granted") {
      new Notification(title, options);
    } else {
      console.warn("🔕 الإشعارات غير مفعّلة");
    }
  });
}

var app = '';
if (!app) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },

    data: function data() {

      return {
        selectedOrderObj: null,
        selectedOrderIndex: -1,
        orders: [],
        loggedUser: null,
        totalOrdersForToday: 0,
        Cheques: [],
        Users: [],
        totalCheques: 0,
        totalExpenses: 0,
        cheque: {
          dealerName: '',
          amount: 0,
          date: '',
          createdDate: __WEBPACK_IMPORTED_MODULE_13_moment___default()().format('LLLL'),
          checked: false,
          Expenses: [],
          fromDate: '',
          toDate: '',
          chequesSearch: '',
          chequesCounter: 0,
          chequesTrue: 0,
          chequesFalse: 0,
          userData: null,
          loggedUserData: null,
          isAuth: null

        }
      };
    },
    created: function created() {
      var user = localStorage.getItem("User");
      var vm = this;
      // console.log('The Params is: ' + vm.$route.path);
      vm.fromDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()().startOf('month').format("YYYY-MM-DD");
      vm.toDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()().endOf('month').format("YYYY-MM-DD");

      if (user && user.length > 0) {
        vm.loggedUser = JSON.parse(user);
      } else {
        vm.$router.push("/");
      }
    },

    computed: {
      filteredCheques: function filteredCheques() {
        var vm = this;
        if (vm.chequesSearch.length > 0) {
          var chequesList = [];
          for (var i = 0; i < vm.Cheques.length; i++) {
            var t = vm.Cheques[i];
            var found = false;
            if (t.Data.dealerName.toUpperCase().indexOf(vm.chequesSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (t.Data.amount.toUpperCase().indexOf(vm.chequesSearch.toUpperCase()) > -1) {
              found = true;
            }
            // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            //   found = true;
            // }
            if (found) {
              chequesList.push(t);
            }
          }
          return chequesList;
        } else {
          return vm.Cheques;
        }
      }
    },
    methods: {
      logout: function logout() {
        // console.log("Logout Click");
        var vm = this;

        vm.loggedUser = null;
        localStorage.removeItem("User");
        vm.$router.push("/");
      },

      // getUserData(){
      //   let vm = this;
      //   console.log(vm.loggedUser)
      //   db.collection("Users").doc(vm.loggedUser).get()
      //   .then((result) => {
      //     if(result.size > 0){
      //       result.forEach((doc) => {
      //         let user = doc.data();
      //         console.log(user)
      //       })
      //     }

      //   }).catch((err) => {
      //         console.log("Error : ");

      //       });

      // },
      getUserData: function getUserData() {

        var vm = this;
        // console.log("Loading user data >>>" , vm.loggedUser);

        __WEBPACK_IMPORTED_MODULE_12__src_firebase__["a" /* db */].collection("Users").doc(vm.loggedUser.userID).onSnapshot(function (doc) {
          if (doc.exists) {
            var userData = doc.data();
            // console.log("vm.userData =" + JSON.stringify(userData));
            if (userData.active == false) {
              vm.$router.push("/");
            }
          }
        });
        // db.collection("Users").doc(vm.loggedUser).get().then((result)=>{
        //   for(let a = 0; a < result.size; a++){
        //     let userId = result.docs[a].id;
        //     let user = result.docs[a].data();
        //     //
        //     console.log(user)
        //     vm.Users.push({
        //       ID: userId,
        //       username: user.dealerName,
        //       active: user.active,
        //       firstName: user.firstName,
        //       lastName: user.lastName,
        //       profileImg: user.profileImg,
        //       password: user.password,
        //       });


        //   }
        // }).catch((error)=>{
        //   console.log("Error Loading User", error)
        // })
      },
      loadChequesSum: function loadChequesSum() {
        var vm = this;
        vm.Cheques = [];
        vm.totalCheques = 0;
        vm.chequesCounter = 0;
        vm.chequesFalse = 0;
        vm.chequesTrue = 0;
        __WEBPACK_IMPORTED_MODULE_12__src_firebase__["a" /* db */].collection("cheques").where('date', '>=', vm.fromDate).where('date', '<=', vm.toDate).orderBy("date", "desc").get().then(function (result) {
          for (var a = 0; a < result.size; a++) {
            var chequeId = result.docs[a].id;
            var cheque = result.docs[a].data();
            vm.Cheques.push({
              ID: chequeId,
              dealerName: cheque.dealerName,
              amount: cheque.amount,
              date: cheque.date,
              createdDate: cheque.createdDate,
              checked: cheque.checked
            });
            vm.totalCheques = vm.totalCheques += cheque.amount;
            vm.chequesCounter = result.size;
            if (cheque.checked == false) {
              vm.chequesFalse = vm.chequesFalse += cheque.amount;
            }
            if (cheque.checked == true) {
              vm.chequesTrue = vm.chequesTrue += cheque.amount;
            }

            // console.log(vm.totalCheques)
          }
        }).catch(function (error) {
          console.log("Error Loading Products", error);
        });
      },
      loadExpenses: function loadExpenses() {
        var vm = this;
        vm.Expenses = [];
        vm.totalExpenses = 0;
        __WEBPACK_IMPORTED_MODULE_12__src_firebase__["a" /* db */].collection("Expenses").where('date', '>=', vm.fromDate).where('date', '<=', vm.toDate).orderBy("date", "desc").get().then(function (result) {
          for (var a = 0; a < result.size; a++) {
            var expenseId = result.docs[a].id;
            var expense = result.docs[a].data();
            vm.Expenses.push({
              ID: expenseId,
              dealerName: expense.dealerName,
              amount: expense.amount,
              date: expense.date,
              createdDate: expense.createdDate,
              checked: expense.checked,
              note: expense.note,
              image: expense.image
            });
            vm.totalExpenses = vm.totalExpenses += expense.amount;
            // console.log(vm.totalExpenses)
          }
        }).catch(function (error) {
          console.log("Error Loading Products", error);
        });
      }
    }
  });
}

/* eslint-disable no-new */

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65188b85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65188b85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */,
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomNavbar_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ab9c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNavbar_vue__ = __webpack_require__(524);
function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4ab9c58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ab9c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-navbar-wrapper"},[_c('div',{staticClass:"bottom-navbar"},[_c('button',{staticClass:"nav-item",class:{ active: _vm.isActive('/Home') },on:{"click":function($event){return _vm.goTo('/Home')}}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("דף ראשי")])]),_vm._v(" "),_c('button',{staticClass:"nav-item",class:{ active: _vm.isActive('/ordersBeta') },on:{"click":function($event){return _vm.goTo('/ordersBeta')}}},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v("הזמנות")])]),_vm._v(" "),_c('button',{staticClass:"nav-item",class:{ active: _vm.isActive('/cheques') },on:{"click":function($event){return _vm.goTo('/cheques')}}},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v("שיקים")])]),_vm._v(" "),_c('button',{staticClass:"nav-item",class:{ active: _vm.isActive('/profile') },on:{"click":function($event){return _vm.goTo('/profile')}}},[_vm._m(3),_vm._v(" "),_c('span',[_vm._v("חשבון")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon-wrapper"},[_c('i',{staticClass:"fi fi-rr-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon-wrapper"},[_c('i',{staticClass:"fi fi-rr-shopping-bag"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon-wrapper"},[_c('i',{staticClass:"fi fi-rr-payroll-calendar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon-wrapper"},[_c('i',{staticClass:"fi fi-rr-user"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topHeader_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d4825f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topHeader_vue__ = __webpack_require__(527);
function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d4825f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d4825f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu-items"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.changeRoute('/Home')}}},[_c('svg',{staticClass:"lucide lucide-house-icon lucide-house",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"}}),_c('path',{attrs:{"d":"M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"}})]),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("דף הבית")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.changeRoute('/ordersBeta')}}},[_c('svg',{staticClass:"lucide lucide-shopping-bag-icon lucide-shopping-bag",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16 10a4 4 0 0 1-8 0"}}),_c('path',{attrs:{"d":"M3.103 6.034h17.794"}}),_c('path',{attrs:{"d":"M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"}})]),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("הזמנות")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.changeRoute('/Inventory')}}},[_c('svg',{staticClass:"lucide lucide-boxes-icon lucide-boxes",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"}}),_c('path',{attrs:{"d":"m7 16.5-4.74-2.85"}}),_c('path',{attrs:{"d":"m7 16.5 5-3"}}),_c('path',{attrs:{"d":"M7 16.5v5.17"}}),_c('path',{attrs:{"d":"M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"}}),_c('path',{attrs:{"d":"m17 16.5-5-3"}}),_c('path',{attrs:{"d":"m17 16.5 4.74-2.85"}}),_c('path',{attrs:{"d":"M17 16.5v5.17"}}),_c('path',{attrs:{"d":"M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"}}),_c('path',{attrs:{"d":"M12 8 7.26 5.15"}}),_c('path',{attrs:{"d":"m12 8 4.74-2.85"}}),_c('path',{attrs:{"d":"M12 13.5V8"}})]),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("מלאי")])]),_vm._v(" "),(_vm.$root.loggedUser.Type === 'Admin')?_c('li',{staticClass:"admin-btn"},[_c('button',{staticClass:"menu__btn",attrs:{"type":"button"},on:{"click":function($event){_vm.isActive = !_vm.isActive}}},[_vm._v("כלי מנהל")]),_vm._v(" "),_c('ul',{staticClass:"menu__list menu__list--wide",class:{ 'is-open': _vm.isActive },attrs:{"dir":"rtl"},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"quick-actions"},_vm._l((_vm.quickLinks),function(btn,i){return _c('button',{key:i,staticClass:"qa-btn",style:({
    backgroundColor: btn.color || '#3B82F6',
    color: btn.textColor || '#fff'
  }),on:{"click":function($event){return _vm.handleQuickAction(btn)}}},[_vm._v("\n  "+_vm._s(btn.label)+"\n")])}),0),_vm._v(" "),_c('hr',{staticClass:"menu-divider"}),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/');  _vm.isActive=false}}},[_vm._v("משתמשים")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/Secret');  _vm.isActive=false}}},[_vm._v("מתכונים")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/Suppliers');  _vm.isActive=false}}},[_vm._v("ספקים")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/cheques');   _vm.isActive=false}}},[_vm._v("שיקים")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/reports');   _vm.isActive=false}}},[_vm._v("סיכום חודשי")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function($event){_vm.changeRoute('/');   _vm.isActive=false}}},[_vm._v("ניהול קישורים חיצוניים")])])])]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"menu-toggle",on:{"click":function($event){_vm.mobileMenuOpen = !_vm.mobileMenuOpen}}},[_vm._v("\n  ☰\n")]),_vm._v(" "),(_vm.mobileMenuOpen)?_c('div',{staticClass:"mobile-menu"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/Home')}}},[_vm._v("דף הבית")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/ordersBeta')}}},[_vm._v("הזמנות")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/Inventory')}}},[_vm._v("מלאי")]),_vm._v(" "),_c('li',{staticClass:"mobile-submenu"},[_c('div',{staticClass:"submenu-title"},[_vm._v("כלי מנהל")]),_vm._v(" "),_c('div',{staticClass:"quick-actions-mobile"},_vm._l((_vm.quickLinks),function(btn,i){return _c('button',{key:i,staticClass:"qa-btn",style:({ backgroundColor: btn.color || '#3B82F6', color: btn.textColor || '#fff' }),on:{"click":function($event){return _vm.handleQuickAction(btn)}}},[_vm._v("\n          "+_vm._s(btn.label)+"\n        ")])}),0),_vm._v(" "),_c('ul',[_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/')}}},[_vm._v("משתמשים")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/Secret')}}},[_vm._v("מתכונים")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/Suppliers')}}},[_vm._v("ספקים")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/cheques')}}},[_vm._v("שיקים")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.navigateAndClose('/')}}},[_vm._v("ניהול קישורים")])])]),_vm._v(" "),_c('li',{on:{"click":_vm.goToSettings}},[_vm._v("⚙️ הגדרות")]),_vm._v(" "),_c('li',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("🔴 התנתקות")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('div',{ref:"addNewDropDown",staticClass:"addNewBtn",on:{"click":function($event){return _vm.addNewOpen()}}},[_c('button',[_vm._v("חדש +")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addNew),expression:"addNew"}],staticClass:"NewDropDown"},[_c('ul',[_c('router-link',{staticClass:"link",attrs:{"to":"/newOrderBeta"}},[_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" הזמנה חדשה")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.emitOpen('supplier')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" ספק חדש")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.emitOpen('recipe')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" מתכון חדש")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.emitOpen('cheque')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" שיק חדש")])],1)])]),_vm._v(" "),_c('div',{staticClass:"user-dropdown",on:{"click":function($event){$event.stopPropagation();_vm.userMenuOpen = !_vm.userMenuOpen}}},[_c('button',{staticClass:"user-btn"},[_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.$root.loggedUser.profileImg,"alt":"User"}}),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.$root.loggedUser.firstName))]),_vm._v(" "),_c('span',{staticClass:"chevron"},[_vm._v("▾")])]),_vm._v(" "),(_vm.userMenuOpen)?_c('ul',{staticClass:"user-menu"},[_c('li',{on:{"click":_vm.goToSettings}},[_vm._v("⚙️ הגדרות")]),_vm._v(" "),_c('li',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("🔴 התנתקות")])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(528),"alt":"","srcset":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chef-logo.8b66c66.png";

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82e50a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82e50a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c469382_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(533);
function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c469382_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('svg',{attrs:{"viewBox":"0 0 1030 638","width":"10"}},[_c('path',{attrs:{"d":"M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z","fill":"#FFF"}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.isOpen)?_c('div',{staticClass:"sub-menu"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"menu-item"},[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.title))])])}),0):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('Dropdown',{attrs:{"title":"חשבון שלי","items":_vm.services}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbe02c5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbe02c5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-GR"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.closeModal}},[_vm._v("סגור")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('h2',{staticClass:"card-heading"},[_vm._v("\n                Get started\n                "),_c('small',[_vm._v("Let us create your account")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card-form"},[_c('div',{staticClass:"input"},[_c('input',{staticClass:"input-field",attrs:{"type":"text","placeholder":"שם הספק","required":""}})]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('button',{staticClass:"action-button"},[_vm._v("Get started")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 190,
	"./af.js": 190,
	"./ar": 191,
	"./ar-dz": 192,
	"./ar-dz.js": 192,
	"./ar-kw": 193,
	"./ar-kw.js": 193,
	"./ar-ly": 194,
	"./ar-ly.js": 194,
	"./ar-ma": 195,
	"./ar-ma.js": 195,
	"./ar-sa": 196,
	"./ar-sa.js": 196,
	"./ar-tn": 197,
	"./ar-tn.js": 197,
	"./ar.js": 191,
	"./az": 198,
	"./az.js": 198,
	"./be": 199,
	"./be.js": 199,
	"./bg": 200,
	"./bg.js": 200,
	"./bm": 201,
	"./bm.js": 201,
	"./bn": 202,
	"./bn-bd": 203,
	"./bn-bd.js": 203,
	"./bn.js": 202,
	"./bo": 204,
	"./bo.js": 204,
	"./br": 205,
	"./br.js": 205,
	"./bs": 206,
	"./bs.js": 206,
	"./ca": 207,
	"./ca.js": 207,
	"./cs": 208,
	"./cs.js": 208,
	"./cv": 209,
	"./cv.js": 209,
	"./cy": 210,
	"./cy.js": 210,
	"./da": 211,
	"./da.js": 211,
	"./de": 212,
	"./de-at": 213,
	"./de-at.js": 213,
	"./de-ch": 214,
	"./de-ch.js": 214,
	"./de.js": 212,
	"./dv": 215,
	"./dv.js": 215,
	"./el": 216,
	"./el.js": 216,
	"./en-au": 217,
	"./en-au.js": 217,
	"./en-ca": 218,
	"./en-ca.js": 218,
	"./en-gb": 219,
	"./en-gb.js": 219,
	"./en-ie": 220,
	"./en-ie.js": 220,
	"./en-il": 221,
	"./en-il.js": 221,
	"./en-in": 222,
	"./en-in.js": 222,
	"./en-nz": 223,
	"./en-nz.js": 223,
	"./en-sg": 224,
	"./en-sg.js": 224,
	"./eo": 225,
	"./eo.js": 225,
	"./es": 226,
	"./es-do": 227,
	"./es-do.js": 227,
	"./es-mx": 228,
	"./es-mx.js": 228,
	"./es-us": 229,
	"./es-us.js": 229,
	"./es.js": 226,
	"./et": 230,
	"./et.js": 230,
	"./eu": 231,
	"./eu.js": 231,
	"./fa": 232,
	"./fa.js": 232,
	"./fi": 233,
	"./fi.js": 233,
	"./fil": 234,
	"./fil.js": 234,
	"./fo": 235,
	"./fo.js": 235,
	"./fr": 236,
	"./fr-ca": 237,
	"./fr-ca.js": 237,
	"./fr-ch": 238,
	"./fr-ch.js": 238,
	"./fr.js": 236,
	"./fy": 239,
	"./fy.js": 239,
	"./ga": 240,
	"./ga.js": 240,
	"./gd": 241,
	"./gd.js": 241,
	"./gl": 242,
	"./gl.js": 242,
	"./gom-deva": 243,
	"./gom-deva.js": 243,
	"./gom-latn": 244,
	"./gom-latn.js": 244,
	"./gu": 245,
	"./gu.js": 245,
	"./he": 37,
	"./he.js": 37,
	"./hi": 246,
	"./hi.js": 246,
	"./hr": 247,
	"./hr.js": 247,
	"./hu": 248,
	"./hu.js": 248,
	"./hy-am": 249,
	"./hy-am.js": 249,
	"./id": 250,
	"./id.js": 250,
	"./is": 251,
	"./is.js": 251,
	"./it": 252,
	"./it-ch": 253,
	"./it-ch.js": 253,
	"./it.js": 252,
	"./ja": 254,
	"./ja.js": 254,
	"./jv": 255,
	"./jv.js": 255,
	"./ka": 256,
	"./ka.js": 256,
	"./kk": 257,
	"./kk.js": 257,
	"./km": 258,
	"./km.js": 258,
	"./kn": 259,
	"./kn.js": 259,
	"./ko": 260,
	"./ko.js": 260,
	"./ku": 261,
	"./ku.js": 261,
	"./ky": 262,
	"./ky.js": 262,
	"./lb": 263,
	"./lb.js": 263,
	"./lo": 264,
	"./lo.js": 264,
	"./lt": 265,
	"./lt.js": 265,
	"./lv": 266,
	"./lv.js": 266,
	"./me": 267,
	"./me.js": 267,
	"./mi": 268,
	"./mi.js": 268,
	"./mk": 269,
	"./mk.js": 269,
	"./ml": 270,
	"./ml.js": 270,
	"./mn": 271,
	"./mn.js": 271,
	"./mr": 272,
	"./mr.js": 272,
	"./ms": 273,
	"./ms-my": 274,
	"./ms-my.js": 274,
	"./ms.js": 273,
	"./mt": 275,
	"./mt.js": 275,
	"./my": 276,
	"./my.js": 276,
	"./nb": 277,
	"./nb.js": 277,
	"./ne": 278,
	"./ne.js": 278,
	"./nl": 279,
	"./nl-be": 280,
	"./nl-be.js": 280,
	"./nl.js": 279,
	"./nn": 281,
	"./nn.js": 281,
	"./oc-lnc": 282,
	"./oc-lnc.js": 282,
	"./pa-in": 283,
	"./pa-in.js": 283,
	"./pl": 284,
	"./pl.js": 284,
	"./pt": 285,
	"./pt-br": 286,
	"./pt-br.js": 286,
	"./pt.js": 285,
	"./ro": 287,
	"./ro.js": 287,
	"./ru": 288,
	"./ru.js": 288,
	"./sd": 289,
	"./sd.js": 289,
	"./se": 290,
	"./se.js": 290,
	"./si": 291,
	"./si.js": 291,
	"./sk": 292,
	"./sk.js": 292,
	"./sl": 293,
	"./sl.js": 293,
	"./sq": 294,
	"./sq.js": 294,
	"./sr": 295,
	"./sr-cyrl": 296,
	"./sr-cyrl.js": 296,
	"./sr.js": 295,
	"./ss": 297,
	"./ss.js": 297,
	"./sv": 298,
	"./sv.js": 298,
	"./sw": 299,
	"./sw.js": 299,
	"./ta": 300,
	"./ta.js": 300,
	"./te": 301,
	"./te.js": 301,
	"./tet": 302,
	"./tet.js": 302,
	"./tg": 303,
	"./tg.js": 303,
	"./th": 304,
	"./th.js": 304,
	"./tk": 305,
	"./tk.js": 305,
	"./tl-ph": 306,
	"./tl-ph.js": 306,
	"./tlh": 307,
	"./tlh.js": 307,
	"./tr": 308,
	"./tr.js": 308,
	"./tzl": 309,
	"./tzl.js": 309,
	"./tzm": 310,
	"./tzm-latn": 311,
	"./tzm-latn.js": 311,
	"./tzm.js": 310,
	"./ug-cn": 312,
	"./ug-cn.js": 312,
	"./uk": 313,
	"./uk.js": 313,
	"./ur": 314,
	"./ur.js": 314,
	"./uz": 315,
	"./uz-latn": 316,
	"./uz-latn.js": 316,
	"./uz.js": 315,
	"./vi": 317,
	"./vi.js": 317,
	"./x-pseudo": 318,
	"./x-pseudo.js": 318,
	"./yo": 319,
	"./yo.js": 319,
	"./zh-cn": 320,
	"./zh-cn.js": 320,
	"./zh-hk": 321,
	"./zh-hk.js": 321,
	"./zh-mo": 322,
	"./zh-mo.js": 322,
	"./zh-tw": 323,
	"./zh-tw.js": 323
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 545;

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateModal_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_889c2dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateModal_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-889c2dc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_889c2dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"modal-default-button",on:{"click":_vm.reloadNow}},[_vm._v("\n          تحديث الآن\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h3',[_vm._v("تحديث جديد متوفر")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("هناك تحديث جديد. سيتم تحديث الموقع تلقائيًا بعد 3 ثوانٍ.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddChequeModal_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4caaee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddChequeModal_vue__ = __webpack_require__(579);
function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d4caaee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddChequeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4caaee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddChequeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal-fade"}},[(_vm.chequeModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"cheque-modal"},[_c('button',{staticClass:"close-btn",on:{"click":_vm.closeModal}},[_vm._v("\n                ✕\n            ")]),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("\n                        הוספת שיק חדש\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        נהל את פרטי השיק בצורה פשוטה\n                    ")])])]),_vm._v(" "),(_vm.errorDealer)?_c('div',{staticClass:"error-box"},[_vm._v("\n                "+_vm._s(_vm.errorAddingDealer)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-form"},[_c('div',{staticClass:"glass-input"},[_c('label',[_vm._v("\n                            שם הלקוח\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localCheque.dealerName),expression:"localCheque.dealerName"}],attrs:{"type":"text","list":"exampleList","placeholder":"בחר לקוח..."},domProps:{"value":(_vm.localCheque.dealerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localCheque, "dealerName", $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":"exampleList"}},_vm._l((_vm.Dealers),function(person){return _c('option',{key:person.id,domProps:{"value":person.Data.selectDealerName}})}),0)]),_vm._v(" "),_c('div',{staticClass:"glass-input"},[_c('label',[_vm._v("בנק")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localCheque.bank),expression:"localCheque.bank"}],staticClass:"bank-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.localCheque, "bank", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("בחר בנק (לא חובה לשיקים ישנים)")]),_vm._v(" "),_c('option',{attrs:{"value":"לאומי"}},[_vm._v("בנק לאומי")]),_vm._v(" "),_c('option',{attrs:{"value":"דיסקונט"}},[_vm._v("בנק דיסקונט")])])]),_vm._v(" "),_c('div',{staticClass:"glass-input"},[_c('label',[_vm._v("\n                            סכום השיק\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.localCheque.amount),expression:"localCheque.amount",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"₪ 0.00"},domProps:{"value":(_vm.localCheque.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localCheque, "amount", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"glass-input"},[_c('label',[_vm._v("\n                            תאריך פירעון\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localCheque.formattedDate),expression:"localCheque.formattedDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.localCheque.formattedDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localCheque, "formattedDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"glass-input"},[_c('label',[_vm._v("\n                            הערות\n                        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localCheque.notes),expression:"localCheque.notes"}],attrs:{"rows":"3","placeholder":"הוסף הערות..."},domProps:{"value":(_vm.localCheque.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localCheque, "notes", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"preview-card"},[_c('span',{staticClass:"preview-label"},[_vm._v("\n                        תצוגה מקדימה\n                    ")]),_vm._v(" "),_c('h1',[_vm._v("\n                        ₪"+_vm._s(_vm.localCheque.amount || '0')+"\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.localCheque.dealerName || 'שם לקוח')+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"preview-date"},[_vm._v("\n                        "+_vm._s(_vm.localCheque.formattedDate
                            || '--/--/----')+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"modal-actions"},[_c('button',{staticClass:"save-btn",on:{"click":_vm.addCheque}},[_vm._v("\n                    שמור שיק\n                ")]),_vm._v(" "),_c('button',{staticClass:"cancel-btn",on:{"click":_vm.closeModal}},[_vm._v("\n                    ביטול\n                ")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.modalToggle)?_c('div',{staticClass:"modal-GR"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),(_vm.errorDealer)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorAddingDealer))]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"card-form"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectDealerName),expression:"selectDealerName"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"שם הספק"},domProps:{"value":(_vm.selectDealerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectDealerName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"input-field",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("-- נא לבחור את התפקיד --")]),_vm._v(" "),_c('option',{attrs:{"value":"עובד"}},[_vm._v("עובד")]),_vm._v(" "),_c('option',{attrs:{"value":"ספק"}},[_vm._v("ספק")])])]),_vm._v(" "),_c('div',{staticClass:"action",on:{"click":function($event){return _vm.addDealer()}}},[_vm._v("\n                            אישור\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('button',{staticClass:"link-btn",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("סגור")])])])]):_vm._e(),_vm._v(" "),(_vm.newCategoryModal)?_c('div',{staticClass:"modal-GR"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),(_vm.errorDealer)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorAddingDealer))]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"card-form"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectDealerName),expression:"selectDealerName"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"שם הספק"},domProps:{"value":(_vm.selectDealerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectDealerName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"action",on:{"click":function($event){return _vm.addDealer()}}},[_vm._v("\n                            אישור\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('button',{staticClass:"link-btn",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("סגור")])])])]):_vm._e(),_vm._v(" "),_c('AddChequeModal',{attrs:{"chequeModal":_vm.chequeModal,"Dealers":_vm.Dealers},on:{"close":_vm.closeChequeModal,"save":_vm.addCheque}}),_vm._v(" "),(_vm.secretModal)?_c('div',{staticClass:"modal-GR"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),(_vm.errorDealer)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorAddingDealer))]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"card-form"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.secret.name),expression:"secret.name"}],staticClass:"input-field",attrs:{"type":"text","list":"exampleList","placeholder":"שם המתכון"},domProps:{"value":(_vm.secret.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.secret, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.secret.note),expression:"secret.note"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"מתכון"},domProps:{"value":(_vm.secret.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.secret, "note", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"action",on:{"click":function($event){return _vm.addExpense()}}},[_vm._v("\n                                אישור\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('button',{staticClass:"link-btn",attrs:{"type":"button"},on:{"click":_vm.closeChequeModal}},[_vm._v("סגור")])])])]):_vm._e(),_vm._v(" "),_c('topHeader',{on:{"open-modal":_vm.handleOpenModal}}),_vm._v(" "),_c('main',{staticClass:"main"},[(_vm.showUpdateModal)?_c('UpdateModal'):_vm._e(),_vm._v(" "),(!_vm.$route.meta.hideNavbar)?_c('div',{staticClass:"paths"},[_c('router-link',{staticClass:"link",attrs:{"to":"/newOrderBeta"}},[_vm._v("יצירת הזמנה")])],1):_vm._e(),_vm._v(" "),_c('keep-alive',{attrs:{"exclude":"SelectedOrderBeta,SignIn"}},[_c('router-view')],1),_vm._v(" "),(_vm.showNavbar && _vm.$root.loggedUser)?_c('BottomNavbar'):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('h2',{staticClass:"card-heading"},[_c('small',[_vm._v("הוספת ספק חדש")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('h2',{staticClass:"card-heading"},[_c('small',[_vm._v("הוספת ספק חדש")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('h2',{staticClass:"card-heading"},[_c('small',[_vm._v("מתכון חדש")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orders__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ordersBeta__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Secret__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelectedOrder__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_signIn__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AddWorkers__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Meheron__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_CreateOrderBeta__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_newOrderbeta__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_SelectedOrderBeta__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Inventory__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Suppliers__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Settings__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Media__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Trash__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_cheques__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_chequesBeta__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_reports__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_expenses__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_checkout__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_printOrder__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_firebase_firestore__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_firebase_storage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_firebase_auth__ = __webpack_require__(50);






























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["b" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["b" /* default */]({
  mode: "history",
  base: Object({"NODE_ENV":"production"}).Base_URL,

  routes: [{
    path: '/',
    name: 'signIn',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_signIn__["a" /* default */],
    meta: {
      hideNavbar: true
    }

  }, { path: '/catalog/:slug', name: 'CatalogDynamic', component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 730));
    } }, {
    path: '/Home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Home__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/Orders',
    name: 'Orders',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Orders__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/OrdersBeta',
    name: 'ordersBeta',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_ordersBeta__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/Secret',
    name: 'Secret',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Secret__["a" /* default */],
    //meta: { requiresAuth: true},
    meta: { adminOnly: true }
  }, {
    path: '/SelectedOrder',
    name: 'SelectedOrder',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_SelectedOrder__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/AddWorkers',
    name: 'AddWorkers',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_AddWorkers__["a" /* default */],
    //meta: { requiresAuth: true},
    meta: { adminOnly: true }
  }, {
    path: '/Meheron',
    name: 'Meheron',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Meheron__["a" /* default */],
    //meta: { requiresAuth: true},
    meta: { adminOnly: true }
  },, {
    path: '/CreateOrderBeta',
    name: 'CreateOrderBeta',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_CreateOrderBeta__["a" /* default */],
    props: true

    //meta: { requiresAuth: true},
  }, {
    path: '/newOrderbeta',
    name: 'newOrderbeta',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_newOrderbeta__["a" /* default */],
    props: true

    //meta: { requiresAuth: true},
  }, {
    path: '/SelectedOrderBeta/:id',
    name: 'SelectedOrderBeta',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_SelectedOrderBeta__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/Inventory/',
    name: 'Inventory',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Inventory__["a" /* default */]
    //meta: { requiresAuth: true},

  }, {
    path: '/Suppliers',
    name: 'Suppliers',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Suppliers__["a" /* default */],
    //meta: { requiresAuth: true},
    meta: { adminOnly: true }
  }, {
    path: '/Settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Settings__["a" /* default */]
    //meta: { requiresAuth: true},
  }, {
    path: '/Media',
    name: 'Media',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_Media__["a" /* default */]
  }, {
    path: '/Trash',
    name: 'Trash',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_Trash__["a" /* default */]
  }, {
    path: '/cheques',
    name: 'cheques',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_cheques__["a" /* default */],
    meta: { adminOnly: true }
  }, {
    path: '/expenses',
    name: 'expenses',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_expenses__["a" /* default */],
    meta: { adminOnly: true }
  }, {
    path: '/checkout',
    name: 'checkout',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_checkout__["a" /* default */]
  }, {
    path: '/reports',
    name: 'reports',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_reports__["a" /* default */],
    meta: { adminOnly: true }
  }, {
    path: '/Suppliers/:id',
    name: 'SupplierLedger',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 731));
    },
    meta: { adminOnly: true }
  }]
});
// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//   const currentUser = firebase.auth().currentUser

//   if (requiresAuth && !currentUser) {
//     next('/')
//   } else if (requiresAuth && currentUser) {
//     next()
//   } else {
//     next()
//   }
// });
router.beforeEach(function (to, from, next) {

  var user = JSON.parse(localStorage.getItem("User"));

  // صفحات مسموحة بدون تسجيل
  var publicPages = ['/'];

  // هل الصفحة تحتاج login؟
  var authRequired = !publicPages.includes(to.path);

  // إذا مش مسجل دخول
  if (authRequired && !user) {

    return next('/');
  }

  // صفحات الأدمن فقط
  if (to.meta.adminOnly && user.Type !== 'Admin') {

    alert("אין לך גישה לדף הזה");

    return next('/Home');
  }

  next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88564cb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88564cb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88564cb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ordersDiv",on:{"click":function($event){return _vm.openOrder(_vm.order.ID)}}},[_c('div',{staticClass:"orderImg"},[_c('img',{attrs:{"src":_vm.order.Data.orderImg,"alt":""}})]),_vm._v(" "),_c('div',{key:_vm.order.ID,staticClass:"ordername",attrs:{"id":_vm.order.ID,"order":_vm.order}},[_vm._v("\n        "+_vm._s(_vm.order.Data.fullname)+" | \n        \n        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.Data.status == 'התקבלה'),expression:"order.Data.status == 'התקבלה'"}],staticClass:"statusStyle acceptBadge"},[_vm._v(_vm._s(_vm.order.Data.status)+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.Data.status == 'מוכנה'),expression:"order.Data.status == 'מוכנה'"}],staticClass:"statusStyle readyBadge"},[_vm._v(_vm._s(_vm.order.Data.status)+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.Data.status == 'נמסרה'),expression:"order.Data.status == 'נמסרה'"}],staticClass:"statusStyle shippedBadge"},[_vm._v(_vm._s(_vm.order.Data.status)+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.Data.status == 'בוטלה'),expression:"order.Data.status == 'בוטלה'"}],staticClass:"statusStyle canceledBadge"},[_vm._v(_vm._s(_vm.order.Data.status)+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.Data.status == 'שלב הכנה'),expression:"order.Data.status == 'שלב הכנה'"}],staticClass:"statusStyle inprogressBadge"},[_vm._v(_vm._s(_vm.order.Data.status)+" ")]),_vm._v(" "),_c('span',{staticClass:"numberBadge"},[_vm._v("#"+_vm._s(_vm.order.Data.orderNumber)+" ")])]),_vm._v(" "),_c('div',{staticClass:"orderDetails"},[_vm._v("\n        \n        "+_vm._s(_vm.order.Data.phoneNumber)+" | "+_vm._s(_vm.order.Data.cakeTaste  + ' ' +  _vm.order.Data.cakeSize)+" | "+_vm._s(_vm.order.Data.dateOrder)+" | "+_vm._s(_vm.order.Data.timeOrder)+" |  יום "+_vm._s(_vm.order.Data.dayOrder)+"  | "+_vm._s(_vm.order.Data.priceOrder)+" ₪ \n    ")]),_vm._v(" "),_c('div',{staticClass:"addedTime"},[_vm._v("\n        "+_vm._s(_vm.order.Data.createdDate)+" \n         ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-card",class:[  _vm.order.Data.status == 'מוכנה' ? 'orderReady' : 'order-card', _vm.order.Data.status == 'נמסרה' ? 'confirmed' : 'order-card', _vm.order.Data.status == 'בוטלה' ? 'canceledOrder' : 'order-card']},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"order-card-header"},[_c('div',{staticClass:"right-side"},[_c('span',{staticClass:"order-id",on:{"click":function($event){return _vm.openOrder(_vm.order.ID)}}},[_vm._v("#"+_vm._s(_vm.order.Data.orderNumber))]),_vm._v(" "),_c('span',{class:[_vm.order.Data.status == 'בוטלה' ? 'canceledBadge' : 'select',
                 _vm.order.Data.status == 'מוכנה' ? 'readyBadge' : 'select',
                  _vm.order.Data.status == 'נמסרה' ? 'shippedBadge' : 'select',
                  _vm.order.Data.status == 'שלב הכנה' ? 'inprogressBadge' : 'select',
                   _vm.order.Data.status == 'התקבלה' ? 'acceptBadge' : 'select' ],on:{"click":function($event){return _vm.toggleStatusDropdown(_vm.order.ID)}}},[_c('svg',{staticClass:"lucide lucide-receipt-text-icon lucide-receipt-text",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13 16H8"}}),_c('path',{attrs:{"d":"M14 8H8"}}),_c('path',{attrs:{"d":"M16 12H8"}}),_c('path',{attrs:{"d":"M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z"}})]),_vm._v("\n                "+_vm._s(_vm.order.Data.status)+"\n                "),_c('svg',{staticClass:"lucide lucide-chevron-down-icon lucide-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"m6 9 6 6 6-6"}})])]),_vm._v(" "),(_vm.activeStatusDropdown === _vm.order.ID)?_c('div',{staticClass:"status-dropdown"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.updateOrderStatus(_vm.order.ID, 'התקבלה')}}},[_vm._v("התקבלה")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.updateOrderStatus(_vm.order.ID, 'מוכנה')}}},[_vm._v("מוכנה")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.updateOrderStatus(_vm.order.ID, 'נמסרה')}}},[_vm._v("נמסרה")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.updateOrderStatus(_vm.order.ID, 'בוטלה')}}},[_vm._v("בוטלה")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-payment-status"},[_c('span',{class:[_vm.order.Data.paidStatus == 'שולם' ? 'paid' : 'totalAmount' , _vm.order.Data.paidStatus == 'לא שולם' ? 'unPaid' : 'totalAmount'  ]},[_c('svg',{staticClass:"lucide lucide-banknote-icon lucide-banknote",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"12","x":"2","y":"6","rx":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}}),_c('path',{attrs:{"d":"M6 12h.01M18 12h.01"}})]),_vm._v("\n                 "+_vm._s(_vm.order.Data.paidStatus)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"order-card-body"},[_c('div',{staticClass:"client-details"},[_c('div',{staticClass:"field name",on:{"click":function($event){return _vm.openOrder(_vm.order.ID)}}},[_c('span',{staticClass:"sec-text"},[_vm._v("שם הלקוח")]),_vm._v(" "),_c('span',{staticClass:"primary-text"},[_vm._v(_vm._s(_vm.order.Data.fullname))])]),_vm._v(" "),_c('div',{staticClass:"field phone"},[_c('span',{staticClass:"sec-text"},[_vm._v("מספר הטלפון")]),_vm._v(" "),_c('span',{staticClass:"primary-text"},[_vm._v(_vm._s(_vm.order.Data.phoneNumber))])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"order-date"},[_c('div',{staticClass:"date-box"},[_vm._v("\n              "+_vm._s(_vm.order.Data.selectedDateReadable)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"date-box"},[_vm._v("\n                "+_vm._s(_vm.order.Data.timeOrder)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"order-cart"},[_c('span',{staticClass:"order-cart-title"},[_vm._v("\n            פרטי הזמנה\n        ")]),_vm._v(" "),_c('div',{staticClass:"products-list"},[_vm._l((_vm.order.Data.cart),function(item){return _c('div',{staticClass:"item"},[_c('span',{staticClass:"selectedquantity"},[_vm._v("x"+_vm._s(item.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"itemName"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"subTotal"},[_vm._v("₪"+_vm._s(item.Data.Price * item.selectedCount))])])}),_vm._v(" "),_c('div',{staticClass:"total"},[_c('span',[_vm._v("סה\"כ לתשלום")]),_vm._v(" "),_c('span',[_vm._v("  ₪"+_vm._s(_vm.order.Data.totalOrderPrice -  _vm.order.Data.discount))])]),_vm._v(" "),(_vm.order.Data.note.length > 0)?_c('div',{staticClass:"note"},[_c('pre',[_c('span',[_vm._v("הערות:")]),_c('br'),_vm._v(_vm._s(_vm.order.Data.note))])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"images"},_vm._l((_vm.order.Data.orderImg),function(img,index){return _c('div',{key:'img' + index},[_c('img',{attrs:{"src":img,"alt":""}})])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company"},[_c('span',[_vm._v("\n            \n             הקונדיטוריה הירוקה בע\"מ\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n                                ח.פ.514519024\n\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field actions"},[_c('span',{staticClass:"sec-text"},[_vm._v("פעולות")]),_vm._v(" "),_c('span',{staticClass:"primary-text"},[_c('img',{staticClass:"whatsappIcon",attrs:{"src":"/static/img/whatsapp.8b357b4.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ordersContainer"},[(_vm.isLoading)?_c('div',{staticClass:"loadingModal"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pageHeader"},[_c('div',{staticClass:"pageTitle"},[_c('span',{staticClass:"pageTitleText"},[_vm._v("דף ההזמנות "),_c('span',{staticClass:"total-orders"},[_vm._v(_vm._s(this.acceptedOrders))])]),_vm._v(" "),_c('b',{staticStyle:{"position":"absolute","right":"15rem","font-size":"14px"},on:{"click":function($event){return _vm.loadOrdersRealTime()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("refresh")]),_vm._v(" רענן הזמנות ")]),_vm._v(" "),_c('div',{staticClass:"topLine"},[_c('ul',[_c('li',{class:[_vm.yesterdayItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.yesterdayOrders()}}},[_vm._v("אתמול")])]),_vm._v(" "),_c('li',{class:[_vm.todayItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.todayOrders()}}},[_vm._v("היום")])]),_vm._v(" "),_c('li',{class:[_vm.tommorowItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.tommorowOrders()}}},[_vm._v("מחר")])])])])]),_vm._v(" "),_c('div',{staticClass:"searchData"},[_c('div',{staticClass:"searchBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חיפוש לפי שם או מספר טלפון"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"datesBox"},[_c('div',{staticClass:"filterByDate"},[_c('div',{staticClass:"dateField"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromDate),expression:"fromDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.fromDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.fromDate=$event.target.value}}})]),_vm._v(" "),_c('span',[_vm._v("עד")]),_vm._v(" "),_c('div',{staticClass:"dateField"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.toDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"table"},[_c('div',{staticClass:"filterMobile"},[_c('h3',[_vm._v("סינון הזמנות לפי תאריכים")]),_vm._v(" "),_c('div',{staticClass:"dateFieldMobile"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromDate),expression:"fromDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.fromDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.fromDate=$event.target.value}}})]),_vm._v(" "),_c('span',[_vm._v("עד")]),_vm._v(" "),_c('div',{staticClass:"dateFieldMobile"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.toDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})])]),_vm._v(" "),_vm._l((_vm.filteredOrders),function(order,index){return (order.Data.status !== 'נמחקה' )?_c('orderCard',{key:index,attrs:{"id":order.ID,"order":order,"orderIndex":index}}):_vm._e()}),_vm._v(" "),(this.orders.length == 0)?_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","justify-content":"center","align-items":"center","flex-direction":"column"}},[_c('img',{attrs:{"src":__webpack_require__(595),"width":"500px"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v(" אין כרגע הזמנות")])]):_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"fixed-report-btn",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n  📊 عرض التقرير\n")]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("✖")]),_vm._v(" "),_c('h3',[_vm._v("📈 تقرير المبيعات")]),_vm._v(" "),_c('label',[_vm._v("📅 اختر تاريخ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"datePicker",attrs:{"type":"date"},domProps:{"value":(_vm.selectedDate)},on:{"change":_vm.fetchSalesReport,"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"refresh-btn",on:{"click":_vm.fetchSalesReport}},[_vm._v("🔄 تحديث التقرير")]),_vm._v(" "),(Object.keys(_vm.salesReport).length > 0)?_c('div',{staticClass:"sales-list"},_vm._l((_vm.salesReport),function(count,product){return _c('div',{key:product,staticClass:"sales-item"},[_c('span',{staticClass:"product-count"},[_vm._v(_vm._s(count)+" ")]),_vm._v(" "),_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(product))])])}),0):_c('p',[_vm._v("لا توجد مبيعات في هذا اليوم.")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nodata.94d738e.png";

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordersBeta_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e2be5b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ordersBeta_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63e2be5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordersBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e2be5b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ordersBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ordersContainer"},[(_vm.isLoading)?_c('div',{staticClass:"loadingModal"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"line"},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חיפוש הזמנה לפי שם, מספר טלפון או מספר הזמנה"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"buttons-tools"},[_c('ul',[_c('li',[_c('span',{class:[_vm.yesterdayItemNav == true ? 'activeItem' : ''],on:{"click":function($event){return _vm.yesterdayOrders()}}},[_vm._v("אתמול")]),_vm._v(" "),_c('span',{class:[_vm.todayItemNav == true ? 'activeItem' : ''],on:{"click":function($event){return _vm.todayOrders()}}},[_vm._v("היום")]),_vm._v(" "),_c('span',{class:[_vm.tommorowItemNav == true ? 'activeItem' : ''],on:{"click":function($event){return _vm.tommorowOrders()}}},[_vm._v("מחר")])]),_vm._v(" "),_c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromDate),expression:"fromDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.fromDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.fromDate=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("עד")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],attrs:{"type":"date"},domProps:{"value":(_vm.toDate)},on:{"change":function($event){return _vm.loadOrdersRealTime()},"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.loadOrdersRealTime()}}},[_c('button',[_c('svg',{staticClass:"lucide lucide-refresh-cw-icon lucide-refresh-cw",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"#363636","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"}}),_c('path',{attrs:{"d":"M21 3v5h-5"}}),_c('path',{attrs:{"d":"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"}}),_c('path',{attrs:{"d":"M8 16H3v5"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"order-count"},[_vm._v("\n           "+_vm._s(_vm.filteredOrdersCount)+" הזמנות שנמצאו לפי הסינון\n         ")]),_vm._v(" "),_c('div',{staticClass:"orders-table"},_vm._l((_vm.filteredOrders),function(order,index){return (order.Data.status !== 'נמחקה' )?_c('orderCard',{key:index,attrs:{"id":order.ID,"order":order,"orderIndex":index}}):_vm._e()}),1),_vm._v(" "),(this.orders.length == 0)?_c('div',{staticClass:"no-orders"},[_c('div',{staticClass:"icon-false"},[_c('svg',{staticClass:"lucide lucide-x-icon lucide-x",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18 6 6 18"}}),_c('path',{attrs:{"d":"m6 6 12 12"}})]),_vm._v(" "),_c('span',{staticClass:"primary-text"},[_vm._v("אין הזמנות")]),_vm._v(" "),_c('span',{staticClass:"secondary-text"},[_vm._v("\n               לפי נתוני החיפוש לא נמצא כרגע הזמנות, נא לנסות מאוחר יותר.\n             ")])])]):_vm._e(),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("✖")]),_vm._v(" "),_c('h3',[_vm._v("📈 تقرير المبيعات")]),_vm._v(" "),_c('label',[_vm._v("📅 اختر تاريخ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"datePicker",attrs:{"type":"date"},domProps:{"value":(_vm.selectedDate)},on:{"change":_vm.fetchSalesReport,"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"refresh-btn",on:{"click":_vm.fetchSalesReport}},[_vm._v("🔄 تحديث التقرير")]),_vm._v(" "),(Object.keys(_vm.salesReport).length > 0)?_c('div',{staticClass:"sales-list"},_vm._l((_vm.salesReport),function(count,product){return _c('div',{key:product,staticClass:"sales-item"},[_c('span',{staticClass:"product-count"},[_vm._v(_vm._s(count)+" ")]),_vm._v(" "),_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(product))])])}),0):_c('p',[_vm._v("لا توجد مبيعات في هذا اليوم.")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef8d19e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef8d19e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"mobile-reports"},[_c('div',{staticClass:"welcome"},[_c('span',[_vm._v("ברוך הבא,")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$root.loggedUser.firstName))])]),_vm._v(" "),_c('div',{staticClass:"reports"},[_c('div',{staticClass:"reports-list"},[_c('div',{staticClass:"reports-item"},[_c('div',{staticClass:"report-title"},[_vm._v("\n                            סך הזמנות היום\n                        ")]),_vm._v(" "),_c('div',{staticClass:"report-data"},[_vm._v("\n                            "+_vm._s(_vm.totalOrdersForToday)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"reports-item"},[_c('div',{staticClass:"report-title"},[_vm._v("\n                            סה\"כ מכירות היום\n                        ")]),_vm._v(" "),_c('div',{staticClass:"report-data"},[_vm._v("\n                            ₪"+_vm._s(_vm.subTotalForToday)+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"quick-actions"},[_c('div',{staticClass:"quick-title"},[_vm._v("\n                    קיצורי דרך\n                ")]),_vm._v(" "),_c('div',{staticClass:"actions-list",on:{"click":function($event){return _vm.goToRoute('/newOrderbeta')}}},[_c('div',{staticClass:"action-item"},[_c('div',{staticClass:"action-box"},[_c('svg',{staticClass:"lucide lucide-shopping-bag-icon lucide-shopping-bag",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16 10a4 4 0 0 1-8 0"}}),_c('path',{attrs:{"d":"M3.103 6.034h17.794"}}),_c('path',{attrs:{"d":"M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"}})])]),_vm._v(" "),_c('span',[_vm._v("הזמנה חדשה")])]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"action-item"},[_c('div',{staticClass:"action-box"},[_c('svg',{staticClass:"lucide lucide-banknote-arrow-up-icon lucide-banknote-arrow-up",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5"}}),_c('path',{attrs:{"d":"M18 12h.01"}}),_c('path',{attrs:{"d":"M19 22v-6"}}),_c('path',{attrs:{"d":"m22 19-3-3-3 3"}}),_c('path',{attrs:{"d":"M6 12h.01"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}})])]),_vm._v(" "),_c('span',[_vm._v("הוצאה חדשה")])]):_vm._e(),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"action-item"},[_c('div',{staticClass:"action-box"},[_c('svg',{staticClass:"lucide lucide-user-round-plus-icon lucide-user-round-plus",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2 21a8 8 0 0 1 13.292-6"}}),_c('circle',{attrs:{"cx":"10","cy":"8","r":"5"}}),_c('path',{attrs:{"d":"M19 16v6"}}),_c('path',{attrs:{"d":"M22 19h-6"}})])]),_vm._v(" "),_c('span',[_vm._v("ספק חדש")])]):_vm._e(),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"action-item"},[_c('div',{staticClass:"action-box"},[_c('svg',{staticClass:"lucide lucide-eye-off-icon lucide-eye-off",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"}}),_c('path',{attrs:{"d":"M14.084 14.158a3 3 0 0 1-4.242-4.242"}}),_c('path',{attrs:{"d":"M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"}}),_c('path',{attrs:{"d":"m2 2 20 20"}})])]),_vm._v(" "),_c('span',[_vm._v("מתכון חדש")])]):_vm._e()])])]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"statics"},[_c('div',{staticClass:"box",attrs:{"id":"box"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("סה\"כ הזמנות היום")]),_vm._v(" "),_c('span',{staticClass:"ordersCount"},[_vm._v(_vm._s(_vm.totalOrdersForToday))])]),_vm._v(" "),_c('router-link',{staticClass:"staticBtn",attrs:{"to":"/Orders"}},[_c('span',[_vm._v("מעבר להזמנות")])])],1),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("סה\"כ מכירות היום")]),_vm._v(" "),_c('span',{staticClass:"ordersCount"},[_vm._v(_vm._s(_vm.subTotalForToday)+" "),_c('span',{staticStyle:{"font-size":"14px","color":"#707070"}},[_vm._v("₪")])])]),_vm._v(" "),_c('router-link',{staticClass:"staticBtn",attrs:{"to":""}},[_c('span',[_vm._v("מעבר למכירות")])])],1):_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"box"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("הוצאות")]),_vm._v(" "),_c('span',{staticClass:"ordersCount"},[_vm._v(_vm._s(0)+" "),_c('span',{staticStyle:{"font-size":"14px","color":"#707070"}},[_vm._v("₪")])])]),_vm._v(" "),_c('router-link',{staticClass:"staticBtn",attrs:{"to":""}},[_c('span',[_vm._v("מעבר להוצאות")])])],1):_c('div',{staticClass:"box"},[_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"box"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("ספקים")]),_vm._v(" "),_c('span',{staticClass:"ordersCount"},[_vm._v(_vm._s(_vm.dealersCount))])]),_vm._v(" "),_c('router-link',{staticClass:"staticBtn",attrs:{"to":"/Suppliers"}},[_c('span',[_vm._v("מעבר לספקים")])])],1):_c('div',{staticClass:"box"},[_vm._m(8),_vm._v(" "),_vm._m(9)])]):_vm._e(),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"section2"},[_c('div',{staticClass:"stockData"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("פריטים עם מלאי נמוך")]),_vm._v(" "),_c('span',{staticClass:"ordersCount",staticStyle:{"color":"#d11a2a"}},[_vm._v(_vm._s(this.lowStock))])]),_vm._v(" "),_vm._m(11)]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('div',{staticClass:"lastPayments"},[_vm._m(12),_vm._v(" "),_c('table',[_vm._m(13),_vm._v(" "),_vm._l((_vm.expenses),function(expense,index){return _c('tr',{attrs:{"id":expense.ID,"index":index}},[_c('td',[_vm._v(_vm._s(expense.Data.dealerName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(expense.Data.date))]),_vm._v(" "),_c('td',[_vm._v("₪"+_vm._s(expense.Data.amount))])])})],2)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section3"},[_c('div',{staticClass:"lastOrders"},[_vm._m(14),_vm._v(" "),_c('table',[_vm._m(15),_vm._v(" "),_vm._l((_vm.orders),function(order){return (order.Data.status != 'נמחקה')?_c('tr',[_c('td',[_vm._v("#"+_vm._s(order.Data.orderNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.fullname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.phoneNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.dayOrder))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.dateOrder))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.timeOrder))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.totalOrderPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Data.paidStatus))]),_vm._v(" "),_c('td')]):_vm._e()})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_bag")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("sell")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("אין לך גישה")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart_checkout")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("אין לך גישה")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("groups")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overviewText"},[_c('span',{staticClass:"titleText"},[_vm._v("אין לך גישה")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBox"},[_c('i',{staticClass:"material-icons stockIcon"},[_vm._v("inventory_2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stockList"},[_c('div',{staticClass:"itemList"},[_vm._v("\n                        עוגה מרובעת 5 פסים\n                    ")]),_vm._v(" "),_c('div',{staticClass:"itemList"},[_vm._v("\n                        test\n                    ")]),_vm._v(" "),_c('div',{staticClass:"itemList"},[_vm._v("\n                        test\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart_checkout")])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("הוצאות אחרונות")]),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('input',{attrs:{"type":"text","placeholder":"חיפוש בהוצאות"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("הוצאה עבור")]),_vm._v(" "),_c('th',[_vm._v("תאריך")]),_vm._v(" "),_c('th',[_vm._v("סכום")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_bag")])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("הזמנות אחרונות")]),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('input',{attrs:{"type":"text","placeholder":"חיפוש הזמנות"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("מספר")]),_vm._v(" "),_c('th',[_vm._v("שם")]),_vm._v(" "),_c('th',[_vm._v("מספר טלפון")]),_vm._v(" "),_c('th',[_vm._v("יום")]),_vm._v(" "),_c('th',[_vm._v("תאריך")]),_vm._v(" "),_c('th',[_vm._v("שעה")]),_vm._v(" "),_c('th',[_vm._v("סטטוס")]),_vm._v(" "),_c('th',[_vm._v("סכום")]),_vm._v(" "),_c('th',[_vm._v("גבייה")]),_vm._v(" "),_c('th')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secret_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fc6906_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Secret_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8fc6906"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secret_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fc6906_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Secret_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secret-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"section"},_vm._l((_vm.secrets),function(secret,index){return _c('div',{staticClass:"secret-card"},[_c('span',{staticClass:"secret-item-name"},[_vm._v(_vm._s(secret.Data.name))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(secret.Data.note))])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secret-header"},[_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"header-title"},[_vm._v("\n          מתכונים\n        ")])]),_vm._v(" "),_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"secret-inputs"},[_c('input',{attrs:{"type":"text","placeholder":"חיפוש מתכון"}}),_vm._v(" "),_c('button',[_vm._v("מתכון חדש + ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedOrder_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a72f40a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedOrder_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a72f40a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectedOrderContainer"},[_c('div',{staticClass:"orderId"},[_c('span',{staticClass:"orderZehot"},[_vm._v(" הזמנה")]),_vm._v(" "),_c('span',{staticClass:"orderIdStyle"},[_vm._v(_vm._s(_vm.$root.selectedOrderObj.ID))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"orderIdStyle"},[_vm._v(" התקבלה בתאריך  "+_vm._s(_vm.$root.selectedOrderObj.Data.createdDate)+"  ")]),_vm._v(" "),_c('span',{staticClass:"orderIdStyle",staticStyle:{"color":"#1c1c1c","font-weight":"500"}},[_vm._v(" |  הונפקה על ידי   "+_vm._s(_vm.$root.selectedOrderObj.Data.workerName)+" ")])]),_vm._v(" "),(_vm.editOrder)?_c('div',{staticClass:"orderDataBox borders"},[_c('div',{staticClass:"boxHeader"},[_c('span',{staticClass:"orderName"},[_vm._v(_vm._s(_vm.$root.selectedOrderObj.Data.fullname))]),_vm._v(" "),_c('button',{staticClass:"deleteBtn",on:{"click":function($event){return _vm.deleteOrder(_vm.$root.selectedOrderObj.ID)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("delete_outline")])]),_vm._v(" "),_c('button',{staticClass:"editBtn",on:{"click":function($event){_vm.editOrder = !_vm.editOrder}}},[_c('span',{staticClass:"material-icons"},[_vm._v("edit")])]),_vm._v(" "),_c('span',{staticClass:"selectedOrderPrice"},[_vm._v(_vm._s(_vm.$root.selectedOrderObj.Data.priceOrder)+" ₪")])]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"fullname"}},[_vm._v("שם מלא")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.fullname),expression:"$root.selectedOrderObj.Data.fullname"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "fullname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"phoneNumber"}},[_vm._v("מספר הטלפון")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.phoneNumber),expression:"$root.selectedOrderObj.Data.phoneNumber"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"dateOrder"}},[_vm._v("תאריך")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.dateOrder),expression:"$root.selectedOrderObj.Data.dateOrder"}],attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.dateOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "dateOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"dayOrder"}},[_vm._v("יום")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.dayOrder),expression:"$root.selectedOrderObj.Data.dayOrder"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.dayOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "dayOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"timeOrder"}},[_vm._v("שעה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.timeOrder),expression:"$root.selectedOrderObj.Data.timeOrder"}],attrs:{"type":"time","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.timeOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "timeOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("טעם העוגה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.cakeTaste),expression:"$root.selectedOrderObj.Data.cakeTaste"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.cakeTaste)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "cakeTaste", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("גודל העוגה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.cakeSize),expression:"$root.selectedOrderObj.Data.cakeSize"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.cakeSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "cakeSize", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("מחיר ההזמנה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.priceOrder),expression:"$root.selectedOrderObj.Data.priceOrder"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.$root.selectedOrderObj.Data.priceOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "priceOrder", $event.target.value)}}})])]):_c('div',{staticClass:"orderDataBox borders"},[_c('div',{staticClass:"boxHeader"},[_c('span',{staticClass:"orderName"},[_vm._v(_vm._s(_vm.$root.selectedOrderObj.Data.fullname))]),_vm._v(" "),_c('button',{staticClass:"deleteBtn",on:{"click":function($event){return _vm.deleteOrder(_vm.$root.selectedOrderObj.ID)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("delete_outline")])]),_vm._v(" "),_c('button',{staticClass:"editBtn",on:{"click":function($event){_vm.editOrder = !_vm.editOrder}}},[_c('span',{staticClass:"material-icons"},[_vm._v("edit")])]),_vm._v(" "),_c('span',{staticClass:"selectedOrderPrice"},[_vm._v(_vm._s(_vm.$root.selectedOrderObj.Data.priceOrder)+" ₪")])]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"fullname"}},[_vm._v("שם מלא")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.fullname),expression:"$root.selectedOrderObj.Data.fullname"}],attrs:{"type":"text"},domProps:{"value":(_vm.$root.selectedOrderObj.Data.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "fullname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"phoneNumber"}},[_vm._v("מספר הטלפון")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.phoneNumber),expression:"$root.selectedOrderObj.Data.phoneNumber"}],attrs:{"type":"text"},domProps:{"value":(_vm.$root.selectedOrderObj.Data.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"dateOrder"}},[_vm._v("תאריך")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.dateOrder),expression:"$root.selectedOrderObj.Data.dateOrder"}],attrs:{"type":"date"},domProps:{"value":(_vm.$root.selectedOrderObj.Data.dateOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "dateOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',[_vm._v("יום האספקה")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.dayOrder),expression:"$root.selectedOrderObj.Data.dayOrder"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$root.selectedOrderObj.Data, "dayOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"ראשון"}},[_vm._v("ראשון")]),_vm._v(" "),_c('option',{attrs:{"value":"שני "}},[_vm._v("שני")]),_vm._v(" "),_c('option',{attrs:{"value":"שלישי"}},[_vm._v("שלישי")]),_vm._v(" "),_c('option',{attrs:{"value":"רביעי"}},[_vm._v("רביעי")]),_vm._v(" "),_c('option',{attrs:{"value":"חמישי"}},[_vm._v("חמישי ")]),_vm._v(" "),_c('option',{attrs:{"value":"שישי"}},[_vm._v("שישי")]),_vm._v(" "),_c('option',{attrs:{"value":"שבת"}},[_vm._v("שבת")])])]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"timeOrder"}},[_vm._v("שעה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.timeOrder),expression:"$root.selectedOrderObj.Data.timeOrder"}],attrs:{"type":"time"},domProps:{"value":(_vm.$root.selectedOrderObj.Data.timeOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "timeOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("טעם העוגה")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.cakeTaste),expression:"$root.selectedOrderObj.Data.cakeTaste"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$root.selectedOrderObj.Data, "cakeTaste", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"נסיך"}},[_vm._v("נסיך")]),_vm._v(" "),_c('option',{attrs:{"value":"ריבת חלב"}},[_vm._v("ריבת חלב")]),_vm._v(" "),_c('option',{attrs:{"value":"מוס שוקוניל"}},[_vm._v("מוס שוקוניל")]),_vm._v(" "),_c('option',{attrs:{"value":"רוגינצי"}},[_vm._v("רוגינצי")]),_vm._v(" "),_c('option',{attrs:{"value":"גפוניז"}},[_vm._v("גפוניז")])])]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("גודל העוגה")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.cakeSize),expression:"$root.selectedOrderObj.Data.cakeSize"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$root.selectedOrderObj.Data, "cakeSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"3.5 פסים"}},[_vm._v("3.5 פסים")]),_vm._v(" "),_c('option',{attrs:{"value":"5 פסים"}},[_vm._v("5 פסים")]),_vm._v(" "),_c('option',{attrs:{"value":"עגולה"}},[_vm._v("עגולה")])])]),_vm._v(" "),_c('div',{staticClass:"orderInputField"},[_c('label',{attrs:{"for":"cakeTaste"}},[_vm._v("מחיר ההזמנה")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.selectedOrderObj.Data.priceOrder),expression:"$root.selectedOrderObj.Data.priceOrder"}],attrs:{"type":"text"},domProps:{"value":(_vm.$root.selectedOrderObj.Data.priceOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.selectedOrderObj.Data, "priceOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"orderBtnField"},[_c('button',{on:{"click":_vm.updateOrderData}},[_vm._v("שמור שינויים")])])]),_vm._v(" "),_c('div',{staticClass:"ordermedia borders"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.$root.selectedOrderObj.Data.orderImg),function(image){return _c('div',{staticClass:"orderImages"},[_c('img',{attrs:{"src":image,"width":"80px"}})])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxHeader"},[_c('span',{staticClass:"orderName"},[_vm._v("מדיה")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84de3f8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__ = __webpack_require__(611);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84de3f8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"rightBox"},[_c('div',{staticClass:"formBox"},[_c('h1',[_vm._v("ברוך הבא")]),_vm._v(" "),_c('span',[_vm._v("מערכת ניהול הזמנות פנימית")]),_vm._v(" "),(_vm.wrongPassword)?_c('div',{staticClass:"error"},[_vm._v("\n                    "+_vm._s(_vm.wrongPassword)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inputField"},[_c('label',[_vm._v("שם משתמש")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.LoginUser.username),expression:"LoginUser.username"}],attrs:{"type":"text","placeholder":"שם המשתמש"},domProps:{"value":(_vm.LoginUser.username)},on:{"keydown":function($event){return _vm.nameKeydown($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signIn()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.LoginUser, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"inputField"},[_c('label',[_vm._v("סיסמה")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.LoginUser.password),expression:"LoginUser.password"}],attrs:{"type":"password","placeholder":"********"},domProps:{"value":(_vm.LoginUser.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signIn()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.LoginUser, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"inputField"},[_c('button',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("כניסה למערכת")])])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftBox"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/greenhousecakes.appspot.com/o/orders%2Flogo.png?alt=media&token=c6db6348-f389-4dac-817e-63a0c5d69c2b","alt":""}}),_vm._v(" "),_c('div',{staticClass:"area"},[_c('ul',{staticClass:"circles"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddWorkers_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28013819_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddWorkers_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28013819"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddWorkers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28013819_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddWorkers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workerContainer"},_vm._l((_vm.Users),function(User,index){return _c('div',{staticClass:"workerCard"},[_c('div',{staticClass:"imgDiv"},[_c('img',{staticClass:"profileImg",attrs:{"src":User.profileImg,"alt":""}})]),_vm._v(" "),_c('b',{staticClass:"profileName"},[_vm._v(_vm._s(User.firstName + " " + User.lastName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(User.Type == 'Manager'),expression:"User.Type == 'Manager'"}],staticClass:"profileRole"},[_vm._v("מנהל")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(User.Type == 'Worker'),expression:"User.Type == 'Worker'"}],staticClass:"profileRole"},[_vm._v("עובד/ת")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(User.Type == 'Admin'),expression:"User.Type == 'Admin'"}],staticClass:"profileRole"},[_vm._v("מנהל המערכת")]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"btnBox"},[_c('button',{on:{"click":function($event){return _vm.logoutUser(User)}}},[_vm._v("ניתוק משתמש")])])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnBox"},[_c('button',[_vm._v("הגדרות הפרופיל")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Meheron_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b08910_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Meheron_vue__ = __webpack_require__(617);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Meheron_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b08910_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Meheron_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerMeh"},[_c('div',{staticClass:"addNewMeh"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mehForm"},[_c('div',{staticClass:"mehInputField"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productName),expression:"productName"}],attrs:{"type":"text","placeholder":"שם המוצר"},domProps:{"value":(_vm.productName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productPrice),expression:"productPrice"}],attrs:{"type":"number","placeholder":"מחירון ₪"},domProps:{"value":(_vm.productPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productPrice=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dealerName),expression:"dealerName"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dealerName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v(" -- בחר שם הספק -- ")]),_vm._v(" "),_vm._l((_vm.Dealers),function(dealer){return _c('option',{domProps:{"value":dealer.Data.selectDealerName}},[_vm._v(_vm._s(dealer.Data.selectDealerName))])})],2)]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.uploadImage}})]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('input',{attrs:{"type":"submit"},on:{"click":function($event){return _vm.addProductMeheron()}}})])])]),_vm._v(" "),_c('div',{staticClass:"loadProducts"},[_c('button',{staticClass:"edit-btn",on:{"click":function($event){_vm.EditProduct = !_vm.EditProduct}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]),_vm._v(" "),_vm._l((_vm.Meheronem),function(product){return (_vm.EditProduct)?_c('div',{staticClass:"product"},[_c('img',{attrs:{"src":product.Data.productImg,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"prodName"},[_vm._v(_vm._s(product.Data.productName))]),_vm._v(" "),_c('span',{staticClass:"prodPrice"},[_vm._v("₪"+_vm._s(product.Data.productPrice)+" ")]),_vm._v(" "),_c('span',{staticClass:"prodDealer"},[_vm._v(_vm._s(product.Data.dealerName))])]):_vm._l((_vm.Meheronem),function(eProduct){return _c('div',{staticClass:"product"},[_c('img',{attrs:{"src":eProduct.Data.productImg,"alt":""}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(eProduct.Data.productName),expression:"eProduct.Data.productName"}],attrs:{"type":"text"},domProps:{"value":(eProduct.Data.productName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(eProduct.Data, "productName", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(eProduct.Data.productPrice),expression:"eProduct.Data.productPrice"}],attrs:{"type":"text"},domProps:{"value":(eProduct.Data.productPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(eProduct.Data, "productPrice", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(eProduct.Data.dealerName),expression:"eProduct.Data.dealerName"}],attrs:{"type":"text"},domProps:{"value":(eProduct.Data.dealerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(eProduct.Data, "dealerName", $event.target.value)}}})])})})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mehTitle"},[_c('h1',[_vm._v("הוספת מוצר ומחירון")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateOrderBeta_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b826fe08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateOrderBeta_vue__ = __webpack_require__(626);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b826fe08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateOrderBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b826fe08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateOrderBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createOrder"},[(_vm.isLoading)?_c('div',{staticClass:"loadingModal"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rightSide"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("יצירת הזמנה חדשה")]),_vm._v(" "),_c('span',{staticClass:"orderNum"},[_vm._v("#"+_vm._s(_vm.counter.orderNumber))])]),_vm._v(" "),_c('div',{staticClass:"steps"},[_c('ul',{staticClass:"subMenu"},[_c('li',{staticClass:"listItem",class:[_vm.activeItemBar == 1 ? 'activeItem' : 'listItem'],on:{"click":function($event){_vm.activeItemBar = 1}}},[_vm._v("פרטי הלקוח")]),_vm._v(" "),_c('li',{staticClass:"listItem",class:[_vm.activeItemBar == 2 ? 'activeItem' : 'listItem'],on:{"click":function($event){_vm.activeItemBar = 2}}},[_vm._v("פרטי ההזמנה")]),_vm._v(" "),_c('li',{staticClass:"listItem",class:[_vm.activeItemBar == 3 ? 'activeItem' : 'listItem'],on:{"click":function($event){_vm.activeItemBar = 3}}},[_vm._v("העלאת תמונות")]),_vm._v(" "),_c('li',{staticClass:"listItem",class:[_vm.activeItemBar == 4 ? 'activeItem' : 'listItem'],on:{"click":function($event){_vm.activeItemBar = 4}}},[_vm._v("שיטת תשלום")])])]),_vm._v(" "),(_vm.activeItemBar == 1)?_c('div',{staticClass:"boxStyle"},[_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" שם מלא")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullname),expression:"fullname"}],attrs:{"type":"text","placeholder":"נא להכנס את שם הלקוח "},domProps:{"value":(_vm.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" מספר הטלפון")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],attrs:{"type":"text","placeholder":"נא להכנס את מספר הטלפון "},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 2)?_c('div',{staticClass:"boxStyle"},[_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" תאריך")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateOrder),expression:"dateOrder"}],attrs:{"type":"date"},domProps:{"value":(_vm.dateOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateOrder=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" יום")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dayOrder),expression:"dayOrder"}],staticClass:"col-3",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dayOrder=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר יום")]),_vm._v(" "),_c('option',{attrs:{"value":"ראשון"}},[_vm._v("ראשון")]),_vm._v(" "),_c('option',{attrs:{"value":"שני "}},[_vm._v("שני")]),_vm._v(" "),_c('option',{attrs:{"value":"שלישי"}},[_vm._v("שלישי")]),_vm._v(" "),_c('option',{attrs:{"value":"רביעי"}},[_vm._v("רביעי")]),_vm._v(" "),_c('option',{attrs:{"value":"חמישי"}},[_vm._v("חמישי ")]),_vm._v(" "),_c('option',{attrs:{"value":"שישי"}},[_vm._v("שישי")]),_vm._v(" "),_c('option',{attrs:{"value":"שבת"}},[_vm._v("שבת")])])]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" שעה")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeOrder),expression:"timeOrder"}],staticClass:"col-3",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timeOrder=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר שעה")]),_vm._v(" "),_c('option',{attrs:{"value":"09:00"}},[_vm._v("09:00")]),_vm._v(" "),_c('option',{attrs:{"value":"09:30"}},[_vm._v("09:30")]),_vm._v(" "),_c('option',{attrs:{"value":"10:00"}},[_vm._v("10:00")]),_vm._v(" "),_c('option',{attrs:{"value":"10:30"}},[_vm._v("10:30")]),_vm._v(" "),_c('option',{attrs:{"value":"11:00"}},[_vm._v("11:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"11:30"}},[_vm._v("11:30")]),_vm._v(" "),_c('option',{attrs:{"value":"12:00"}},[_vm._v("12:00")]),_vm._v(" "),_c('option',{attrs:{"value":"12:30"}},[_vm._v("12:30")]),_vm._v(" "),_c('option',{attrs:{"value":"13:00"}},[_vm._v("13:00")]),_vm._v(" "),_c('option',{attrs:{"value":"13:30"}},[_vm._v("13:30")]),_vm._v(" "),_c('option',{attrs:{"value":"14:00"}},[_vm._v("14:00")]),_vm._v(" "),_c('option',{attrs:{"value":"14:30"}},[_vm._v("14:30 ")]),_vm._v(" "),_c('option',{attrs:{"value":"15:00"}},[_vm._v("15:00")]),_vm._v(" "),_c('option',{attrs:{"value":"15:30"}},[_vm._v("15:30")]),_vm._v(" "),_c('option',{attrs:{"value":"16:00"}},[_vm._v("16:00")]),_vm._v(" "),_c('option',{attrs:{"value":"16:30"}},[_vm._v("16:30")]),_vm._v(" "),_c('option',{attrs:{"value":"17:00"}},[_vm._v("17:00")]),_vm._v(" "),_c('option',{attrs:{"value":"17:30"}},[_vm._v("17:30")]),_vm._v(" "),_c('option',{attrs:{"value":"18:00"}},[_vm._v("18:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"18:30"}},[_vm._v("18:30")]),_vm._v(" "),_c('option',{attrs:{"value":"19:00"}},[_vm._v("19:00")]),_vm._v(" "),_c('option',{attrs:{"value":"19:30"}},[_vm._v("19:30")]),_vm._v(" "),_c('option',{attrs:{"value":"20:00"}},[_vm._v("20:00")]),_vm._v(" "),_c('option',{attrs:{"value":"20:30"}},[_vm._v("20:30")]),_vm._v(" "),_c('option',{attrs:{"value":"21:00"}},[_vm._v("21:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"21:30"}},[_vm._v("21:30")])])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 2)?_c('div',{staticClass:"categories"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collection"},[_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProductsToOrder()}}},[_c('span',[_vm._v("עוגות מרובעות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadCircleCakes()}}},[_c('span',[_vm._v("עוגות עגולות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBiscuit()}}},[_c('span',[_vm._v("עוגיות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadPasim()}}},[_c('span',[_vm._v("פסים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadCoufsaot()}}},[_c('span',[_vm._v("קופסאות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadMghashim()}}},[_c('span',[_vm._v("מגשים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadOneUse()}}},[_c('span',[_vm._v("חד פעמי")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadDrinks()}}},[_c('span',[_vm._v("שתיה")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadHataifim()}}},[_c('span',[_vm._v("חטיפים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBakingCakes()}}},[_c('span',[_vm._v("שמרים")])])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 2 && _vm.activeProductsBar == 1)?_c('div',{staticClass:"categories"},[_c('div',{staticClass:"catHeader"},[_c('span',[_vm._v("בחר מוצרים")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חפש מוצר"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"collection"},_vm._l((_vm.filteredProducts),function(item){return _c('div',{staticClass:"product",on:{"click":function($event){return _vm.addToCart(item)}}},[_c('span',{staticClass:"productName"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"productPrice"},[_vm._v("₪"+_vm._s(item.Data.Price))]),_vm._v(" "),_c('span',{staticClass:"productQuantity"},[_vm._v(" "+_vm._s(item.Data.Quantity)+" במלאי")])])}),0)]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 3)?_c('div',{staticClass:"boxStyle"},[_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" העלאת תמונות")]),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.uploadImage}})])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 3)?_c('div',{staticClass:"uploadedPhotos"},[_c('div',{staticClass:"photosHeader"},[_vm._v("\n            תמונות שהועלאו\n        ")]),_vm._v(" "),_c('div',{staticClass:"photos"},_vm._l((_vm.orderImg),function(img,i){return _c('div',{key:i},[_c('img',{attrs:{"src":img,"alt":"","width":"120px"}})])}),0)]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 4)?_c('div',{staticClass:"paymentStyle"},[_c('div',{staticClass:"title"},[_vm._v("\n            הוספת הערה להזמנה\n        ")]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"noteField"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],attrs:{"placeholder":"הערה \\ ملاحظة"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n            סטטוס גבייה\n        ")]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"cash","value":"שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"שולם")},on:{"change":function($event){_vm.paidStatus="שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("price_check")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("שולם")])]),_vm._v(" "),_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"creditCard","value":"לא שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"לא שולם")},on:{"change":function($event){_vm.paidStatus="לא שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("money_off")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("לא שולם")])])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 1)?_c('div',{staticClass:"forward"},[_c('button',{on:{"click":function($event){_vm.activeItemBar  = 2}}},[_vm._v("שלב הבא")])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 2)?_c('div',{staticClass:"forward"},[_c('button',{on:{"click":function($event){_vm.activeItemBar  = 3}}},[_vm._v("שלב הבא")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.activeItemBar  = 1}}},[_vm._v(" ~ חזרה אחורה  ")])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 3)?_c('div',{staticClass:"forward"},[_c('button',{on:{"click":function($event){_vm.activeItemBar  = 4}}},[_vm._v("שלב הבא")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.activeItemBar  = 2}}},[_vm._v(" ~ חזרה אחורה  ")])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 4)?_c('div',{staticClass:"forward"},[_c('button',{on:{"click":function($event){return _vm.sendOrder()}}},[_vm._v("שלח הזמנה")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.activeItemBar  = 3}}},[_vm._v(" ~ חזרה אחורה  ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"leftSide"},[_c('div',{staticClass:"cartbox"},[_c('div',{staticClass:"cartHeader"},[_vm._v("\n                    סל הקניות\n            ")]),_vm._v(" "),(this.cart.length <= 0)?_c('div',{staticStyle:{"text-align":"center","padding":"70px"}},[_vm._v(" \n                אין מוצרים בסל הקניות\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.cart),function(product,index){return _c('div',{key:index,staticClass:"ProductLine"},[_c('span',{staticClass:"selectedQuantity"},[_vm._v(" x"+_vm._s(product.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(product.Data.Name)+" ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(" ₪"+_vm._s(product.Data.Price * product.selectedCount)+" ")]),_vm._v(" "),_c('div',{staticClass:"tools"},[_c('ul',[_c('li',{staticClass:"removeBtn",on:{"click":function($event){return _vm.removeItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("clear")])]),_vm._v(" "),_c('li',{staticClass:"increaseBtn",on:{"click":function($event){return _vm.addToCart(product)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('li',{staticClass:"reduceBtn",on:{"click":function($event){return _vm.reduceItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("remove")])])])])])}),_vm._v(" "),_c('div',{staticClass:"totalPrice"},[_c('div',{staticClass:"discountLabel"},[_c('label',[_vm._v("הנחה \\ שולם חלקי")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.discount),expression:"discount",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"הנחה"},domProps:{"value":(_vm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.discount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("סה\"כ לתשלום")]),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v(" ₪"+_vm._s(_vm.totalOrderPrice - _vm.discount))])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catHeader"},[_c('span',[_vm._v("בחר קטגוריה")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newOrderbeta_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d8f586_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newOrderbeta_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5d8f586"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newOrderbeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d8f586_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newOrderbeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},_vm._l((_vm.days),function(day,index){return _c('div',{key:index,class:['day-card', { selected: _vm.selectedDate === day.dateKey }],on:{"click":function($event){return _vm.selectDate(day)}}},[_c('div',{staticClass:"day-name"},[_vm._v(_vm._s(day.dayName))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.dateString))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarTime_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d30b0f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarTime_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05d30b0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d30b0f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},_vm._l((_vm.timeSlots),function(slot,index){return _c('div',{key:index,class:['day-card', { selected: _vm.selectedTime === slot.value }],on:{"click":function($event){return _vm.selectTime(slot)}}},[_c('div',{staticClass:"day-name"},[_vm._v(_vm._s(slot.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.showPreview)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showPreview = true}}},[_c('div',{staticClass:"modal-content modern-modal"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.showPreview = false}}},[_vm._v("✕")])]),_vm._v(" "),_c('div',{staticClass:"info-grid"},[_c('div',{staticClass:"info-box"},[_c('label',[_vm._v("שם")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fullname))])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('label',[_vm._v("מספר טלפון")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phoneNumber))])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('label',[_vm._v("תאריך")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedDateReadable))])]),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('label',[_vm._v("שעה")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.timeOrder))])])]),_vm._v(" "),_c('div',{staticClass:"cart-section"},[_c('div',{staticClass:"section-title"},[_vm._v("פרטי הזמנה")]),_vm._v(" "),_c('div',{staticClass:"cart-list"},_vm._l((_vm.cart),function(product,index){return _c('div',{key:index,staticClass:"cart-item"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"qty"},[_vm._v("x"+_vm._s(product.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(product.Data.Name))])]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("\n            ₪"+_vm._s(product.Data.Price * product.selectedCount)+"\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"summary"},[_c('div',{staticClass:"discount"},[_c('label',[_vm._v("הנחה")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.discount),expression:"discount",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"0"},domProps:{"value":(_vm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.discount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"total"},[_c('span',[_vm._v("סה\"כ")]),_vm._v(" "),_c('strong',[_vm._v("₪"+_vm._s(_vm.totalOrderPrice - _vm.discount))])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn-cancel",on:{"click":function($event){_vm.showPreview = false}}},[_vm._v("חזרה")]),_vm._v(" "),_c('button',{staticClass:"btn-confirm",on:{"click":function($event){return _vm.sendOrder()}}},[_vm._v("אישור הזמנה")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"newOrderSection"},[_c('div',{staticClass:"createOrder-template"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"head"},[_c('span',{staticClass:"page-title"},[_vm._v("יצירת הזמנה חדשה")]),_vm._v(" "),_c('span',{staticClass:"counter-badge"},[_vm._v("#"+_vm._s(_vm.counter.orderNumber))])])]),_vm._v(" "),_c('div',{staticClass:"order-form"},[(_vm.loadingCounter)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-item"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"first-step"},[(!_vm.isFirstStep)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToPrevious.apply(null, arguments)}}},[_vm._v(" < חזרה ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                    "+_vm._s(_vm.stepTitle)+"\n                ")]),_vm._v(" "),(_vm.activeItemBar === 1)?_c('div',{staticClass:"form-inputs"},[_c('div',{staticClass:"input-field"},[_c('label',{attrs:{"for":""}},[_vm._v("שם לקוח")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullname),expression:"fullname"}],attrs:{"type":"text","placeholder":"שם לקוח"},domProps:{"value":(_vm.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('label',{attrs:{"for":""}},[_vm._v("מספר טלפון")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],attrs:{"type":"number","placeholder":"מספר טלפון"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('button',{on:{"click":function($event){return _vm.goToNext()}}},[_vm._v("המשך ")])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar === 2)?_c('div',{staticClass:"form-inputs"},[_c('div',{staticClass:"input-field"},[_c('label',{attrs:{"for":""}},[_vm._v("בחירת יום ותאריך")]),_vm._v(" "),_c('Calendar',{on:{"date-selected":_vm.handleDateSelected}})],1),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('label',{attrs:{"for":""}},[_vm._v("בחירת שעה")]),_vm._v(" "),_c('CalendarTime',{on:{"time-selected":_vm.handleTimeSelect}})],1),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('button',{on:{"click":function($event){return _vm.goToNext()}}},[_vm._v("המשך ")])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar === 3)?_c('div',{staticClass:"form-inputs"},[_c('span',[_vm._v("בחירת קטגוריה")]),_vm._v(" "),_c('div',{staticClass:"categories"},[_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('עוגות מרובעות')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("עוגות מרובעות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('עוגות עגולות')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("עוגות עגולות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('פסים')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("פסים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('קופסאות')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("קופסאות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('מגשים')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("מגשים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('שמרים')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("שמרים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProducts('חד פעמי')}}},[_c('span',{staticClass:"category-icon"},[_c('svg',{staticClass:"lucide lucide-archive-icon lucide-archive",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"20","height":"5","x":"2","y":"3","rx":"1"}}),_c('path',{attrs:{"d":"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"}}),_c('path',{attrs:{"d":"M10 12h4"}})])]),_vm._v(" "),_c('span',{staticClass:"category-name"},[_vm._v("חד פעמי")])])]),_vm._v(" "),(_vm.activeItemBar == 3 && _vm.activeProductsBar == 1)?_c('span',[_vm._v("בחירת מוצרים")]):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 3 && _vm.activeProductsBar == 1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],staticClass:"search-input-products",attrs:{"type":"text","placeholder":"חיפוש מוצר"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.activeItemBar == 3 && _vm.activeProductsBar == 1)?_c('div',{staticClass:"products"},_vm._l((_vm.filteredProducts),function(item){return _c('div',{staticClass:"product",on:{"click":function($event){return _vm.addToCart(item)}}},[_c('img',{staticClass:"product-image",attrs:{"src":item.Data.imageUrl,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"product-price"},[_vm._v("₪"+_vm._s(item.Data.Price))])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('button',{on:{"click":function($event){return _vm.goToNext()}}},[_vm._v("המשך ")])])]):_vm._e(),_vm._v(" "),(_vm.activeItemBar === 4)?_c('div',{staticClass:"form-inputs"},[_c('div',{staticClass:"title"},[_vm._v("\n                הוספת הערה להזמנה\n            ")]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"noteField"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],attrs:{"placeholder":"הערה \\ ملاحظة"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                סטטוס גבייה\n            ")]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"cash","value":"שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"שולם")},on:{"change":function($event){_vm.paidStatus="שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("price_check")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("שולם")])]),_vm._v(" "),_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"creditCard","value":"לא שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"לא שולם")},on:{"change":function($event){_vm.paidStatus="לא שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("money_off")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("לא שולם")])])]),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('button',{on:{"click":function($event){_vm.showPreview = true}}},[_vm._v("אישור  ")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cart-btn",on:{"click":_vm.openCartModal}},[_c('span',{staticClass:"badge"},[_vm._v("\n                "+_vm._s(_vm.cartItemCount)+"\n            ")]),_vm._v(" "),(_vm.openCart)?_c('svg',{staticClass:"lucide lucide-circle-x-icon lucide-circle-x",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"d":"m15 9-6 6"}}),_c('path',{attrs:{"d":"m9 9 6 6"}})]):_c('svg',{staticClass:"lucide lucide-shopping-basket-icon lucide-shopping-basket",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"m15 11-1 9"}}),_c('path',{attrs:{"d":"m19 11-4-7"}}),_c('path',{attrs:{"d":"M2 11h20"}}),_c('path',{attrs:{"d":"m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"}}),_c('path',{attrs:{"d":"M4.5 15.5h15"}}),_c('path',{attrs:{"d":"m5 11 4-7"}}),_c('path',{attrs:{"d":"m9 11 1 9"}})])]),_vm._v(" "),(_vm.openCart)?_c('div',{staticClass:"modal-cart"},[(this.cart.length <= 0)?_c('div',{staticStyle:{"text-align":"center","padding":"70px"}},[_vm._v(" \n                    אין מוצרים בסל הקניות\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.cart),function(product,index){return _c('div',{key:index,staticClass:"ProductLine"},[_c('span',{staticClass:"selectedQuantity"},[_vm._v(" x"+_vm._s(product.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(product.Data.Name)+" ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(" ₪"+_vm._s(product.Data.Price * product.selectedCount)+" ")]),_vm._v(" "),_c('div',{staticClass:"tools"},[_c('ul',[_c('li',{staticClass:"removeBtn",on:{"click":function($event){return _vm.removeItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("clear")])]),_vm._v(" "),_c('li',{staticClass:"increaseBtn",on:{"click":function($event){return _vm.addToCart(product)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('li',{staticClass:"reduceBtn",on:{"click":function($event){return _vm.reduceItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("remove")])])])])])}),_vm._v(" "),_c('div',{staticClass:"totalPrice"},[_c('div',{staticClass:"discountLabel"},[_c('label',[_vm._v("הנחה \\ שולם חלקי")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.discount),expression:"discount",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"הנחה"},domProps:{"value":(_vm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.discount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("סה\"כ לתשלום")]),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v(" ₪"+_vm._s(_vm.totalOrderPrice - _vm.discount))])])],2):_vm._e()])]),_vm._v(" "),(_vm.successAdded)?_c('div',{staticClass:"success-added"},[_c('svg',{staticClass:"lucide lucide-package-check-icon lucide-package-check",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"m16 16 2 2 4-4"}}),_c('path',{attrs:{"d":"M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"}}),_c('path',{attrs:{"d":"m7.5 4.27 9 5.15"}}),_c('polyline',{attrs:{"points":"3.29 7 12 12 20.71 7"}}),_c('line',{attrs:{"x1":"12","x2":"12","y1":"22","y2":"12"}})]),_vm._v(" "),_c('span',[_vm._v("המוצר נוסף לסל")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("אישור הזמנה")]),_vm._v(" "),_c('p',[_vm._v("נא לוודא שהפרטים נכונים")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedOrderBeta_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e58392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedOrderBeta_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65e58392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedOrderBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e58392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedOrderBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"loadingModal"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),(_vm.ProductsModal)?_c('div',{staticClass:"ProductsModal"},[_c('div',{staticClass:"productsBox"},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("הוספת מוצר להזמנה")]),_vm._v(" "),_c('button',{on:{"click":_vm.closeModal}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"collection"},[_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBigCakes()}}},[_c('span',[_vm._v("עוגות מרובעות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadCircleCakes()}}},[_c('span',[_vm._v("עוגות עגולות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBiscuit()}}},[_c('span',[_vm._v("עוגיות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadPasim()}}},[_c('span',[_vm._v("פסים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadKofsaot()}}},[_c('span',[_vm._v("קופסאות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadMagashim()}}},[_c('span',[_vm._v("מגשים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadOneUse()}}},[_c('span',[_vm._v("חד פעמי")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadDrinks()}}},[_c('span',[_vm._v("שתיה")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadHatifim()}}},[_c('span',[_vm._v("חטיפים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadShmareem()}}},[_c('span',[_vm._v("שמרים")])])]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.selectedCategory))]),_vm._v(" "),_c('div',{staticClass:"collection"},_vm._l((_vm.filteredProducts),function(item){return _c('div',{staticClass:"product",on:{"click":function($event){return _vm.pushToCart(item)}}},[_c('span',{staticClass:"productName"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"productPrice"},[_vm._v("₪"+_vm._s(item.Data.Price))]),_vm._v(" "),_c('span',{staticClass:"productQuantity"},[_vm._v(" "+_vm._s(item.Data.Quantity)+" במלאי")])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"selectedOrderContainer"},[_c('div',{staticClass:"btn-collection"},[_c('div',{staticClass:"back-field"},[_c('button',{staticClass:"back-btn",on:{"click":function($event){return _vm.backToOrders()}}},[_c('span',{staticClass:"material-icons"},[_vm._v("arrow_forward")])])]),_vm._v(" "),_c('div',{staticClass:"left-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.paidStatus),expression:"orderOBJ.paidStatus"}],class:[_vm.orderOBJ.paidStatus == 'לא שולם' ? 'notPaidStatus' : '', _vm.orderOBJ.paidStatus == 'שולם' ? 'paidStatus' : ''],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orderOBJ, "paidStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updatePayment()}]}},[_c('option',{attrs:{"value":"שולם"}},[_vm._v("שולם")]),_vm._v(" "),_c('option',{attrs:{"value":"לא שולם"}},[_vm._v("לא שולם")])]),_vm._v(" "),(_vm.$root.loggedUser.Type == 'Admin')?_c('button',{staticClass:"back-btn",on:{"click":function($event){return _vm.pushOrderToTrash()}}},[_c('span',{staticClass:"material-icons"},[_vm._v("delete")]),_c('p',[_vm._v("העבר לאשפה")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"recipetContainer"},[_c('div',{staticClass:"recipet"},[_c('span',{staticClass:"ordernumber font-noto"},[_vm._v("\n                הזמנה מס\" #"+_vm._s(_vm.orderOBJ.orderNumber)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"createdDate font-noto"},[_vm._v("\n            "+_vm._s(_vm.orderOBJ.createdDate)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"customerInfo"},[_c('div',{staticClass:"contactInfo"},[_c('div',{staticClass:"contactHeader"},[_c('p',{staticClass:"font-noto clientInfo"},[_vm._v("\n                        פרטי לקוח\n                    ")]),_vm._v(" "),_c('i',{staticClass:"material-icons icon",on:{"click":function($event){return _vm.editInfoFun()}}},[_vm._v(" edit")])]),_vm._v(" "),_c('div',{staticClass:"contactFields"},[_c('div',{staticClass:"contactName"},[_c('label',[_vm._v("שם מלא")]),_vm._v(" "),(!_vm.editInfo)?_c('span',{staticClass:"nameField"},[_vm._v(_vm._s(_vm.orderOBJ.fullname))]):_vm._e(),_vm._v(" "),(_vm.editInfo)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.fullname),expression:"orderOBJ.fullname"}],staticClass:"editField",attrs:{"type":"text"},domProps:{"value":(_vm.orderOBJ.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orderOBJ, "fullname", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contactName"},[_c('label',[_vm._v("מספר טלפון")]),_vm._v(" "),_c('img',{staticClass:"whatsappIcon",attrs:{"src":__webpack_require__(645)},on:{"click":function($event){return _vm.whatsappMessage()}}}),_vm._v(" "),(!_vm.editInfo)?_c('span',{staticClass:"nameField"},[_vm._v(_vm._s(_vm.orderOBJ.phoneNumber))]):_vm._e(),_vm._v(" "),(_vm.editInfo)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.phoneNumber),expression:"orderOBJ.phoneNumber"}],staticClass:"editField",attrs:{"type":"tel"},domProps:{"value":(_vm.orderOBJ.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orderOBJ, "phoneNumber", $event.target.value)}}}):_vm._e()]),_vm._v(" "),(_vm.editInfo)?_c('div',{staticClass:"saveBtn"},[_c('button',{on:{"click":function($event){return _vm.updateOrderData()}}},[_vm._v("שמור שינויים")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contactInfo"},[_c('div',{staticClass:"contactHeader"},[_c('p',{staticClass:"font-noto clientInfo"},[_vm._v("\n                        תאריך אספקה\n                    ")]),_vm._v(" "),_c('i',{staticClass:"material-icons icon",on:{"click":function($event){return _vm.editDatesFun()}}},[_vm._v(" edit")])]),_vm._v(" "),_c('div',{staticClass:"contactFields"},[_c('div',{staticClass:"orderInfo"},[_c('label',[_vm._v("יום אספקה")]),_vm._v(" "),(!_vm.editDates)?_c('span',{staticClass:"nameField"},[_vm._v(_vm._s(_vm.orderOBJ.selectedDateReadable))]):_vm._e(),_vm._v(" "),(_vm.editDates)?_c('div',{staticClass:"edit-section"},[_c('label',[_vm._v("בחר תאריך חדש")]),_vm._v(" "),_c('Calendar',{on:{"date-selected":_vm.updateDate}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"orderInfo"},[_c('label',[_vm._v("שעת אספקה")]),_vm._v(" "),(!_vm.editDates)?_c('span',{staticClass:"nameField"},[_vm._v(_vm._s(_vm.orderOBJ.timeOrder))]):_vm._e(),_vm._v(" "),(_vm.editDates)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.timeOrder),expression:"orderOBJ.timeOrder"}],staticClass:"editField",attrs:{"type":"tel"},domProps:{"value":(_vm.orderOBJ.timeOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orderOBJ, "timeOrder", $event.target.value)}}}):_vm._e()]),_vm._v(" "),(_vm.editDates)?_c('div',{staticClass:"saveBtn"},[_c('button',{on:{"click":function($event){return _vm.updateOrderData()}}},[_vm._v("שמור שינויים")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"orderCart"},[_c('div',{staticClass:"orderCartHeader"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"orderCartLeft"},[_c('div',{staticClass:"plus"},[_c('button',[_c('i',{staticClass:"material-icons",on:{"click":_vm.addToCart}},[_vm._v("add")])])]),_vm._v(" "),_c('div',{staticClass:"pen"},[_c('button',{on:{"click":_vm.editCart}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])])])]),_vm._v(" "),_c('div',{staticClass:"cartList"},_vm._l((_vm.orderOBJ.cart),function(item,index){return _c('div',{staticClass:"cartItem"},[(_vm.editCartItems)?_c('button',{on:{"click":function($event){return _vm.deleteItemFromCart(item,index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v("x"+_vm._s(item.selectedCount)+" | "+_vm._s(item.Data.Name)+" ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v("₪"+_vm._s(item.Data.Price * item.selectedCount))])])}),0),_vm._v(" "),_c('div',{staticClass:"orderNote"},[_c('div',{staticClass:"note"},[(!_vm.editCartItems)?_c('pre',[_vm._v(_vm._s(_vm.orderOBJ.note))]):_vm._e(),_vm._v(" "),(_vm.editCartItems)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.note),expression:"orderOBJ.note"}],attrs:{"type":"text"},domProps:{"value":(_vm.orderOBJ.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orderOBJ, "note", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.editCartItems)?_c('button',{on:{"click":function($event){return _vm.saveNote()}}},[_vm._v("שמור שינויים")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"orderCartFooter"},[_c('div',{staticClass:"line"},[_c('span',{staticClass:"rightText"},[_vm._v("סכום ההזמנה")]),_vm._v(" "),_c('span',{staticClass:"leftText"},[_vm._v("₪"+_vm._s(_vm.orderOBJ.totalOrderPrice))])]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"rightText"},[_vm._v("הנחה")]),_vm._v(" "),_c('span',{staticClass:"leftText"},[_vm._v("₪"+_vm._s(_vm.orderOBJ.discount))])]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"rightText"},[_vm._v("סה\"כ לתשלום")]),_vm._v(" "),_c('span',{staticClass:"leftText"},[_vm._v("₪"+_vm._s(_vm.orderOBJ.totalOrderPrice - _vm.orderOBJ.discount))])])])])])]),_vm._v(" "),_c('div',{staticClass:"media-status-priceBox"},[_c('div',{staticClass:"statusBox"},[_c('div',{staticClass:"statusHeader"},[_c('i',{staticClass:"material-icons icon"},[_vm._v("incomplete_circle")]),_vm._v(" "),_c('p',{staticClass:"font-noto"},[_vm._v("\n                    סטטוס ההזמנה\n                ")]),_vm._v(" "),_c('span',{staticClass:"statusBadge font-noto"},[_vm._v("\n                    "+_vm._s(_vm.orderOBJ.status)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"statusField"},[_c('label',{staticClass:"font-noto",attrs:{"for":""}},[_vm._v("שינוי סטטוס ההזמנה")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.status),expression:"orderOBJ.status"}],attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orderOBJ, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר סטטוס להזמנה")]),_vm._v(" "),_c('option',{attrs:{"value":"מוכנה"}},[_vm._v("מוכנה")]),_vm._v(" "),_c('option',{attrs:{"value":"שלב הכנה"}},[_vm._v("שלב הכנה")]),_vm._v(" "),_c('option',{attrs:{"value":"בוטלה"}},[_vm._v("בוטלה")]),_vm._v(" "),_c('option',{attrs:{"value":"התקבלה"}},[_vm._v("התקבלה")]),_vm._v(" "),_c('option',{attrs:{"value":"נמסרה"}},[_vm._v("נמסרה")])])]),_vm._v(" "),_c('div',{staticClass:"changeBtn"},[_c('button',{staticClass:"font-noto",on:{"click":function($event){return _vm.updateStatus()}}},[_vm._v("שינוי")])])]),_vm._v(" "),_c('div',{staticClass:"statusBox"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"statusField"},[_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.handleFiles}}),_vm._v(" "),(this.progress > 0)?_c('div',[_c('progress',{staticStyle:{"width":"100%"},attrs:{"max":"100"},domProps:{"value":_vm.progress}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.progress)+"%")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"statusBox"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.orderOBJ.orderImg),function(img,index){return _c('div',{key:'img'+index,staticStyle:{"display":"block","width":"100%","margin-top":"10px"}},[_c('i',{staticClass:"material-icons icon",on:{"click":function($event){return _vm.deleteImage(img,index)}}},[_vm._v("delete")]),_vm._v(" "),_c('img',{attrs:{"src":img,"alt":"","width":"100%"}})])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderCartIconBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart")]),_vm._v(" "),_c('span',{staticClass:"orderCartText"},[_vm._v("פרטי הזמנה")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusHeader"},[_c('i',{staticClass:"material-icons icon"},[_vm._v("photo_camera")]),_vm._v(" "),_c('p',{staticClass:"font-noto"},[_vm._v("\n                    הוספת תמונות להזמנה\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusHeader"},[_c('i',{staticClass:"material-icons icon"},[_vm._v("photo_camera")]),_vm._v(" "),_c('p',{staticClass:"font-noto"},[_vm._v("\n                    תמונות\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/whatsapp.4fd2c75.png";

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230debbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-230debbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230debbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventorySection"},[_c('div',{staticClass:"addNewMeh"},[_c('div',{staticStyle:{"display":"flex","gap":"10px","align-items":"center","margin":"10px 0"}},[_c('button',{staticClass:"btnBackfill",attrs:{"disabled":_vm.isBackfilling},on:{"click":_vm.backfillImageFieldForAllProducts}},[_vm._v("\n                    "+_vm._s(_vm.isBackfilling ? 'מעדכן...' : 'הוסף שדה תמונה לכל המוצרים')+"\n                ")]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.isFixing},on:{"click":_vm.fixOrderedTimesForAllProducts}},[_vm._v("\n  "+_vm._s(_vm.isFixing ? 'جاري التحديث...' : 'تحديث orderedTimes لكل المنتجات')+"\n")]),_vm._v(" "),(_vm.backfillReport)?_c('small',{staticStyle:{"color":"#6c757d"}},[_vm._v("\n                    "+_vm._s(_vm.backfillReport)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.succsessMsg))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mehForm"},[_c('div',{staticClass:"mehInputField"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.Name),expression:"item.Name"}],attrs:{"type":"text","placeholder":"שם המוצר"},domProps:{"value":(_vm.item.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "Name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.item.Price),expression:"item.Price",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"מחירון ₪"},domProps:{"value":(_vm.item.Price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "Price", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.category),expression:"item.category"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר קטגוריה")]),_vm._v(" "),_c('option',{attrs:{"value":"עוגות מרובעות"}},[_vm._v("עוגות מרובעות")]),_vm._v(" "),_c('option',{attrs:{"value":"עוגות עגולות"}},[_vm._v("עוגות עגולות")]),_vm._v(" "),_c('option',{attrs:{"value":"פסים"}},[_vm._v("פסים")]),_vm._v(" "),_c('option',{attrs:{"value":"שמרים"}},[_vm._v("שמרים")]),_vm._v(" "),_c('option',{attrs:{"value":"קופסאות"}},[_vm._v("קופסאות")]),_vm._v(" "),_c('option',{attrs:{"value":"מגשים"}},[_vm._v("מגשים ")]),_vm._v(" "),_c('option',{attrs:{"value":"חד פעמי"}},[_vm._v("חד פעמי")]),_vm._v(" "),_c('option',{attrs:{"value":"שתיה"}},[_vm._v("שתיה")]),_vm._v(" "),_c('option',{attrs:{"value":"חטיפים"}},[_vm._v("חטיפים")]),_vm._v(" "),_c('option',{attrs:{"value":"עוגות להזנמות"}},[_vm._v("עוגות להזנמות")])])]),_vm._v(" "),_c('div',{staticClass:"mehInputField"},[_c('input',{attrs:{"type":"submit"},on:{"click":function($event){return _vm.sendProduct()}}})])])]),_vm._v(" "),_c('div',{staticClass:"categoriesList"},[_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadBigCakes()}}},[_vm._v("עוגות מרובעות")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadCircleCakes()}}},[_vm._v("עוגות עגולות")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadPasim()}}},[_vm._v("פסים")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadShmareem()}}},[_vm._v("שמרים")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadKofsaot()}}},[_vm._v("קופסאות")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadOneUse()}}},[_vm._v("חד פעמי")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadMagashim()}}},[_vm._v("מגשים")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadshtea()}}},[_vm._v("שתיה")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadHatifim()}}},[_vm._v("חטיפים")]),_vm._v(" "),_c('div',{staticClass:"categoryItem",on:{"click":function($event){return _vm.loadSpecialCakes()}}},[_vm._v("עוגות להזנמות")])]),_vm._v(" "),_c('div',{staticClass:"searchInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חיפוש"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"productsList"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.filteredProducts),function(item,index){return _c('div',{key:index,staticClass:"productLine"},[(_vm.showIndex !== index)?_c('span',{},[_vm._v(_vm._s(item.Data.Name))]):_vm._e(),_vm._v(" "),(_vm.showIndex === index)?_c('span',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Data.Name),expression:"item.Data.Name"}],attrs:{"type":"text"},domProps:{"value":(item.Data.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.Data, "Name", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(item.Data.category))]),_vm._v(" "),_c('span',{staticClass:"inputsBox"},[_c('input',{staticClass:"minus",attrs:{"type":"button","value":"-"},on:{"click":function($event){return _vm.reduceProduct(item)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Data.Quantity),expression:"item.Data.Quantity"}],staticClass:"stock",attrs:{"type":"text"},domProps:{"value":(item.Data.Quantity)},on:{"change":function($event){return _vm.updateProduct(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item.Data, "Quantity", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"plus",attrs:{"type":"button","value":"+"},on:{"click":function($event){return _vm.increaseProduct(item)}}})]),_vm._v(" "),(_vm.showIndex !== index)?_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(item.Data.Price)+" ש\"ח ")]):_vm._e(),_vm._v(" "),(_vm.showIndex === index)?_c('span',{},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.Data.Price),expression:"item.Data.Price",modifiers:{"number":true}}],attrs:{"type":"number"},domProps:{"value":(item.Data.Price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.Data, "Price", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),_c('span',[_c('button',{on:{"click":function($event){return _vm.deleteItem(item, index)}}},[_vm._v(" x מחק ")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.editProductData(index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")]),_vm._v(" עריכה ")]),_vm._v(" "),(_vm.showIndex === index)?_c('button',{on:{"click":function($event){return _vm.editProduct(item, index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("done")]),_vm._v(" שמור ")]):_vm._e()])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mehTitle"},[_c('h1',[_vm._v("הוספת מוצר ומחירון")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productsCategories"},[_c('span',[_vm._v("שם המוצר")]),_vm._v(" "),_c('span',[_vm._v("קטגוריה")]),_vm._v(" "),_c('span',[_vm._v("כמות במלאי")]),_vm._v(" "),_c('span',[_vm._v("מחיר")]),_vm._v(" "),_c('span',[_vm._v("כלים")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suppliers_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c6c9a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suppliers_vue__ = __webpack_require__(655);
function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c6c9a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suppliersContainer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"section"},_vm._l((_vm.Dealers),function(dealer,index){return _c('div',{key:index,staticClass:"supplier-box"},[_c('div',{staticClass:"supplier-head"},[_c('span',[_vm._v(_vm._s(dealer.Data.selectDealerName))]),_vm._v(" "),_c('button',{on:{"click":_vm.addTestTransaction}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])])]),_vm._v(" "),_c('div',{staticClass:"supplier-body"},[_c('button',{staticClass:"krtest",on:{"click":function($event){return _vm.goToLedger(dealer
                .ID)}}},[_vm._v("כרטסת ספק")])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("רשימת הספקים")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd21a9c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd21a9c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container rounded bg-white mt-5 mb-5"},[_c('div',{staticClass:"wrapper bg-white mt-sm-5"},[_c('h4',{staticClass:"pb-4 border-bottom"},[_vm._v("הגדרות הפרופיל")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-start py-3 border-bottom"},[_c('img',{staticClass:"img",attrs:{"src":_vm.$root.loggedUser.profileImg,"alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"py-2"},[_c('div',{staticClass:"row py-2"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"firstname"}},[_vm._v("שם")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.loggedUser.firstName),expression:"$root.loggedUser.firstName"}],staticClass:"bg-light form-control",attrs:{"type":"text","placeholder":"שם"},domProps:{"value":(_vm.$root.loggedUser.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.loggedUser, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pt-md-0 pt-3"},[_c('label',{attrs:{"for":"lastname"}},[_vm._v("שם המשפחה")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.loggedUser.lastName),expression:"$root.loggedUser.lastName"}],staticClass:"bg-light form-control",attrs:{"type":"text","placeholder":"שם המשפחה"},domProps:{"value":(_vm.$root.loggedUser.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.loggedUser, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6 pt-md-0 pt-3"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("סיסמה")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.loggedUser.password),expression:"$root.loggedUser.password"}],staticClass:"bg-light form-control",attrs:{"type":"password","placeholder":"סיסמה"},domProps:{"value":(_vm.$root.loggedUser.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$root.loggedUser, "password", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row py-2"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"country"}},[_vm._v("תפקיד")]),_vm._v(" "),_c('select',{staticClass:"bg-light",attrs:{"name":"country","id":"country"}},[_c('option',{attrs:{"selected":""},domProps:{"value":_vm.$root.loggedUser.Type}},[_vm._v(_vm._s(_vm.$root.loggedUser.Type))]),_vm._v(" "),_c('option',{attrs:{"value":"usa"}},[_vm._v("USA")]),_vm._v(" "),_c('option',{attrs:{"value":"uk"}},[_vm._v("UK")]),_vm._v(" "),_c('option',{attrs:{"value":"uae"}},[_vm._v("UAE")])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-sm-4 pl-2",attrs:{"id":"img-section"}},[_c('b',[_vm._v("תמונת הפרופיל")]),_vm._v(" "),_c('p',[_vm._v("Accepted file type .png. Less than 1MB")]),_vm._v(" "),_c('button',{staticClass:"btn button border"},[_c('b',[_vm._v("העלאה")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"email"}},[_vm._v("דואר אלקטרוני")]),_vm._v(" "),_c('input',{staticClass:"bg-light form-control",attrs:{"type":"text","placeholder":"example@mail.com"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 pb-4 border-bottom"},[_c('button',{staticClass:"btn btn-primary mr-3"},[_vm._v("Save Changes")]),_vm._v(" "),_c('button',{staticClass:"btn border button"},[_vm._v("Cancel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex align-items-center pt-3",attrs:{"id":"deactivate"}},[_c('div',[_c('b',[_vm._v("Deactivate your account")]),_vm._v(" "),_c('p',[_vm._v("Details about your company account and password")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('button',{staticClass:"btn danger"},[_vm._v("Deactivate")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Media_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bb06e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Media_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Media_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bb06e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Media_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media"},[_c('div',{staticClass:"pageHeader"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"searchData"},[_c('div',{staticClass:"searchBox"},[_c('i',{staticClass:"material-icons"},[_vm._v("search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חיפוש לפי שם או מספר טלפון"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"imagesCollection"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"imgCard"},[_c('img',{attrs:{"src":image.Data.image}}),_vm._v(" "),_c('div',{staticClass:"details"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(image.Data.fullname))]),_vm._v(" "),_c('span',{staticClass:"orderNumber"},[_vm._v("#"+_vm._s(image.Data.orderNumber))])]),_vm._v(" "),_c('div',{staticClass:"created"},[_c('i',{staticClass:"material-icons"},[_vm._v("calendar_month")]),_vm._v(" "),_c('span',{staticClass:"createdDate"},[_vm._v(_vm._s(image.Data.date))])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageTitle"},[_c('span',{staticClass:"pageTitleText"},[_vm._v("דף המדיה")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trash_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ab9c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trash_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ab9c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trash"},_vm._l((_vm.orders),function(order,index){return _c('orderCard',{key:index,attrs:{"id":order.ID,"order":order,"orderIndex":index}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cheques_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e818d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cheques_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64e818d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cheques_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e818d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cheques_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cheques-page",attrs:{"dir":"rtl"}},[_c('header',{staticClass:"page-header"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"primary-btn",on:{"click":function($event){_vm.showAddForm = !_vm.showAddForm}}},[_vm._v("\n        "+_vm._s(_vm.showAddForm ? 'ביטול' : '+ הוספת שיק')+"\n      ")])]),_vm._v(" "),(_vm.showAddForm)?_c('section',{staticClass:"add-panel"},[_c('h2',[_vm._v("הוספת שיק חדש")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addCheque.apply(null, arguments)}}},[_c('div',{staticClass:"form-grid"},[_c('label',[_vm._v("\n            שם הספק / החברה\n            "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newCheque.dealerName),expression:"newCheque.dealerName",modifiers:{"trim":true}}],attrs:{"required":"","maxlength":"150","placeholder":"שם הספק"},domProps:{"value":(_vm.newCheque.dealerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCheque, "dealerName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('label',[_vm._v("\n            סכום השיק (₪)\n            "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newCheque.amount),expression:"newCheque.amount",modifiers:{"number":true}}],attrs:{"type":"number","min":"0.01","step":"0.01","required":""},domProps:{"value":(_vm.newCheque.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCheque, "amount", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('label',[_vm._v("\n            תאריך השיק\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCheque.date),expression:"newCheque.date"}],attrs:{"type":"date","required":""},domProps:{"value":(_vm.newCheque.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCheque, "date", $event.target.value)}}})]),_vm._v(" "),_c('label',[_vm._v("\n            בנק\n            "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCheque.bank),expression:"newCheque.bank"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newCheque, "bank", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("לא צוין")]),_vm._v(" "),_c('option',{attrs:{"value":"leumi"}},[_vm._v("בנק לאומי")]),_vm._v(" "),_c('option',{attrs:{"value":"discount"}},[_vm._v("בנק דיסקונט")])])]),_vm._v(" "),_c('label',{staticClass:"full-width"},[_vm._v("\n            הערות\n            "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newCheque.notes),expression:"newCheque.notes",modifiers:{"trim":true}}],attrs:{"placeholder":"הערות (לא חובה)"},domProps:{"value":(_vm.newCheque.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCheque, "notes", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),(_vm.formError)?_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"primary-btn",attrs:{"type":"submit","disabled":_vm.saving}},[_vm._v("\n          "+_vm._s(_vm.saving ? 'שומר...' : 'שמירת השיק')+"\n        ")])])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"month-panel"},[_c('button',{staticClass:"month-arrow",attrs:{"aria-label":"החודש הקודם"},on:{"click":function($event){return _vm.changeMonth(-1)}}},[_vm._v("\n        ‹\n      ")]),_vm._v(" "),_c('div',{staticClass:"month-label"},[_vm._v(_vm._s(_vm.selectedMonthLabel))]),_vm._v(" "),_c('button',{staticClass:"month-arrow",attrs:{"aria-label":"החודש הבא"},on:{"click":function($event){return _vm.changeMonth(1)}}},[_vm._v("\n        ›\n      ")]),_vm._v(" "),_c('button',{staticClass:"today-btn",on:{"click":_vm.goToCurrentMonth}},[_vm._v("החודש הנוכחי")])]),_vm._v(" "),_c('section',{staticClass:"stats-grid"},[_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon blue-icon"},[_vm._v("₪")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("סך כל השיקים")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.totalAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stats.totalCount)+" שיקים")])])]),_vm._v(" "),_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon orange-icon"},[_vm._v("◷")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("ממתינים למשיכה")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.pendingAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stats.pendingCount)+" שיקים")])])]),_vm._v(" "),_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon green-icon"},[_vm._v("✓")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("שיקים שנמשכו")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.checkedAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stats.checkedCount)+" שיקים")])])]),_vm._v(" "),_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon blue-icon"},[_vm._v("₪")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("סכום שיקים - בנק לאומי")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.leumiAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stats.leumiCount)+" שיקים")])])]),_vm._v(" "),_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon green-icon"},[_vm._v("₪")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("סכום שיקים - בנק דיסקונט")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.discountAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stats.discountCount)+" שיקים")])])]),_vm._v(" "),_c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-icon purple-icon"},[_vm._v("∑")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("ממוצע לשיק")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.formatAmount(_vm.stats.averageAmount))+" ₪")]),_vm._v(" "),_c('small',[_vm._v("לפי החודש הנבחר")])])])]),_vm._v(" "),_c('section',{staticClass:"list-panel"},[_c('div',{staticClass:"list-header"},[_c('div',[_c('h2',[_vm._v("רשימת השיקים")]),_vm._v(" "),_c('p',[_vm._v("השיקים לחודש "+_vm._s(_vm.selectedMonthLabel))])]),_vm._v(" "),_c('button',{staticClass:"refresh-btn",attrs:{"disabled":_vm.loading},on:{"click":_vm.fetchChecksForMonth}},[_vm._v("\n          "+_vm._s(_vm.loading ? 'טוען...' : 'רענון')+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"filters"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.searchQuery),expression:"searchQuery",modifiers:{"trim":true}}],attrs:{"type":"search","placeholder":"חיפוש לפי ספק או סכום..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bankFilter),expression:"bankFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bankFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("כל הבנקים")]),_vm._v(" "),_c('option',{attrs:{"value":"leumi"}},[_vm._v("בנק לאומי")]),_vm._v(" "),_c('option',{attrs:{"value":"discount"}},[_vm._v("בנק דיסקונט")]),_vm._v(" "),_c('option',{attrs:{"value":"unknown"}},[_vm._v("בנק לא צוין")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("כל המצבים")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("ממתינים למשיכה")]),_vm._v(" "),_c('option',{attrs:{"value":"checked"}},[_vm._v("נמשכו")])])]),_vm._v(" "),(_vm.pageError)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.pageError))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"empty-state"},[_vm._v("טוען שיקים...")]):(_vm.filteredChecks.length === 0)?_c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-icon"},[_vm._v("₪")]),_vm._v(" "),_c('h3',[_vm._v("לא נמצאו שיקים")]),_vm._v(" "),_c('p',[_vm._v("לא נמצאו שיקים התואמים לחיפוש ולסינון שבחרת.")])]):_c('div',{staticClass:"cheques-grid"},_vm._l((_vm.filteredChecks),function(cheque){return _c('article',{key:cheque.id,staticClass:"cheque-card",class:[_vm.bankClass(cheque.bank), { 'is-checked': cheque.checked }]},[_c('div',{staticClass:"cheque-top"},[_c('span',{staticClass:"bank-badge"},[_vm._v(_vm._s(_vm.bankLabel(cheque.bank)))]),_vm._v(" "),_c('span',{staticClass:"status-badge",class:cheque.checked ? 'status-done' : 'status-pending'},[_vm._v("\n              "+_vm._s(cheque.checked ? 'נמשך' : 'ממתין למשיכה')+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"cheque-amount"},[_c('span',[_vm._v("סכום השיק")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatAmount(cheque.amount))+" ₪")])]),_vm._v(" "),_c('div',{staticClass:"cheque-divider"}),_vm._v(" "),_c('div',{staticClass:"cheque-details"},[_c('div',[_c('span',[_vm._v("ספק / חברה")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(cheque.dealerName || 'לא צוין'))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("תאריך השיק")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(cheque.date))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("תאריך הוספה")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(cheque.createdDate || '—'))])]),_vm._v(" "),(cheque.notes)?_c('div',[_c('span',[_vm._v("הערות")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(cheque.notes))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cheque-actions"},[_c('label',{staticClass:"status-toggle"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.updatingIds.indexOf(cheque.id) !== -1},domProps:{"checked":!!cheque.checked},on:{"change":function($event){return _vm.toggleCheque(cheque)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cheque.checked ? 'סמן כממתין' : 'סמן כנמשך'))])]),_vm._v(" "),_c('button',{staticClass:"delete-btn",attrs:{"disabled":_vm.deletingIds.indexOf(cheque.id) !== -1},on:{"click":function($event){return _vm.deleteDealer(cheque)}}},[_vm._v("\n              "+_vm._s(_vm.deletingIds.indexOf(cheque.id) !== -1 ? 'מוחק...' : 'מחיקה')+"\n            ")])])])}),0),_vm._v(" "),(!_vm.loading && _vm.filteredChecks.length)?_c('div',{staticClass:"list-footer"},[_vm._v("\n        מוצגים "+_vm._s(_vm.filteredChecks.length)+" מתוך "+_vm._s(_vm.checks.length)+" שיקים\n      ")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("ניהול שיקים")]),_vm._v(" "),_c('p',[_vm._v("ניהול ומעקב אחר שיקים לספקים")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chequesBeta_vue__ = __webpack_require__(364);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660165ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chequesBeta_vue__ = __webpack_require__(675);
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chequesBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660165ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chequesBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckList_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636600e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckList_vue__ = __webpack_require__(674);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636600e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("اختر شهرًا لعرض الشيكات:")]),_vm._v(" "),_c('div',{staticClass:"slider-container"},[_c('button',{staticClass:"slider-btn",on:{"click":_vm.prevSlide}},[_vm._v("❮")]),_vm._v(" "),_c('div',{ref:"slider",staticClass:"slider"},_vm._l((_vm.monthsList),function(month,index){return _c('div',{key:index,staticClass:"month",class:{'selected-month': _vm.selectedMonth === month},on:{"click":function($event){return _vm.fetchChecksForMonth(month)}}},[_vm._v("\n        "+_vm._s(_vm.formatISODateWithMonth(month))+"\n      ")])}),0),_vm._v(" "),_c('button',{staticClass:"slider-btn",on:{"click":_vm.nextSlide}},[_vm._v("❯")])]),_vm._v(" "),_c('h3',[_vm._v("الشيكات لشهر: "+_vm._s(_vm.selectedMonth ? _vm.formatISODateWithMonth(_vm.selectedMonth) : 'لم يتم الاختيار بعد'))]),_vm._v(" "),_c('ul',_vm._l((_vm.checks),function(check){return _c('li',{key:check.id},[_vm._v("\n      "+_vm._s(check.amount)+" - "+_vm._s(_vm.formatDate(check.date))+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CheckList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa81e926_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa81e926_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports-section"},[_c('div',{staticClass:"reports-header"},[_c('h3',[_vm._v("סיכום חודשי")]),_vm._v(" "),_c('p',[_vm._v("תצוגה מרוכזת של נתוני החודש")])]),_vm._v(" "),_c('div',{staticClass:"reports-body"},[_c('div',{staticClass:"static-box"},[_c('button',[_vm._v("+")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685fef9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685fef9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suppliersContainer"},[_c('div',{staticClass:"pageHeader"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"topLine"},[_c('ul',[_c('li',{class:[_vm.yesterdayItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.yesterdayOrders()}}},[_vm._v("אתמול")])]),_vm._v(" "),_c('li',{class:[_vm.todayItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.todayOrders()}}},[_vm._v("היום")])]),_vm._v(" "),_c('li',{class:[_vm.tommorowItemNav == true ? 'activeItem' : '']},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.tommorowOrders()}}},[_vm._v("מחר")])])])])]),_vm._v(" "),_c('div',{staticClass:"suppliers"},[_vm._m(1),_vm._v(" "),_c('table',[_vm._m(2),_vm._v(" "),_vm._l((_vm.$root.Expenses),function(expense,index){return _c('tr',{key:index,attrs:{"id":expense.ID}},[_c('td',[_c('div',{staticClass:"checkboxes__item"},[_c('label',{staticClass:"checkbox style-c"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":expense.checked},on:{"change":function($event){return _vm.checkLine(expense.ID)}}}),_vm._v(" "),_c('div',{staticClass:"checkbox__checkmark"})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(expense.dealerName))]),_vm._v(" "),_c('td',[_vm._v("₪"+_vm._s(expense.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(expense.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(expense.createdDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(expense.note))]),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_c('td',[_c('button',{on:{"click":function($event){return _vm.deleteDealer(expense)}}},[_vm._v("X")])])])}),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("סך הכל")]),_vm._v(" "),_c('td',[_vm._v("₪"+_vm._s(_vm.$root.totalExpenses))])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageTitle"},[_c('span',{staticClass:"pageTitleText"},[_vm._v("דף ההוצאות")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("credit_score")])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("רשימת השיקים")]),_vm._v(" "),_c('div',{staticClass:"searchDiv"},[_c('input',{attrs:{"type":"text","placeholder":"חיפוש שיקים"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("שם הספק \\ החברה")]),_vm._v(" "),_c('th',[_vm._v("סכום")]),_vm._v(" "),_c('th',[_vm._v("ת\"פ")]),_vm._v(" "),_c('th',[_vm._v("תאריך ההוספה למערכת")]),_vm._v(" "),_c('th',[_vm._v("הערה")]),_vm._v(" "),_c('th',[_vm._v("מסמכים")]),_vm._v(" "),_c('th',[_vm._v("כלים")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',[_vm._v("צפייה במסמך")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4167de93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4167de93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4167de93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createOrder"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("יצירת הזמנה חדשה")]),_vm._v(" "),_c('span',{staticClass:"orderNum"},[_vm._v("#"+_vm._s(_vm.counter.orderNumber))])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"right-box"},[_c('div',{staticClass:"personal-details"},[_c('span',{staticClass:"title"},[_vm._v("פרטי לקוח")]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" שם מלא")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullname),expression:"fullname"}],attrs:{"type":"text","placeholder":"שם מלא "},domProps:{"value":(_vm.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" מספר הטלפון")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],attrs:{"type":"number","placeholder":"מספר הטלפון "},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"personal-details"},[_c('span',{staticClass:"title"},[_vm._v("פרטי הזמנה")]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" תאריך")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateOrder),expression:"dateOrder"}],attrs:{"type":"date"},domProps:{"value":(_vm.dateOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateOrder=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" יום")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dayOrder),expression:"dayOrder"}],staticClass:"col-3",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dayOrder=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר יום")]),_vm._v(" "),_c('option',{attrs:{"value":"ראשון"}},[_vm._v("ראשון")]),_vm._v(" "),_c('option',{attrs:{"value":"שני "}},[_vm._v("שני")]),_vm._v(" "),_c('option',{attrs:{"value":"שלישי"}},[_vm._v("שלישי")]),_vm._v(" "),_c('option',{attrs:{"value":"רביעי"}},[_vm._v("רביעי")]),_vm._v(" "),_c('option',{attrs:{"value":"חמישי"}},[_vm._v("חמישי ")]),_vm._v(" "),_c('option',{attrs:{"value":"שישי"}},[_vm._v("שישי")]),_vm._v(" "),_c('option',{attrs:{"value":"שבת"}},[_vm._v("שבת")])])]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('label',[_vm._v(" שעה")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeOrder),expression:"timeOrder"}],staticClass:"col-3",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timeOrder=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("בחר שעה")]),_vm._v(" "),_c('option',{attrs:{"value":"09:00"}},[_vm._v("09:00")]),_vm._v(" "),_c('option',{attrs:{"value":"09:30"}},[_vm._v("09:30")]),_vm._v(" "),_c('option',{attrs:{"value":"10:00"}},[_vm._v("10:00")]),_vm._v(" "),_c('option',{attrs:{"value":"10:30"}},[_vm._v("10:30")]),_vm._v(" "),_c('option',{attrs:{"value":"11:00"}},[_vm._v("11:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"11:30"}},[_vm._v("11:30")]),_vm._v(" "),_c('option',{attrs:{"value":"12:00"}},[_vm._v("12:00")]),_vm._v(" "),_c('option',{attrs:{"value":"12:30"}},[_vm._v("12:30")]),_vm._v(" "),_c('option',{attrs:{"value":"13:00"}},[_vm._v("13:00")]),_vm._v(" "),_c('option',{attrs:{"value":"13:30"}},[_vm._v("13:30")]),_vm._v(" "),_c('option',{attrs:{"value":"14:00"}},[_vm._v("14:00")]),_vm._v(" "),_c('option',{attrs:{"value":"14:30"}},[_vm._v("14:30 ")]),_vm._v(" "),_c('option',{attrs:{"value":"15:00"}},[_vm._v("15:00")]),_vm._v(" "),_c('option',{attrs:{"value":"15:30"}},[_vm._v("15:30")]),_vm._v(" "),_c('option',{attrs:{"value":"16:00"}},[_vm._v("16:00")]),_vm._v(" "),_c('option',{attrs:{"value":"16:30"}},[_vm._v("16:30")]),_vm._v(" "),_c('option',{attrs:{"value":"17:00"}},[_vm._v("17:00")]),_vm._v(" "),_c('option',{attrs:{"value":"17:30"}},[_vm._v("17:30")]),_vm._v(" "),_c('option',{attrs:{"value":"18:00"}},[_vm._v("18:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"18:30"}},[_vm._v("18:30")]),_vm._v(" "),_c('option',{attrs:{"value":"19:00"}},[_vm._v("19:00")]),_vm._v(" "),_c('option',{attrs:{"value":"19:30"}},[_vm._v("19:30")]),_vm._v(" "),_c('option',{attrs:{"value":"20:00"}},[_vm._v("20:00")]),_vm._v(" "),_c('option',{attrs:{"value":"20:30"}},[_vm._v("20:30")]),_vm._v(" "),_c('option',{attrs:{"value":"21:00"}},[_vm._v("21:00 ")]),_vm._v(" "),_c('option',{attrs:{"value":"21:30"}},[_vm._v("21:30")])])])])]),_vm._v(" "),_c('div',{staticClass:"personal-details"},[_c('span',{staticClass:"title"},[_vm._v("הוספת מוצרים לסל הקניות ")]),_vm._v(" "),_c('div',{staticClass:"categories"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collection"},[_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadProductsToOrder()}}},[_c('span',[_vm._v("עוגות מרובעות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadCircleCakes()}}},[_c('span',[_vm._v("עוגות עגולות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBiscuit()}}},[_c('span',[_vm._v("עוגיות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadPasim()}}},[_c('span',[_vm._v("פסים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadCoufsaot()}}},[_c('span',[_vm._v("קופסאות")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadMghashim()}}},[_c('span',[_vm._v("מגשים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadOneUse()}}},[_c('span',[_vm._v("חד פעמי")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadDrinks()}}},[_c('span',[_vm._v("שתיה")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadHataifim()}}},[_c('span',[_vm._v("חטיפים")])]),_vm._v(" "),_c('div',{staticClass:"category",on:{"click":function($event){return _vm.loadBakingCakes()}}},[_c('span',[_vm._v("שמרים")])])])]),_vm._v(" "),(_vm.activeProductsBar == 1)?_c('div',{staticClass:"categories"},[_c('div',{staticClass:"catHeader"},[_c('span',[_vm._v("בחר מוצרים")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.txtSearch),expression:"txtSearch"}],attrs:{"type":"text","placeholder":"חפש מוצר"},domProps:{"value":(_vm.txtSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.txtSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"collection"},_vm._l((_vm.filteredProducts),function(item){return _c('div',{staticClass:"product",on:{"click":function($event){return _vm.addToCart(item)}}},[_c('span',{staticClass:"productName"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"productPrice"},[_vm._v("₪"+_vm._s(item.Data.Price))])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"personal-details"},[_c('span',{staticClass:"title"},[_vm._v("העלאת תמונות")]),_vm._v(" "),_c('div',{staticClass:"input-field-beta"},[_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.uploadImage}})])]),_vm._v(" "),_c('div',{staticClass:"personal-details"},[_c('span',{staticClass:"title"},[_vm._v("פרטי תשלום")]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"noteField"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],attrs:{"placeholder":"הערה \\ ملاحظة"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"paymentDiv"},[_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"cash","value":"שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"שולם")},on:{"change":function($event){_vm.paidStatus="שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("price_check")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("שולם")])]),_vm._v(" "),_c('div',{staticClass:"selectPayment"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paidStatus),expression:"paidStatus"}],attrs:{"type":"radio","id":"creditCard","value":"לא שולם","required":""},domProps:{"checked":_vm._q(_vm.paidStatus,"לא שולם")},on:{"change":function($event){_vm.paidStatus="לא שולם"}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("money_off")]),_vm._v(" "),_c('span',{staticClass:"paymentText"},[_vm._v("לא שולם")])])])])]),_vm._v(" "),_c('div',{staticClass:"left-box"},[_c('div',{staticClass:"shopping-cart"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cart-list"},[_c('span',[_vm._v("מוצרים")]),_vm._v(" "),(this.cart.length <= 0)?_c('div',{staticStyle:{"text-align":"center","padding":"70px"}},[_vm._v(" \n                        אין מוצרים בסל הקניות\n                    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.cart),function(product,index){return _c('div',{key:index,staticClass:"ProductLine"},[_c('span',{staticClass:"selectedQuantity"},[_vm._v(" x"+_vm._s(product.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(product.Data.Name)+" ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(" ₪"+_vm._s(product.Data.Price * product.selectedCount)+" ")]),_vm._v(" "),_c('div',{staticClass:"tools"},[_c('ul',[_c('li',{staticClass:"removeBtn",on:{"click":function($event){return _vm.removeItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("clear")])]),_vm._v(" "),_c('li',{staticClass:"increaseBtn",on:{"click":function($event){return _vm.addToCart(product)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('li',{staticClass:"reduceBtn",on:{"click":function($event){return _vm.reduceItem(product,index)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("remove")])])])])])})],2),_vm._v(" "),_c('div',{staticClass:"cart-summary"},[_c('span',[_vm._v("סיכום הזמנה")]),_vm._v(" "),_c('div',{staticClass:"totalPrice"},[_c('div',{staticClass:"discountLabel"},[_c('label',[_vm._v("הנחה \\ שולם חלקי")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.discount),expression:"discount",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"הנחה"},domProps:{"value":(_vm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.discount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("סה\"כ לתשלום")]),_vm._v(" "),_c('span',{staticClass:"total"},[_vm._v(" ₪"+_vm._s(_vm.totalOrderPrice - _vm.discount))])])]),_vm._v(" "),_c('div',{staticClass:"cart-submit"},[_c('button',{on:{"click":function($event){return _vm.sendOrder()}}},[_vm._v("שליחת הזמנה")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catHeader"},[_c('span',[_vm._v("בחר קטגוריה")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-title"},[_c('span',[_vm._v("סל הקניות")]),_vm._v(" "),_c('button',{staticClass:"custom-product"},[_vm._v("מוצר כללי +")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printOrder_vue__ = __webpack_require__(369);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f062603a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printOrder_vue__ = __webpack_require__(687);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f062603a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{attrs:{"id":this.selectedorderID}},[_c('div',{staticClass:"card",class:[_vm.orderOBJ.status == 'בוטלה' ? 'canceledOrder' : 'card',  _vm.orderOBJ.status == 'מוכנה' ? 'orderReady' : 'card', _vm.orderOBJ.status == 'נמסרה' ? 'confirmed' : 'card' ]},[_c('div',{staticClass:"head"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.orderOBJ.fullname))]),_vm._v(" "),_c('span',{staticClass:"orderNumber"},[_vm._v("#"+_vm._s(_vm.orderOBJ.orderNumber))]),_vm._v(" "),_c('span',{staticClass:"status"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderOBJ.status),expression:"orderOBJ.status"}],class:[_vm.orderOBJ.status == 'בוטלה' ? 'canceledBadge' : 'select',
                     _vm.orderOBJ.status == 'מוכנה' ? 'readyBadge' : 'select',
                     _vm.orderOBJ.status == 'נמסרה' ? 'shippedBadge' : 'select',
                     _vm.orderOBJ.status == 'התקבלה' ? 'acceptBadge' : 'select' ],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orderOBJ, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateStatus()}]}},[_c('option',{attrs:{"value":"מוכנה"}},[_vm._v("מוכנה")]),_vm._v(" "),_c('option',{attrs:{"value":"שלב הכנה"}},[_vm._v("שלב הכנה")]),_vm._v(" "),_c('option',{attrs:{"value":"בוטלה"}},[_vm._v("בוטלה")]),_vm._v(" "),_c('option',{attrs:{"value":"התקבלה"}},[_vm._v("התקבלה")]),_vm._v(" "),_c('option',{attrs:{"value":"נמסרה"}},[_vm._v("נמסרה")])])])]),_vm._v(" "),_c('div',{staticClass:"head"},[_c('span',{staticClass:"day"},[_vm._v("יום "+_vm._s(_vm.orderOBJ.dayOrder))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.orderOBJ.timeOrder))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("\r\n                "+_vm._s(_vm.orderOBJ.dateOrder)+"\r\n            ")])]),_vm._v(" "),_c('div',{staticClass:"orderCart"},[_c('span',{staticClass:"title",on:{"click":function($event){return _vm.printDiv(_vm.order.ID)}}},[_vm._v("הדפס")]),_vm._v(" "),_vm._l((_vm.orderOBJ.cart),function(item){return _c('div',{staticClass:"item"},[_c('span',{staticClass:"selectedquantity"},[_vm._v("x"+_vm._s(item.selectedCount))]),_vm._v(" "),_c('span',{staticClass:"itemName"},[_vm._v(_vm._s(item.Data.Name))]),_vm._v(" "),_c('span',{staticClass:"subTotal"},[_vm._v("₪"+_vm._s(item.Data.Price * item.selectedCount))])])}),_vm._v(" "),(_vm.orderOBJ.note.length > 0)?_c('div',{staticClass:"note"},[_c('span',[_vm._v(_vm._s(_vm.orderOBJ.note))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"images"},_vm._l((_vm.orderOBJ.orderImg),function(img,index){return _c('div',{key:index},[_c('img',{attrs:{"src":img,"alt":""}})])}),0)],2),_vm._v(" "),_c('div',{staticClass:"flex"}),_vm._v(" "),_c('div',{staticClass:"footerCard"},[_c('div',{staticClass:"col3"},[_c('span',{staticClass:"totalTitle"},[_vm._v("\r\n                סטטוס גבייה \r\n                ")]),_vm._v(" "),_c('span',{staticClass:"totalAmount",class:[_vm.orderOBJ.paidStatus == 'שולם' ? 'paid' : 'totalAmount' , _vm.orderOBJ.paidStatus == 'לא שולם' ? 'unPaid' : 'totalAmount'  ]},[_vm._v("\r\n                    \r\n                    "+_vm._s(_vm.orderOBJ.paidStatus)+"\r\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col3"},[_c('span',{staticClass:"totalTitle"},[_vm._v("\r\n                סה\"כ לתשלום \r\n                ")]),_vm._v(" "),_c('span',{staticClass:"totalAmount"},[_vm._v("\r\n                    ₪"+_vm._s(_vm.orderOBJ.totalOrderPrice -  _vm.orderOBJ.discount)+"\r\n                ")])])])])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setupVersionListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(74);
// تأكد من أنك قمت بتهيئة Firebase مسبقًا في مشروعك



function setupVersionListener() {
  var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore();

  // المرجع لمستند الإصدار في Firestore
  var versionDocRef = db.collection('appUpdates').doc('version');

  versionDocRef.onSnapshot(function (doc) {
    if (!doc.exists) {
      console.error('مستند الإصدار غير موجود!');
      return;
    }

    // قراءة قيمة الإصدار من Firestore
    var serverVersion = doc.data().version;

    // قراءة الإصدار المحلي المخزن في localStorage (افتراضيًا "1.0.0" إذا لم يكن موجود)
    var localVersion = localStorage.getItem('appVersion') || '1.0.0';

    console.log('\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u062D\u0644\u064A: ' + localVersion + ' - \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0639\u0644\u0649 \u0627\u0644\u0633\u064A\u0631\u0641\u0631: ' + serverVersion);

    // إذا كانت قيمة الإصدار مختلفة، فهذا يعني أنه تم نشر تحديث جديد
    if (serverVersion !== localVersion) {
      // تحديث الإصدار المخزن محليًا
      localStorage.setItem('appVersion', serverVersion);
      console.log('تم الكشف عن إصدار جديد! جاري إعادة تحميل الصفحة...');
      // إعادة تحميل الصفحة لجلب النسخة الجديدة
      window.location.reload();
    }
  }, function (error) {
    console.error('خطأ في مراقبة مستند الإصدار:', error);
  });
}

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[516]);


// WEBPACK FOOTER //
// static/js/app.eb55580ff1f55a8b2e78.js